
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("c4rGD", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $d35d149b3c4e76b2$export$9923361bd43fa030);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $55pTl = parcelRequire("55pTl");

var $ltfxy = parcelRequire("ltfxy");

var $ceJvc = parcelRequire("ceJvc");

var $77gCP = parcelRequire("77gCP");

var $gd0Sp = parcelRequire("gd0Sp");
var $4xHig = parcelRequire("4xHig");

var $k09VB = parcelRequire("k09VB");

const $d35d149b3c4e76b2$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: 'jira',
    locale: 'en'
};
const $d35d149b3c4e76b2$export$9923361bd43fa030 = ({ AtlassianSwitcherIntegration: AtlassianSwitcherIntegration = (0, $77gCP.AtlassianSwitcherIntegration), isOpen: isOpen, onClose: onClose, onOpen: onOpen, IntegrationViewRenderer: IntegrationViewRenderer = (0, $ceJvc.PopupIntegrationDI), SpotlightTarget: SpotlightTarget = (0, $ltfxy.default), TenantContextSubscriber: TenantContextSubscriber = (0, $gd0Sp.TenantContextSubscriber), useLocale: useLocale = (0, $4xHig.useLocale) })=>{
    const locale = useLocale();
    const postOfficeContextData = (0, $eUqFw.useMemo)(()=>({
            ...$d35d149b3c4e76b2$var$DEFAULT_POST_OFFICE_CONTEXT,
            locale: locale
        }), [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k09VB.PostOfficeContextProvider), {
        value: postOfficeContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SpotlightTarget, {
        name: (0, $ecbb977aece36a74$export$381faf5821ba1c1f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AtlassianSwitcherIntegration, {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onCloseComplete: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        TenantContextSubscriber: TenantContextSubscriber,
        IntegrationViewRenderer: IntegrationViewRenderer
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: (0, $ecbb977aece36a74$export$381faf5821ba1c1f)
    })));
};
var $d35d149b3c4e76b2$export$2e2bcd8739ae039 = $d35d149b3c4e76b2$export$9923361bd43fa030;

});
parcelRegister("ceJvc", function(module, exports) {

$parcel$export(module.exports, "PopupIntegrationDI", () => $2e24468cd3aa139f$export$deca5e1c99d6f8fe);

var $69VVg = parcelRequire("69VVg");
const $2e24468cd3aa139f$export$deca5e1c99d6f8fe = ({ IntegrationPopup: IntegrationPopup = (0, $69VVg.IntegrationPopup), ...props })=>props.children({
        IntegrationView: IntegrationPopup,
        atlassianSwitcherCustomizationProps: {
            appearance: 'standalone'
        }
    });

});
parcelRegister("69VVg", function(module, exports) {

$parcel$export(module.exports, "IntegrationPopup", () => $fb9c17e6bfee2285$export$a50b842ca832255d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $eYynb = parcelRequire("eYynb");

var $3MV1G = parcelRequire("3MV1G");

var $kwMhr = parcelRequire("kwMhr");
var $9EHc8 = parcelRequire("9EHc8");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $7JTqr = parcelRequire("7JTqr");

var $gd0Sp = parcelRequire("gd0Sp");

var $hKQEQ = parcelRequire("hKQEQ");
var $e2Wjq = parcelRequire("e2Wjq");

var $2kDND = parcelRequire("2kDND");

var $eSDUj = parcelRequire("eSDUj");

var $gATOG = parcelRequire("gATOG");
const $fb9c17e6bfee2285$var$JIRA_PRODUCT = 'jira';
const $fb9c17e6bfee2285$export$a50b842ca832255d = ({ Popup: Popup = (0, $3MV1G.default), AppSwitcher: AppSwitcher = (0, $eYynb.AppSwitcher), useTenantContext: useTenantContext = (0, $gd0Sp.useTenantContext), ViewExperienceTrackingProvider: ViewExperienceTrackingProvider = (0, $9EHc8.ViewExperienceTrackingProvider), ViewExperienceSuccessTracker: ViewExperienceSuccessTracker = (0, $kwMhr.ExperienceSuccessTracker), ...popupProps })=>{
    const { cloudId: cloudId } = useTenantContext();
    const { isOpen: isOpen, children: children, Drawer: Drawer, icon: icon, onOpen: onOpen, ...akPopupProps } = popupProps;
    const renderSwitcher = (0, $eUqFw.useCallback)((triggerProps)=>(0, $7JTqr.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eSDUj.default), {
            ...triggerProps,
            isSelected: popupProps.isOpen,
            onClick: ()=>{
                popupProps.isOpen ? popupProps.onClose() : popupProps.onOpen();
            },
            tooltip: (0, $e2Wjq.SwitchToTooltipText)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AppSwitcher, {
            ...triggerProps,
            isSelected: popupProps.isOpen,
            onClick: ()=>{
                popupProps.isOpen ? popupProps.onClose() : popupProps.onOpen();
            },
            tooltip: (0, $e2Wjq.SwitchToTooltipText)
        }), [
        AppSwitcher,
        popupProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Popup, {
        ...akPopupProps,
        isOpen: popupProps.isOpen,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewExperienceTrackingProvider, {
                application: null,
                analyticsSource: "atlassian-navigation",
                experience: "viewAtlassianNavigationMenu",
                experienceId: "atlassianSwitcher",
                edition: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewExperienceSuccessTracker, {
                location: "atlassian-navigation--secondary-actions-app-switcher--menu-popup",
                parentProviders: null,
                failureEventAttributes: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gATOG.StyledSwitcherContainer), null, popupProps.children))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hKQEQ.default), {
                cloudId: cloudId,
                product: $fb9c17e6bfee2285$var$JIRA_PRODUCT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                id: "app-switcher-nudge-tooltip",
                packageName: "jira-atlassian-navigation-switcher-integration",
                render: ()=>renderSwitcher(triggerProps)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2kDND.AppSwitcherNudgeToolTip), {
                cloudId: cloudId
            }, renderSwitcher(triggerProps))))
    }));
};

});
parcelRegister("hKQEQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67746a1797419e2e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $7KV1o = parcelRequire("7KV1o");

var $lC6tE = parcelRequire("lC6tE");

var $j5Yzx = parcelRequire("j5Yzx");
var $dcbVh = parcelRequire("dcbVh");
var $2jDha = parcelRequire("2jDha");

var $mV5nr = parcelRequire("mV5nr");
const $67746a1797419e2e$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $67746a1797419e2e$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $67746a1797419e2e$var$TRIGGER_CONTEXT = {
    componentName: (0, $j5Yzx.TRIGGER_COMPONENT),
    ...(0, $mV5nr.default)
};
class $67746a1797419e2e$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick
        }, children);
    }
    constructor(...args){
        super(...args);
        this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                actionSubject: (0, $j5Yzx.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $j5Yzx.NAVIGATION_CHANNEL));
        };
        this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
            (0, $7KV1o.prefetch)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $67746a1797419e2e$var$THROTTLE_EXPIRES, $67746a1797419e2e$var$THROTTLE_OPTIONS);
        this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $lC6tE.performanceNow)();
        };
        this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $lC6tE.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $67746a1797419e2e$var$PrefetchTriggerWithEvents = (0, $2jDha.default)()($67746a1797419e2e$var$PrefetchTrigger);
var $67746a1797419e2e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcbVh.NavigationAnalyticsContext), {
        data: $67746a1797419e2e$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($67746a1797419e2e$var$PrefetchTriggerWithEvents, props));

});
parcelRegister("7KV1o", function(module, exports) {

$parcel$export(module.exports, "prefetch", () => $cffd4a471309e957$export$f003ab04b0b3c00e);

var $5JBnN = parcelRequire("5JBnN");

var $9rUOT = parcelRequire("9rUOT");

var $lwQen = parcelRequire("lwQen");

var $4f9KR = parcelRequire("4f9KR");
const $cffd4a471309e957$export$f003ab04b0b3c00e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $4f9KR.default)(product);
    (0, $9rUOT.prefetchAvailableProducts)();
    (0, $lwQen.prefetchJoinableSites)(props.joinableSitesDataProvider);
    if (cloudId) (0, $5JBnN.prefetchAll)({
        cloudId: cloudId
    });
};

});
parcelRegister("5JBnN", function(module, exports) {

$parcel$export(module.exports, "emptyCollaborationGraphRecentContainers", () => $60cfea781e017873$export$93ad17821eb580b7);
$parcel$export(module.exports, "CollaborationGraphRecentContainersProvider", () => $60cfea781e017873$export$e2fc3865d31ff15e);
$parcel$export(module.exports, "UserPermissionProvider", () => $60cfea781e017873$export$ea5ef74fdb7fc4f8);
$parcel$export(module.exports, "XFlowSettingsProvider", () => $60cfea781e017873$export$d83aec5120e1e4bc);
$parcel$export(module.exports, "prefetchAll", () => $60cfea781e017873$export$aba5d6cf034db22e);

var $eUqFw = parcelRequire("eUqFw");

var $41qIX = parcelRequire("41qIX");

var $hYg5M = parcelRequire("hYg5M");

var $h5kHR = parcelRequire("h5kHR");

var $biW6x = parcelRequire("biW6x");

var $7NTKJ = parcelRequire("7NTKJ");

var $J5mP3 = parcelRequire("J5mP3");
const $60cfea781e017873$var$fetchCollaborationGraphRecentContainers = ({ cloudId: cloudId })=>(0, $41qIX.postJson)('/gateway/api/collaboration/v1/collaborationgraph/user/container', {
        containerTypes: [
            'confluenceSpace',
            'jiraProject'
        ],
        context: {
            contextType: 'atlassianSwitcher',
            principalId: 'context',
            siteId: cloudId
        },
        expanded: true,
        maxNumberOfResults: 6,
        userId: 'context'
    });
const $60cfea781e017873$var$RealCollaborationGraphRecentContainersProvider = (0, $hYg5M.default)('collaborationGraphRecentContainers', (0, $J5mP3.ExperienceMark).API_COLLABORATION_GRAPH_RECENT_CONTAINERS, $60cfea781e017873$var$fetchCollaborationGraphRecentContainers);
const $60cfea781e017873$export$93ad17821eb580b7 = {
    status: (0, $hYg5M.Status).COMPLETE,
    data: {
        collaborationGraphEntities: []
    }
};
const $60cfea781e017873$export$9b0dd6d5e04c79b7 = {
    status: (0, $hYg5M.Status).COMPLETE,
    data: {
        collaborationGraphEntities: null
    }
};
const $60cfea781e017873$export$e2fc3865d31ff15e = (0, $7NTKJ.default)(({ cloudId: cloudId, enableRecentContainers: enableRecentContainers, children: children })=>{
    if (enableRecentContainers) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($60cfea781e017873$var$RealCollaborationGraphRecentContainersProvider, {
        cloudId: cloudId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children($60cfea781e017873$export$93ad17821eb580b7));
}, $60cfea781e017873$export$93ad17821eb580b7.data);
const $60cfea781e017873$var$fetchPermission = (0, $biW6x.withCached)(({ cloudId: cloudId, permissionId: permissionId })=>(0, $41qIX.postJson)(`/gateway/api/permissions/permitted`, {
        permissionId: permissionId,
        resourceId: `ari:cloud:platform::site/${cloudId}`
    }).then((permission)=>permission.permitted));
const $60cfea781e017873$export$ea5ef74fdb7fc4f8 = (0, $7NTKJ.default)((0, $hYg5M.default)('permission', (0, $J5mP3.ExperienceMark).API_PERMISSIONS, $60cfea781e017873$var$fetchPermission, $60cfea781e017873$var$fetchPermission.cached), false);
const $60cfea781e017873$export$7b5e6d0d1397ff86 = (0, $biW6x.withCached)(({ cloudId: cloudId })=>(0, $41qIX.fetchJson)(`/gateway/api/site/${cloudId}/setting/xflow`).then((xFlowSettings)=>xFlowSettings['product-suggestions-enabled'] !== undefined ? xFlowSettings['product-suggestions-enabled'] : true));
const $60cfea781e017873$export$d83aec5120e1e4bc = (0, $7NTKJ.default)((0, $hYg5M.default)('xflowSettings', (0, $J5mP3.ExperienceMark).API_XFLOW_SETTINGS, $60cfea781e017873$export$7b5e6d0d1397ff86, $60cfea781e017873$export$7b5e6d0d1397ff86.cached), true);
const $60cfea781e017873$export$aba5d6cf034db22e = ({ cloudId: cloudId })=>{
    $60cfea781e017873$export$7b5e6d0d1397ff86({
        cloudId: cloudId
    });
    $60cfea781e017873$var$fetchPermission({
        cloudId: cloudId,
        permissionId: (0, $h5kHR.Permissions).MANAGE
    });
};
const $60cfea781e017873$export$ffe8c06b7e356699 = ()=>{
    $60cfea781e017873$export$7b5e6d0d1397ff86.reset();
    $60cfea781e017873$var$fetchPermission.reset();
};

});
parcelRegister("41qIX", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $520566ad5477ea3d$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $520566ad5477ea3d$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $520566ad5477ea3d$export$c776284ef4b1209a);

var $fv7xM = parcelRequire("fv7xM");

var $dweqP = parcelRequire("dweqP");

var $mV5nr = parcelRequire("mV5nr");
const $520566ad5477ea3d$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $fv7xM.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $520566ad5477ea3d$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $mV5nr.default).packageVersion,
            ...init?.headers
        }
    }).then($520566ad5477ea3d$var$extraJsonFromResponse);
const $520566ad5477ea3d$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $dweqP.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $mV5nr.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($520566ad5477ea3d$var$extraJsonFromResponse);
};
const $520566ad5477ea3d$export$c776284ef4b1209a = (url, data)=>$520566ad5477ea3d$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

});
parcelRegister("fv7xM", function(module, exports) {

$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $4f7f1e8caa12e70b$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $4f7f1e8caa12e70b$export$26e841bcf1aeb894);
const $4f7f1e8caa12e70b$export$83179404a61b001a = 'FetchError';
class $4f7f1e8caa12e70b$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message);
        this.name = $4f7f1e8caa12e70b$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $4f7f1e8caa12e70b$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("dweqP", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $de7a16350838661f$export$1d94629c94e7a17f);
const $de7a16350838661f$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $de7a16350838661f$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $de7a16350838661f$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("mV5nr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99ef955c4f00755$export$2e2bcd8739ae039);
const $b99ef955c4f00755$var$packageName = "platform-pkg";
const $b99ef955c4f00755$var$packageVersion = "0.0.0-use.local";
var $b99ef955c4f00755$export$2e2bcd8739ae039 = {
    packageName: $b99ef955c4f00755$var$packageName,
    packageVersion: $b99ef955c4f00755$var$packageVersion
};

});


parcelRegister("hYg5M", function(module, exports) {

$parcel$export(module.exports, "Status", () => $8419c8ad31c0db62$export$96e9906d6d93a972);
$parcel$export(module.exports, "createResultComplete", () => $8419c8ad31c0db62$export$947ceca65da0e7a6);
$parcel$export(module.exports, "isComplete", () => $8419c8ad31c0db62$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $8419c8ad31c0db62$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "hasLoaded", () => $8419c8ad31c0db62$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $8419c8ad31c0db62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j5Yzx = parcelRequire("j5Yzx");

var $2jDha = parcelRequire("2jDha");

var $iqXt7 = parcelRequire("iqXt7");

var $dweqP = parcelRequire("dweqP");

var $bATRZ = parcelRequire("bATRZ");
const $8419c8ad31c0db62$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $8419c8ad31c0db62$export$96e9906d6d93a972;
(function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
})($8419c8ad31c0db62$export$96e9906d6d93a972 || ($8419c8ad31c0db62$export$96e9906d6d93a972 = {}));
const $8419c8ad31c0db62$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $8419c8ad31c0db62$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $8419c8ad31c0db62$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $8419c8ad31c0db62$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $8419c8ad31c0db62$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $8419c8ad31c0db62$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static{
            this.displayName = `DataProvider(${name})`;
        }
        componentWillUnmount() {
            /**
			 * Promise resolved after component is unmounted to be ignored
			 */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $dweqP.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $iqXt7.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
			 * Do not transition from "complete" state to "error"
			 */ if (this.acceptResults && !$8419c8ad31c0db62$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $iqXt7.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args);
            this.acceptResults = true;
            this.state = getInitialState(this.props.params);
            this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                    actionSubject: $8419c8ad31c0db62$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $j5Yzx.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $2jDha.default)()((0, $bATRZ.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}

});
parcelRegister("j5Yzx", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $421aa4554894e770$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $421aa4554894e770$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $421aa4554894e770$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $421aa4554894e770$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $421aa4554894e770$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $421aa4554894e770$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $421aa4554894e770$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $421aa4554894e770$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $421aa4554894e770$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $421aa4554894e770$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $421aa4554894e770$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $421aa4554894e770$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_NAME_EXPAND_PANEL", () => $421aa4554894e770$export$53f2256589c0fa08);
$parcel$export(module.exports, "SWITCHER_CURRENT_ORG", () => $421aa4554894e770$export$44c7ac3fdc1d62b8);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $421aa4554894e770$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $421aa4554894e770$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $421aa4554894e770$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $421aa4554894e770$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $421aa4554894e770$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $421aa4554894e770$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $421aa4554894e770$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $421aa4554894e770$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $421aa4554894e770$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "ImageLoadedTracker", () => $421aa4554894e770$export$7609fab79cf145a0);
$parcel$export(module.exports, "getJoinableSitesRenderTracker", () => $421aa4554894e770$export$e823e937102b322b);
$parcel$export(module.exports, "getDiscoverSectionRenderTracker", () => $421aa4554894e770$export$eff0211e47c4d541);
$parcel$export(module.exports, "getRecentContainersRenderTracker", () => $421aa4554894e770$export$92f66a8a67c9c3ce);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $421aa4554894e770$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $421aa4554894e770$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("2jDha")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("dcbVh")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $662e33bb7444ae33$export$12346a674644c156);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $662e33bb7444ae33$export$a1562d08625f5d7e);

var $eUqFw = parcelRequire("eUqFw");

var $dcbVh = parcelRequire("dcbVh");

var $hM7RE = parcelRequire("hM7RE");
var $bFzGY = parcelRequire("bFzGY");
var $2jDha = parcelRequire("2jDha");


var $hYg5M = parcelRequire("hYg5M");

var $89DHy = parcelRequire("89DHy");

var $9Nmk7 = parcelRequire("9Nmk7");

var $lC6tE = parcelRequire("lC6tE");
const $421aa4554894e770$export$515664faa1398f37 = 'navigation';
const $421aa4554894e770$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $421aa4554894e770$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $421aa4554894e770$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $421aa4554894e770$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $421aa4554894e770$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $421aa4554894e770$export$2b570fc112cbca = 'atlassianSwitcher';
const $421aa4554894e770$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $421aa4554894e770$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $421aa4554894e770$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $421aa4554894e770$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $421aa4554894e770$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $421aa4554894e770$export$af0b3e734498c53c = 'atlassianSwitcherFooterLeaveFeedback';
const $421aa4554894e770$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $421aa4554894e770$export$44c7ac3fdc1d62b8 = 'atlassianSwitcherCurrentOrg';
const $421aa4554894e770$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $421aa4554894e770$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $421aa4554894e770$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $421aa4554894e770$var$SWITCHER_DISCOVER_SECTION = 'atlassianSwitcherDiscoverMore';
const $421aa4554894e770$var$SWITCHER_RECENT_CONTAINERS = 'atlassianSwitcherRecentContainers';
const $421aa4554894e770$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $421aa4554894e770$var$SWITCHER_REMOTE_ICON = 'atlassianSwitcherRemoteIcon';
const $421aa4554894e770$var$RENDERED_ACTION = 'rendered';
const $421aa4554894e770$var$NOT_RENDERED_ACTION = 'not_rendered';
const $421aa4554894e770$var$VIEWED_ACTION = 'viewed';
const $421aa4554894e770$var$LOADED_ACTION = 'loaded';
const $421aa4554894e770$var$NOT_LOADED_ACTION = 'not_loaded';
const $421aa4554894e770$export$884b1a4c7ac9dd14 = (0, $hM7RE.default)($421aa4554894e770$export$515664faa1398f37);
const $421aa4554894e770$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $421aa4554894e770$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcbVh.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props));
    };
};
const $421aa4554894e770$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $421aa4554894e770$export$e09ad93c2b74b853 = (0, $2jDha.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
            action: $421aa4554894e770$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$421aa4554894e770$var$isValidDuration(duration) && {
                    bucket: (0, $9Nmk7.getMetricBucket)(duration, (0, $9Nmk7.RenderTrackerBuckets))
                }
            }
        }).fire($421aa4554894e770$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $421aa4554894e770$export$95b1f1a72cad0dcb = (0, $2jDha.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
            action: $421aa4554894e770$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($421aa4554894e770$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $421aa4554894e770$export$b3fd6624b6a6d057 = (0, $2jDha.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $662e33bb7444ae33$export$a1562d08625f5d7e),
            action: $421aa4554894e770$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($421aa4554894e770$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $421aa4554894e770$export$7609fab79cf145a0 = (props)=>{
    const { onLoad: onLoad, onError: onError, ...imgProps } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const imageMountedAt = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef((0, $lC6tE.performanceNow)());
    const analyticsHandler = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((actionType, event, action)=>{
        const duration = (0, $lC6tE.performanceNow)() - imageMountedAt.current;
        createAnalyticsEvent({
            action: actionType,
            actionSubject: $421aa4554894e770$var$SWITCHER_REMOTE_ICON,
            attributes: {
                ...$421aa4554894e770$var$isValidDuration(duration) && {
                    bucket: (0, $9Nmk7.getMetricBucket)(duration, (0, $9Nmk7.ImageLoadTrackerBuckets)),
                    duration: duration
                },
                src: imgProps.src
            },
            eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
        }).fire($421aa4554894e770$export$515664faa1398f37);
        if (action) action(event);
    }, [
        createAnalyticsEvent,
        imageMountedAt,
        imgProps.src
    ]);
    const onErrorAnalyticsHandler = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((errorEvent)=>{
        analyticsHandler($421aa4554894e770$var$NOT_LOADED_ACTION, errorEvent, onError);
    }, [
        analyticsHandler,
        onError
    ]);
    const onLoadAnalyticsHandler = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((loadEvent)=>{
        analyticsHandler($421aa4554894e770$var$LOADED_ACTION, loadEvent, onLoad);
    }, [
        analyticsHandler,
        onLoad
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        ...imgProps,
        onError: onErrorAnalyticsHandler,
        onLoad: onLoadAnalyticsHandler
    });
};
const $421aa4554894e770$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($421aa4554894e770$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($421aa4554894e770$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $421aa4554894e770$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($421aa4554894e770$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($421aa4554894e770$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $421aa4554894e770$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $hYg5M.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $421aa4554894e770$var$renderTracker({
        subject: $421aa4554894e770$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $421aa4554894e770$export$eff0211e47c4d541 = (xflowProviderResult, provisionedProductsProviderResult, joinableSitesProviderResult, productRecommendationsProviderResult, suggestedProductLinks, data)=>{
    const hasProviderNotReturnedExpectedData = (provider)=>provider.data === null || provider.status === (0, $hYg5M.Status).ERROR;
    const collectResults = (provider)=>({
            failed: hasProviderNotReturnedExpectedData(provider),
            loaded: (0, $hYg5M.hasLoaded)(provider)
        });
    const emptyRenderExpected = suggestedProductLinks.length === 0;
    const results = {
        xflow: collectResults(xflowProviderResult),
        provisionedProducts: collectResults(provisionedProductsProviderResult),
        joinableSites: collectResults(joinableSitesProviderResult),
        productRecommendations: collectResults(productRecommendationsProviderResult)
    };
    const providersLoaded = results.joinableSites.loaded && results.provisionedProducts.loaded && results.xflow.loaded && results.productRecommendations.loaded;
    if (!providersLoaded) return null;
    const didProviderFail = results.joinableSites.failed || results.provisionedProducts.failed || results.xflow.failed || results.productRecommendations.failed;
    /**
	 * Stop tracking the SLO the moment one of the providers fail.
	 */ if (didProviderFail) return $421aa4554894e770$var$renderTracker({
        subject: $421aa4554894e770$var$SWITCHER_DISCOVER_SECTION,
        providerFailed: true,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: suggestedProductLinks,
        data: {
            ...data,
            providerResults: {
                joinableSites: joinableSitesProviderResult.status,
                joinableSitesFailed: results.joinableSites.failed,
                provisionedProducts: provisionedProductsProviderResult.status,
                provisionedProductsFailed: results.provisionedProducts.failed,
                xflow: xflowProviderResult.status,
                xflowFailed: results.xflow.failed,
                productRecommendations: productRecommendationsProviderResult.status,
                productRecommendationsFailed: results.productRecommendations.failed
            }
        }
    });
    return $421aa4554894e770$var$renderTracker({
        subject: $421aa4554894e770$var$SWITCHER_DISCOVER_SECTION,
        providerFailed: false,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: suggestedProductLinks,
        data: data
    });
};
const $421aa4554894e770$export$92f66a8a67c9c3ce = (isEnabled, cgRecentContainersProviderResult, userSiteDataProviderResult, recentLinks, data)=>{
    if (!isEnabled) return null;
    const providerFailed = cgRecentContainersProviderResult.data === null || userSiteDataProviderResult.data === null;
    const emptyRenderExpected = Boolean(cgRecentContainersProviderResult.data && cgRecentContainersProviderResult.data.collaborationGraphEntities && cgRecentContainersProviderResult.data.collaborationGraphEntities.length === 0);
    return $421aa4554894e770$var$renderTracker({
        subject: $421aa4554894e770$var$SWITCHER_RECENT_CONTAINERS,
        providerFailed: providerFailed,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: recentLinks,
        data: data
    });
};
const $421aa4554894e770$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $hYg5M.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $89DHy.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $421aa4554894e770$var$renderTrackerWithReason({
        subject: $421aa4554894e770$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $421aa4554894e770$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$421aa4554894e770$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

parcelRegister("89DHy", function(module, exports) {

$parcel$export(module.exports, "UserSiteDataErrorReason", () => $5628d96e32bc2adf$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $5628d96e32bc2adf$export$c460344055e97b1);
var $5628d96e32bc2adf$export$b08600051ba52198;
(function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
})($5628d96e32bc2adf$export$b08600051ba52198 || ($5628d96e32bc2adf$export$b08600051ba52198 = {}));
class $5628d96e32bc2adf$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("9Nmk7", function(module, exports) {

$parcel$export(module.exports, "ImageLoadTrackerBuckets", () => $187dcabc649978e9$export$5fbf68affeca91cd);
$parcel$export(module.exports, "RenderTrackerBuckets", () => $187dcabc649978e9$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $187dcabc649978e9$export$b59492d26971ae92);
const $187dcabc649978e9$var$INFINITY = '+Inf';
const $187dcabc649978e9$export$5fbf68affeca91cd = [
    4000,
    2000,
    1000,
    500,
    100,
    50
];
const $187dcabc649978e9$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $187dcabc649978e9$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $187dcabc649978e9$var$INFINITY) : null;
};

});

parcelRegister("lC6tE", function(module, exports) {

$parcel$export(module.exports, "performanceNow", () => $986d5d566de2c36f$export$fb4230f160368c88);
const $986d5d566de2c36f$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});


parcelRegister("iqXt7", function(module, exports) {

$parcel$export(module.exports, "errorToReason", () => $9862a0c92932ac94$export$a3e288208721751b);
function $9862a0c92932ac94$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("bATRZ", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $c63dca19b4acad3f$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $c63dca19b4acad3f$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $c63dca19b4acad3f$export$f88dde183f4d31cb);

var $eUqFw = parcelRequire("eUqFw");
const $c63dca19b4acad3f$var$noop = ()=>{};
const $c63dca19b4acad3f$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    start: $c63dca19b4acad3f$var$noop,
    success: $c63dca19b4acad3f$var$noop,
    failure: $c63dca19b4acad3f$var$noop,
    failureAll: $c63dca19b4acad3f$var$noop,
    abort: $c63dca19b4acad3f$var$noop,
    abortAll: $c63dca19b4acad3f$var$noop,
    markStart: $c63dca19b4acad3f$var$noop,
    markEnd: $c63dca19b4acad3f$var$noop
});
const $c63dca19b4acad3f$export$cdefb2a8b53f879f = ()=>(0, $eUqFw.useContext)($c63dca19b4acad3f$export$3f3eebb4b8116461);
const $c63dca19b4acad3f$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $c63dca19b4acad3f$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("h5kHR", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphRecentContainerType", () => $399d290f264bfa14$export$405e7bccf91c0dd6);
$parcel$export(module.exports, "Permissions", () => $399d290f264bfa14$export$2d41982586bbb6be);
$parcel$export(module.exports, "Product", () => $399d290f264bfa14$export$264ad599d7cef668);
$parcel$export(module.exports, "Feature", () => $399d290f264bfa14$export$6e91cf7616333d5);
$parcel$export(module.exports, "AnalyticsItemType", () => $399d290f264bfa14$export$77f267162e8983fb);
$parcel$export(module.exports, "ProductKey", () => $399d290f264bfa14$export$f3a53bd43617a593);
$parcel$export(module.exports, "DiscoverLinkItemKeys", () => $399d290f264bfa14$export$b5f05566ea758e86);
var $399d290f264bfa14$export$32bb98a9a0fbbcb0;
(function(RecentContainerType) {
    RecentContainerType["JIRA_PROJECT"] = "jira-project";
    RecentContainerType["CONFLUENCE_SPACE"] = "confluence-space";
})($399d290f264bfa14$export$32bb98a9a0fbbcb0 || ($399d290f264bfa14$export$32bb98a9a0fbbcb0 = {}));
var $399d290f264bfa14$export$405e7bccf91c0dd6;
(function(CollaborationGraphRecentContainerType) {
    CollaborationGraphRecentContainerType["JIRA_PROJECT"] = "jiraProject";
    CollaborationGraphRecentContainerType["CONFLUENCE_SPACE"] = "confluenceSpace";
})($399d290f264bfa14$export$405e7bccf91c0dd6 || ($399d290f264bfa14$export$405e7bccf91c0dd6 = {}));
var $399d290f264bfa14$export$2d41982586bbb6be;
(function(Permissions) {
    Permissions["MANAGE"] = "manage";
    Permissions["CAN_INVITE_USERS"] = "invite-users";
})($399d290f264bfa14$export$2d41982586bbb6be || ($399d290f264bfa14$export$2d41982586bbb6be = {}));
var $399d290f264bfa14$export$264ad599d7cef668;
(function(Product) {
    Product["BITBUCKET"] = "bitbucket";
    Product["CONFLUENCE"] = "confluence";
    Product["HOME"] = "home";
    Product["JIRA"] = "jira";
    Product["SITE_ADMIN"] = "site-admin";
    Product["TRELLO"] = "trello";
    Product["START"] = "start";
})($399d290f264bfa14$export$264ad599d7cef668 || ($399d290f264bfa14$export$264ad599d7cef668 = {}));
var $399d290f264bfa14$export$6e91cf7616333d5;
(function(Feature) {
    Feature["enableRecentContainers"] = "enableRecentContainers";
    Feature["xflow"] = "xflow";
    // Show JSW first in product recommendations
    Feature["isProductStoreInTrelloJSWFirstEnabled"] = "isProductStoreInTrelloJSWFirstEnabled";
    // Show Confluence first in product recommendations
    Feature["isProductStoreInTrelloConfluenceFirstEnabled"] = "isProductStoreInTrelloConfluenceFirstEnabled";
    // Integrations discovery button and copy changes to More products
    Feature["isSlackDiscoveryEnabled"] = "isSlackDiscoveryEnabled";
    Feature["isUFOEnabled"] = "isUFOEnabled";
    Feature["isHighlightJwmInSwitcherExtendedAudienceEnabled"] = "isHighlightJwmInSwitcherExtendedAudienceEnabled";
})($399d290f264bfa14$export$6e91cf7616333d5 || ($399d290f264bfa14$export$6e91cf7616333d5 = {}));
var $399d290f264bfa14$export$77f267162e8983fb;
(function(AnalyticsItemType) {
    AnalyticsItemType["PRODUCT"] = "product";
    AnalyticsItemType["ADMIN"] = "admin";
    AnalyticsItemType["TRY"] = "try";
    AnalyticsItemType["JOIN"] = "join";
    AnalyticsItemType["CUSTOM_LINK"] = "customLink";
    AnalyticsItemType["DISCOVER_FIXED_LINKS"] = "discover-fixed-links";
    AnalyticsItemType["RECENT"] = "recent";
    AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
})($399d290f264bfa14$export$77f267162e8983fb || ($399d290f264bfa14$export$77f267162e8983fb = {}));
var $399d290f264bfa14$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["BITBUCKET"] = "bitbucket";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["TRELLO"] = "trello";
    ProductKey["COMPASS"] = "compass";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
})($399d290f264bfa14$export$f3a53bd43617a593 || ($399d290f264bfa14$export$f3a53bd43617a593 = {}));
var $399d290f264bfa14$export$b5f05566ea758e86;
(function(DiscoverLinkItemKeys) {
    DiscoverLinkItemKeys["DISCOVER_MORE"] = "discover-more";
    DiscoverLinkItemKeys["SLACK_INTEGRATION"] = "slack-integration";
})($399d290f264bfa14$export$b5f05566ea758e86 || ($399d290f264bfa14$export$b5f05566ea758e86 = {}));

});

parcelRegister("biW6x", function(module, exports) {

$parcel$export(module.exports, "withCached", () => $131ec2dfddaed398$export$7f51828d6b6af163);
const $131ec2dfddaed398$export$d4d4b402ab64e2f4 = 5000;
const $131ec2dfddaed398$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $131ec2dfddaed398$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($131ec2dfddaed398$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $131ec2dfddaed398$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("7NTKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4672ec1e95c1a8b2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hYg5M = parcelRequire("hYg5M");
/**
 * Inject the ability to handle cases when cloudID is missing into the provided component.
 *
 * When cloud ID is available, this HOC will wrap {children} with the given provided component.
 * Otherwise, {children} is executed with the provided fallback result.
 *
 * @param ProviderComponent component to wrap
 * @param fallbackProviderResult result used to execute children if cloud id is missing
 *
 * @type P component props
 * @type U provider result type
 */ function $4672ec1e95c1a8b2$var$withHandleOptionalCloudId(ProviderComponent, fallbackProviderResult) {
    return function(props) {
        const { cloudId: cloudId, children: children } = props;
        if (cloudId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProviderComponent, props, children);
        else {
            const resultComplete = {
                status: (0, $hYg5M.Status).COMPLETE,
                data: fallbackProviderResult
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(resultComplete));
        }
    };
}
var $4672ec1e95c1a8b2$export$2e2bcd8739ae039 = $4672ec1e95c1a8b2$var$withHandleOptionalCloudId;

});

parcelRegister("J5mP3", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $d528da849d19c5d1$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $d528da849d19c5d1$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $d528da849d19c5d1$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $d528da849d19c5d1$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $d528da849d19c5d1$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $d528da849d19c5d1$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $d528da849d19c5d1$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $d528da849d19c5d1$export$86919b84f9a64054);

var $12kyE = parcelRequire("12kyE");

var $9Rfi9 = parcelRequire("9Rfi9");
var $d528da849d19c5d1$export$c90b54e658fc4d7c;
(function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_DISCOVER_SECTION"] = "render-discover-section";
    Experience["RENDER_JOIN_SECTION"] = "render-join-section";
    Experience["RENDER_RECENT_SECTION"] = "render-recent-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
})($d528da849d19c5d1$export$c90b54e658fc4d7c || ($d528da849d19c5d1$export$c90b54e658fc4d7c = {}));
const $d528da849d19c5d1$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-discover-section"]: {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-join-section"]: {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-recent-section"]: {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $d528da849d19c5d1$export$cbf1e672c3e37474;
(function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_AVAILABLE_PRODUCTS"] = "api-available-products";
    ExperienceMark["API_COLLABORATION_GRAPH_RECENT_CONTAINERS"] = "api-collaboration-graph-recent-containers";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["API_PRODUCT_CONFIGURATION"] = "api-product-configuration";
    ExperienceMark["API_PRODUCT_RECOMMENDATIONS"] = "api-product-recommendations";
    ExperienceMark["API_XFLOW_SETTINGS"] = "api-xflow-settings";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
})($d528da849d19c5d1$export$cbf1e672c3e37474 || ($d528da849d19c5d1$export$cbf1e672c3e37474 = {}));
const $d528da849d19c5d1$var$allNonTestExperienceMarks = Object.values($d528da849d19c5d1$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $d528da849d19c5d1$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $d528da849d19c5d1$var$allNonTestExperienceMarks,
    ["render-discover-section"]: $d528da849d19c5d1$var$allNonTestExperienceMarks,
    ["render-join-section"]: $d528da849d19c5d1$var$allNonTestExperienceMarks,
    ["render-recent-section"]: $d528da849d19c5d1$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $d528da849d19c5d1$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $d528da849d19c5d1$var$allNonTestExperienceMarks
};
const $d528da849d19c5d1$export$805ed806e0769ee4 = (0, $9Rfi9.invertRecordOfArrays)($d528da849d19c5d1$export$755e75afbd377bc4);
var $d528da849d19c5d1$export$ec8391a70bbdbe59;
(function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
})($d528da849d19c5d1$export$ec8391a70bbdbe59 || ($d528da849d19c5d1$export$ec8391a70bbdbe59 = {}));
var $d528da849d19c5d1$export$279d6315a97b520d;
(function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
})($d528da849d19c5d1$export$279d6315a97b520d || ($d528da849d19c5d1$export$279d6315a97b520d = {}));
const $d528da849d19c5d1$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("9Rfi9", function(module, exports) {

$parcel$export(module.exports, "invertRecordOfArrays", () => $0668d00f1c5026ef$export$c371a74fe5222b3);
function $0668d00f1c5026ef$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});



parcelRegister("9rUOT", function(module, exports) {

$parcel$export(module.exports, "AvailableProductsProvider", () => $6da7045d0d9cd1b6$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $6da7045d0d9cd1b6$export$1c5684a3ba697d80);

var $eUqFw = parcelRequire("eUqFw");

var $eIKwx = parcelRequire("eIKwx");
const { fetchMethod: $6da7045d0d9cd1b6$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $6da7045d0d9cd1b6$var$DefaultBffDataProviderComponent } = (0, $eIKwx.createAppSwitcherBffAvailableProductsProvider)();
const $6da7045d0d9cd1b6$export$4c169257ef988618 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da7045d0d9cd1b6$var$DefaultBffDataProviderComponent, null, children);
const $6da7045d0d9cd1b6$export$1c5684a3ba697d80 = ()=>$6da7045d0d9cd1b6$var$fetchAppSwitcherBffAvailableProducts({});
const $6da7045d0d9cd1b6$export$cd9fc41c59711bdd = ()=>$6da7045d0d9cd1b6$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("eIKwx", function(module, exports) {

$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $18b46df00d5a9ba5$export$7fd9c7ae7afb494c);

var $2LVih = parcelRequire("2LVih");

var $41qIX = parcelRequire("41qIX");

var $J5mP3 = parcelRequire("J5mP3");
const $18b46df00d5a9ba5$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $18b46df00d5a9ba5$export$1096efb00c5f8afc = (url = $18b46df00d5a9ba5$export$f36bb44a614923a8)=>async ()=>{
        let init;
        if (url === $18b46df00d5a9ba5$export$f36bb44a614923a8) init = {
            headers: {
                'Atl-App-Switcher-Private-API': 'true'
            }
        };
        const response = await (0, $41qIX.fetchJsonWithNetworkRetries)(url, {
            intervalsMS: [
                50,
                200,
                1000
            ]
        }, init);
        return response;
    };
const $18b46df00d5a9ba5$export$7fd9c7ae7afb494c = (url = $18b46df00d5a9ba5$export$f36bb44a614923a8)=>{
    return (0, $2LVih.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $J5mP3.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $18b46df00d5a9ba5$export$1096efb00c5f8afc(url));
};

});
parcelRegister("2LVih", function(module, exports) {

$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $fbd4d4851febe69b$export$310e48be95687c2f);

var $hYg5M = parcelRequire("hYg5M");

var $41qIX = parcelRequire("41qIX");

var $biW6x = parcelRequire("biW6x");
const $fbd4d4851febe69b$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $biW6x.withCached)((param)=>(0, $41qIX.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $hYg5M.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $fbd4d4851febe69b$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $biW6x.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $hYg5M.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});



parcelRegister("lwQen", function(module, exports) {

$parcel$export(module.exports, "JoinableSitesProvider", () => $70713345e49a2333$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $70713345e49a2333$export$2aed3ef1595b4d9);

var $eUqFw = parcelRequire("eUqFw");

var $3fbcx = parcelRequire("3fbcx");
const { fetchMethod: $70713345e49a2333$var$fetchJoinableSites, ProviderComponent: $70713345e49a2333$var$DefaultDataProviderComponent } = (0, $3fbcx.createJoinableSitesProvider)();
const $70713345e49a2333$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $70713345e49a2333$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DataProviderComponent, null, children);
};
const $70713345e49a2333$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $70713345e49a2333$var$fetchJoinableSites({});
};
const $70713345e49a2333$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $70713345e49a2333$var$fetchJoinableSites.reset();
};

});
parcelRegister("3fbcx", function(module, exports) {

$parcel$export(module.exports, "createJoinableSitesProvider", () => $23f573bcb2b6827b$export$c3b6af53f1ca17d8);

var $2LVih = parcelRequire("2LVih");

var $J5mP3 = parcelRequire("J5mP3");
const $23f573bcb2b6827b$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $23f573bcb2b6827b$export$c3b6af53f1ca17d8 = (fetchData = $23f573bcb2b6827b$export$62986affcccd56a5, retryConfig)=>{
    return (0, $2LVih.createProviderWithCustomFetchData)('joinableSites', (0, $J5mP3.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});


parcelRegister("4f9KR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2950421b2f90d149$export$2e2bcd8739ae039);

var $h5kHR = parcelRequire("h5kHR");

var $858Yq = parcelRequire("858Yq");
var $2950421b2f90d149$export$2e2bcd8739ae039 = (product)=>{
    (0, $858Yq.loadAtlassianSwitcher)();
    if (product === (0, $h5kHR.Product).JIRA) return (0, $858Yq.loadJiraSwitcher)();
    if (product === (0, $h5kHR.Product).CONFLUENCE) return (0, $858Yq.loadConfluenceSwitcher)();
    if (product === (0, $h5kHR.Product).TRELLO) return (0, $858Yq.loadTrelloSwitcher)();
    return (0, $858Yq.loadGenericSwitcher)();
};

});
parcelRegister("858Yq", function(module, exports) {

$parcel$export(module.exports, "loadAtlassianSwitcher", () => $edc341fdd01ee393$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadJiraSwitcher", () => $edc341fdd01ee393$export$52c59c5b477673fb);
$parcel$export(module.exports, "loadConfluenceSwitcher", () => $edc341fdd01ee393$export$2d2945898d9ee55f);
$parcel$export(module.exports, "loadGenericSwitcher", () => $edc341fdd01ee393$export$64191a36345a6b2b);
$parcel$export(module.exports, "loadTrelloSwitcher", () => $edc341fdd01ee393$export$b1037658b0b9e49e);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $edc341fdd01ee393$export$25f16f9fee84a840);
$parcel$export(module.exports, "JiraSwitcherLoader", () => $edc341fdd01ee393$export$10767845f9f42bd);
$parcel$export(module.exports, "ConfluenceSwitcherLoader", () => $edc341fdd01ee393$export$71f961c620294b68);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $edc341fdd01ee393$export$8c21d1a0c59fc17e);
$parcel$export(module.exports, "TrelloSwitcherLoader", () => $edc341fdd01ee393$export$21b8192b12701f9e);

var $bYKiA = parcelRequire("bYKiA");

var $eUqFw = parcelRequire("eUqFw");

var $4Ri7w = parcelRequire("4Ri7w");

const $edc341fdd01ee393$export$6c6894dd831bfacb = ()=>(parcelRequire("1XcWE")).then((module)=>module.default);

const $edc341fdd01ee393$export$52c59c5b477673fb = ()=>(parcelRequire("bR2AP")).then((module)=>module.default);

const $edc341fdd01ee393$export$2d2945898d9ee55f = ()=>(parcelRequire("3a4sG")).then((module)=>module.default);

const $edc341fdd01ee393$export$64191a36345a6b2b = ()=>(parcelRequire("4UZyH")).then((module)=>module.default);

const $edc341fdd01ee393$export$b1037658b0b9e49e = ()=>(parcelRequire("Mrn4V")).then((module)=>module.default);
const $edc341fdd01ee393$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: $edc341fdd01ee393$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Ri7w.default), null)
});
const $edc341fdd01ee393$export$10767845f9f42bd = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: $edc341fdd01ee393$export$52c59c5b477673fb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Ri7w.default), null)
});
const $edc341fdd01ee393$export$71f961c620294b68 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: $edc341fdd01ee393$export$2d2945898d9ee55f,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Ri7w.default), null)
});
const $edc341fdd01ee393$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: $edc341fdd01ee393$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Ri7w.default), null)
});
const $edc341fdd01ee393$export$21b8192b12701f9e = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: $edc341fdd01ee393$export$b1037658b0b9e49e,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Ri7w.default), null)
});

});
parcelRegister("4Ri7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6938e9ebac4bcfb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $hh00r = parcelRequire("hh00r");

var $b9pb4 = parcelRequire("b9pb4");

var $J5mP3 = parcelRequire("J5mP3");
var $lCMxV = parcelRequire("lCMxV");
const $c6938e9ebac4bcfb$var$iconSkeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    width: 32,
    height: 32,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-skeleton, ${$PdmhA.N20})`,
    borderRadius: "var(--ds-border-radius-200, 8px)"
});
const $c6938e9ebac4bcfb$var$lineSkeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    width: 98,
    height: 10,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-skeleton, ${$PdmhA.N20})`,
    borderRadius: "var(--ds-border-radius, 3px)"
});
// TODO: add loading text for screen reader
// https://product-fabric.atlassian.net/browse/CXP-2998
const $c6938e9ebac4bcfb$var$iconSkeleton = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
    css: $c6938e9ebac4bcfb$var$iconSkeletonStyles
});
const $c6938e9ebac4bcfb$var$lineSkeleton = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
    css: $c6938e9ebac4bcfb$var$lineSkeletonStyles
});
var $c6938e9ebac4bcfb$export$2e2bcd8739ae039 = ()=>{
    (0, $lCMxV.useExperienceRenderAndMountMark)((0, $J5mP3.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hh00r.SectionContainer), {
        sectionId: "skeleton",
        title: $c6938e9ebac4bcfb$var$lineSkeleton
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b9pb4.default), {
        tag: "li",
        icon: $c6938e9ebac4bcfb$var$iconSkeleton,
        isDisabled: true
    }, $c6938e9ebac4bcfb$var$lineSkeleton), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b9pb4.default), {
        tag: "li",
        icon: $c6938e9ebac4bcfb$var$iconSkeleton,
        isDisabled: true
    }, $c6938e9ebac4bcfb$var$lineSkeleton), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b9pb4.default), {
        tag: "li",
        icon: $c6938e9ebac4bcfb$var$iconSkeleton,
        isDisabled: true
    }, $c6938e9ebac4bcfb$var$lineSkeleton));
};

});
parcelRegister("hh00r", function(module, exports) {

$parcel$export(module.exports, "SectionContainerTitle", () => $9aa1edaa50d3d1db$export$7bb82566a1f2a4f5);
$parcel$export(module.exports, "SectionContainer", () => $9aa1edaa50d3d1db$export$be4c8679ebfd988);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $4lTFP = parcelRequire("4lTFP");

var $hGcnP = parcelRequire("hGcnP");

var $byn9U = parcelRequire("byn9U");

var $j5Yzx = parcelRequire("j5Yzx");
var $dcbVh = parcelRequire("dcbVh");

var $eomyR = parcelRequire("eomyR");

var $fCKtC = parcelRequire("fCKtC");

var $h5kHR = parcelRequire("h5kHR");
function $9aa1edaa50d3d1db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9aa1edaa50d3d1db$var$sectionContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-075, 6px)"} 0`
});
const $9aa1edaa50d3d1db$var$secondarySectionTitleBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        marginTop: `${"var(--ds-space-200, 16px)"}`,
        marginLeft: `${"var(--ds-space-100, 8px)"}`
    }
});
const $9aa1edaa50d3d1db$var$secondarySectionTitleStandaloneStyles = {
    name: "tnphew",
    styles: "margin-bottom:var(--ds-space-050, 4px)"
};
const $9aa1edaa50d3d1db$var$secondarySectionTitleDrawerStyles = {
    name: "803obq",
    styles: "margin-bottom:var(--ds-space-100, 8px)"
};
const $9aa1edaa50d3d1db$var$sectionTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: "var(--ds-text-subtle, #44546F)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`,
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
const $9aa1edaa50d3d1db$var$sectionChildrenWrapperStyles = {
    name: "1kz5jpr",
    styles: "list-style-type:none;padding:0;margin:0"
};
const $9aa1edaa50d3d1db$export$7bb82566a1f2a4f5 = ({ appearance: appearance, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("h3", {
        css: [
            $9aa1edaa50d3d1db$var$secondarySectionTitleBaseStyles,
            appearance === 'standalone' ? $9aa1edaa50d3d1db$var$secondarySectionTitleStandaloneStyles : $9aa1edaa50d3d1db$var$secondarySectionTitleDrawerStyles,
            $9aa1edaa50d3d1db$var$sectionTitleStyles
        ]
    }, title);
const $9aa1edaa50d3d1db$var$SectionContainerComponent = ({ title: title, titleLink: titleLink, children: children, appearance: appearance, actionSubject: actionSubject, sectionId: sectionId })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).some(Boolean) ? /*#__PURE__*/ (0, $byn9U.jsx)("section", {
        css: $9aa1edaa50d3d1db$var$sectionContainerStyles,
        "data-testid": `${sectionId}__section`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eomyR.FadeIn), null, title && /*#__PURE__*/ (0, $byn9U.jsx)($9aa1edaa50d3d1db$export$7bb82566a1f2a4f5, {
        appearance: appearance,
        title: title
    }), titleLink && /*#__PURE__*/ (0, $byn9U.jsx)($9aa1edaa50d3d1db$var$TitleLink, {
        titleLink: titleLink,
        actionSubject: actionSubject
    })), /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $9aa1edaa50d3d1db$var$sectionChildrenWrapperStyles
    }, children)) : null;
};
const $9aa1edaa50d3d1db$var$TitleLink = ({ titleLink: titleLink, actionSubject: actionSubject })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $dcbVh.NavigationAnalyticsContext), {
        key: titleLink.key,
        data: (0, $j5Yzx.getItemAnalyticsContext)(0, titleLink.key, (0, $h5kHR.AnalyticsItemType).PRODUCT, titleLink.productType)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fCKtC.default), {
        href: titleLink.href,
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hGcnP))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        label: titleLink.label,
        testId: "section-title__link",
        actionSubject: actionSubject,
        ariaLabel: titleLink.ariaLabel
    }));
const $9aa1edaa50d3d1db$export$be4c8679ebfd988 = (0, $j5Yzx.withAnalyticsContextData)((props)=>(0, $j5Yzx.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(props.children)
    }))($9aa1edaa50d3d1db$var$SectionContainerComponent);

});
parcelRegister("hGcnP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cdeff6f7a5b7fded$var$_react = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cdeff6f7a5b7fded$var$_linkExternal = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("1yh1n")));

var $cdeff6f7a5b7fded$var$_shortcut = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("23NQ5")));
function $cdeff6f7a5b7fded$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cdeff6f7a5b7fded$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $cdeff6f7a5b7fded$var$_react.default.createElement($cdeff6f7a5b7fded$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $cdeff6f7a5b7fded$var$_shortcut.default
    }, props));
$cdeff6f7a5b7fded$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
var $cdeff6f7a5b7fded$var$_default = module.exports.default = $cdeff6f7a5b7fded$var$LinkExternalIcon;

});

parcelRegister("eomyR", function(module, exports) {

$parcel$export(module.exports, "FadeIn", () => $c8d2b73f82f980a0$export$bd7370ffb2917ab7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $c8d2b73f82f980a0$var$fadeIn = (0, $byn9U.keyframes)({
    to: {
        opacity: 1
    }
});
const $c8d2b73f82f980a0$var$fadeInStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$c8d2b73f82f980a0$var$fadeIn} 500ms ease forwards`,
    opacity: 0,
    margin: 0,
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$PdmhA.N800})`
});
const $c8d2b73f82f980a0$export$bd7370ffb2917ab7 = ({ children: children, className: className, tag: Tag = 'div' })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        css: $c8d2b73f82f980a0$var$fadeInStyles,
        className: className
    }, children);

});

parcelRegister("fCKtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $959b5e575749993e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hGcnP = parcelRequire("hGcnP");

var $2jDha = parcelRequire("2jDha");


var $j5Yzx = parcelRequire("j5Yzx");

var $8uD7Y = parcelRequire("8uD7Y");
const $959b5e575749993e$var$ItemLink = ({ label: label, href: href, testId: testId, onClick: onClick, ariaLabel: ariaLabel })=>{
    const buttonProps = {
        appearance: 'link',
        href: href,
        className: 'section-link',
        target: '_blank',
        rel: 'noopener noreferrer',
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hGcnP))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        onClick: onClick ? (e, a)=>onClick(e, a) : undefined,
        testId: testId
    };
    if (ariaLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), ariaLabel, (placeholder)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...buttonProps,
            "aria-label": String(placeholder)
        }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), buttonProps, label);
};
var $959b5e575749993e$export$2e2bcd8739ae039 = (0, $2jDha.default)({
    onClick: (0, $j5Yzx.createAndFireNavigationEvent)({
        eventType: (0, $662e33bb7444ae33$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: (0, $j5Yzx.SWITCHER_ITEM_SUBJECT)
    })
})($959b5e575749993e$var$ItemLink);

});


parcelRegister("b9pb4", function(module, exports) {

$parcel$export(module.exports, "LozengeType", () => $e43bf4e42d4c6ea7$export$b95b532653e2b7f6);
$parcel$export(module.exports, "default", () => $e43bf4e42d4c6ea7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $bo4OB = parcelRequire("bo4OB");

var $j5Yzx = parcelRequire("j5Yzx");

var $eomyR = parcelRequire("eomyR");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $8uD7Y = parcelRequire("8uD7Y");

var $1edW2 = parcelRequire("1edW2");

var $9SMLg = parcelRequire("9SMLg");
function $e43bf4e42d4c6ea7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e43bf4e42d4c6ea7$export$b95b532653e2b7f6;
(function(LozengeType) {
    LozengeType["New"] = "new";
    LozengeType["Try"] = "try";
})($e43bf4e42d4c6ea7$export$b95b532653e2b7f6 || ($e43bf4e42d4c6ea7$export$b95b532653e2b7f6 = {}));
const $e43bf4e42d4c6ea7$var$lozengeData = {
    ["new"]: {
        label: (0, $1edW2.default).newLozenge,
        componentProps: {
            appearance: 'new'
        }
    },
    ["try"]: {
        label: (0, $1edW2.default).tryLozenge,
        componentProps: {
            appearance: 'new'
        }
    }
};
const $e43bf4e42d4c6ea7$var$fadeInStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $e43bf4e42d4c6ea7$var$childrenStyles = {
    name: "1ixuzqj",
    styles: "line-height:14px;min-height:16px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $e43bf4e42d4c6ea7$var$itemDescriptionStyles = {
    name: "ess88o",
    styles: "color:var(--ds-text-subtlest, #626F86);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:var(--ds-space-150, 12px);font-weight:var(--ds-font-weight-regular, 400)"
};
const $e43bf4e42d4c6ea7$var$SwitcherItem = ({ icon: icon, description: description, elemAfter: elemAfter, shouldAllowMultiline: shouldAllowMultiline, onClick: onClick, children: children, lozenges: lozenges, product: product, createAnalyticsEvent: createAnalyticsEvent, tag: tag, href: href, ...rest })=>{
    const itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(description) || typeof description === 'string') return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $e43bf4e42d4c6ea7$var$itemDescriptionStyles
        }, description);
        return undefined;
    }, [
        description
    ]);
    const renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (!lozenges?.length) return null;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9SMLg.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, lozenges.map((lozenge, index)=>{
            const { componentProps: componentProps, label: label } = $e43bf4e42d4c6ea7$var$lozengeData[lozenge];
            return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                key: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    marginLeft: "var(--ds-space-100, 8px)"
                }
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
                ...componentProps,
                "data-testid": "switcher-item-lozenge"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), label)));
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j5Yzx.RenderTracker), {
            subject: (0, $j5Yzx.SWITCHER_ITEM_LOZENGES_SUBJECT),
            data: {
                product: product,
                lozenges: lozenges,
                children: children,
                description: description
            }
        })));
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eomyR.FadeIn), {
        css: $e43bf4e42d4c6ea7$var$fadeInStyles,
        tag: tag
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bo4OB.default), {
        testId: "switcher-base-item",
        description: itemDescription,
        iconBefore: icon,
        iconAfter: elemAfter,
        target: "_blank",
        href: href ?? '#',
        onClick: (event)=>{
            // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
            if (!href) event.preventDefault();
            if (onClick) onClick(event);
        },
        ...rest
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e43bf4e42d4c6ea7$var$childrenStyles
    }, children, renderLozenges)));
};
var $e43bf4e42d4c6ea7$export$2e2bcd8739ae039 = $e43bf4e42d4c6ea7$var$SwitcherItem;

});
parcelRegister("1edW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $187cf93286fc968f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $187cf93286fc968f$var$messages = (0, $90IgZ.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    }
});
var $187cf93286fc968f$export$2e2bcd8739ae039 = $187cf93286fc968f$var$messages;

});

parcelRegister("9SMLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e2fb8f76ff0f0d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $byn9U = parcelRequire("byn9U");

var $cLoZ1 = parcelRequire("cLoZ1");

var $h4BCI = parcelRequire("h4BCI");

var $j5Yzx = parcelRequire("j5Yzx");
var $2jDha = parcelRequire("2jDha");

var $8IPRr = parcelRequire("8IPRr");

var $iqXt7 = parcelRequire("iqXt7");

var $98BQJ = parcelRequire("98BQJ");

var $h5kHR = parcelRequire("h5kHR");

var $iKVU5 = parcelRequire("iKVU5");

var $hJTaO = parcelRequire("hJTaO");

var $fv7xM = parcelRequire("fv7xM");
function $27e2fb8f76ff0f0d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $27e2fb8f76ff0f0d$var$TRIGGER_SUBJECT = 'errorBoundary';
const $27e2fb8f76ff0f0d$var$ACTION_SUBJECT = 'rendered';
// This image is also used as the generic error message in Notifications
const $27e2fb8f76ff0f0d$var$robotsImgStyles = {
    name: "1nv5fft",
    styles: "height:200px"
};
const $27e2fb8f76ff0f0d$var$trelloErrorImgStyles = {
    name: "8svur3",
    styles: "width:140px;height:88px"
};
const $27e2fb8f76ff0f0d$var$unverifiedUserImageStyles = {
    name: "1vavuhq",
    styles: "height:150px"
};
const $27e2fb8f76ff0f0d$var$errorContentStyles = {
    name: "1m9g2qv",
    styles: "display:flex;align-items:center;justify-content:center;flex-direction:column"
};
const $27e2fb8f76ff0f0d$var$errorHeadingStyles = {
    name: "zfzx1k",
    styles: "max-width:240px;margin-top:var(--ds-space-400, 32px)"
};
const $27e2fb8f76ff0f0d$var$errorMessageStyles = {
    name: "8c8jo5",
    styles: "max-width:240px;margin-top:var(--ds-space-300, 24px)"
};
const $27e2fb8f76ff0f0d$var$loginButtonStyles = {
    name: "1d79juz",
    styles: "margin-top:var(--ds-space-300, 24px)"
};
const $27e2fb8f76ff0f0d$var$errorBoundaryBoxStyles = {
    name: "1ourv3z",
    styles: "display:flex;justify-content:center;flex-direction:column;text-align:center"
};
const $27e2fb8f76ff0f0d$var$errorBoundaryBoxDrawerStyles = {
    name: "ys7599",
    styles: "padding-top:128px;padding-right:var(--ds-space-800, 64px)"
};
const $27e2fb8f76ff0f0d$var$errorBoundaryBoxNonDrawerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-600, 48px)"} 0`
});
const $27e2fb8f76ff0f0d$var$loginButtonNonDrawerStyles = {
    name: "1gfc3a0",
    styles: "justify-content:center;align-self:stretch"
};
const $27e2fb8f76ff0f0d$var$ErrorMessage = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("p", {
        css: $27e2fb8f76ff0f0d$var$errorMessageStyles
    }, props.children);
class $27e2fb8f76ff0f0d$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch(error) {
        const reason = error instanceof (0, $hJTaO.SwitcherLoadError) ? error.reason() : (0, $iqXt7.errorToReason)(error);
        this.setState({
            hasError: true,
            reason: reason
        }, ()=>{
            this.fireOperationalEvent({
                action: $27e2fb8f76ff0f0d$var$ACTION_SUBJECT,
                attributes: {
                    ...reason,
                    ...this.props.extraAnalyticProps
                }
            });
        });
        this.props.onErrorCallback?.(error);
    }
    renderErrorBody(appearance) {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $fv7xM.FETCH_ERROR_NAME)) {
            const isTrello = this.props.product === (0, $h5kHR.Product).TRELLO;
            if (reason.status === 401) // Not authorised http error
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)($27e2fb8f76ff0f0d$var$ErrorMessage, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).errorTextLoggedOut)), isTrello ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $iKVU5.default), {
                css: [
                    $27e2fb8f76ff0f0d$var$loginButtonStyles,
                    appearance !== 'drawer' && $27e2fb8f76ff0f0d$var$loginButtonNonDrawerStyles
                ],
                appearance: "link",
                href: (0, $8IPRr.getLoginUrl)((0, $h5kHR.Product).TRELLO),
                onClick: this.handleLogin
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).login)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $iKVU5.default), {
                css: [
                    $27e2fb8f76ff0f0d$var$loginButtonStyles,
                    appearance !== 'drawer' && $27e2fb8f76ff0f0d$var$loginButtonNonDrawerStyles
                ],
                onClick: this.handleLogin
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).login)));
            if (reason.status === 403) return /*#__PURE__*/ (0, $byn9U.jsx)($27e2fb8f76ff0f0d$var$ErrorMessage, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).errorTextUnverified));
            return /*#__PURE__*/ (0, $byn9U.jsx)($27e2fb8f76ff0f0d$var$ErrorMessage, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).errorTextNetwork));
        }
        // Default error message
        return /*#__PURE__*/ (0, $byn9U.jsx)($27e2fb8f76ff0f0d$var$ErrorMessage, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).errorText));
    }
    renderErrorHeading() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $fv7xM.FETCH_ERROR_NAME) && reason.status === 401) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).errorHeadingLoggedOut);
        if (reason.name === (0, $fv7xM.FETCH_ERROR_NAME) && reason.status === 403) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).errorHeadingUnverified);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $98BQJ.default).errorHeading);
    }
    renderErrorImage() {
        const { intl: intl, product: product } = this.props;
        const { reason: reason } = this.state;
        if (product === (0, $h5kHR.Product).TRELLO) return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            css: $27e2fb8f76ff0f0d$var$trelloErrorImgStyles,
            src: (0, $cLoZ1.default),
            alt: intl.formatMessage((0, $98BQJ.default).errorImageAltText)
        });
        if (reason.status === 403) return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            css: $27e2fb8f76ff0f0d$var$unverifiedUserImageStyles,
            src: (0, $h4BCI.default),
            alt: intl.formatMessage((0, $98BQJ.default).errorImageAltText)
        });
        return /*#__PURE__*/ (0, $byn9U.jsx)($27e2fb8f76ff0f0d$var$RobotImage, {
            css: $27e2fb8f76ff0f0d$var$robotsImgStyles,
            alt: intl.formatMessage((0, $98BQJ.default).errorImageAltText)
        });
    }
    render() {
        const { appearance: appearance, hideFallbackUI: hideFallbackUI } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && hideFallbackUI) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
        if (hasError) return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $27e2fb8f76ff0f0d$var$errorBoundaryBoxStyles,
                appearance === 'drawer' ? $27e2fb8f76ff0f0d$var$errorBoundaryBoxDrawerStyles : $27e2fb8f76ff0f0d$var$errorBoundaryBoxNonDrawerStyles
            ],
            "data-testid": "error-boundary"
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $27e2fb8f76ff0f0d$var$errorContentStyles
        }, this.renderErrorImage(), /*#__PURE__*/ (0, $byn9U.jsx)("h3", {
            css: $27e2fb8f76ff0f0d$var$errorHeadingStyles
        }, this.renderErrorHeading()), this.renderErrorBody(appearance)));
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
        this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                actionSubject: this.props.triggerSubject || $27e2fb8f76ff0f0d$var$TRIGGER_SUBJECT,
                ...payload
            }).fire((0, $j5Yzx.NAVIGATION_CHANNEL));
        };
        this.handleLogin = (_, analyticsEvent)=>{
            analyticsEvent.update({
                eventType: (0, $662e33bb7444ae33$export$a1562d08625f5d7e),
                actionSubjectId: 'login'
            }).fire((0, $j5Yzx.NAVIGATION_CHANNEL));
            if (this.props.product !== (0, $h5kHR.Product).TRELLO) window.location.reload();
        };
    }
}

const $27e2fb8f76ff0f0d$var$RobotImage = (props)=>{
    const [imgSrc, setImgSrc] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        (parcelRequire("cdkDJ")).then((src)=>setImgSrc(src.default));
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        ...props,
        src: imgSrc
    });
};
var $27e2fb8f76ff0f0d$export$2e2bcd8739ae039 = (0, $2jDha.default)()((0, $2qhQi.default)($27e2fb8f76ff0f0d$var$ErrorBoundary));

});
parcelRegister("cLoZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1261248aec573bab$export$2e2bcd8739ae039);
var $1261248aec573bab$export$2e2bcd8739ae039 = 'data:image/svg+xml;base64,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';

});

parcelRegister("h4BCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $afbdd25270d46d60$export$2e2bcd8739ae039);
var $afbdd25270d46d60$export$2e2bcd8739ae039 = `data:image/svg+xml;base64,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`;

});

parcelRegister("8IPRr", function(module, exports) {

$parcel$export(module.exports, "getLoginUrl", () => $3a3c515a5a3304d0$export$8abe2e83e8d74da2);

var $h5kHR = parcelRequire("h5kHR");
var $3a3c515a5a3304d0$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["Staging"] = "stg";
    Environment["Production"] = "prod";
})($3a3c515a5a3304d0$export$7dc6752a22ab011a || ($3a3c515a5a3304d0$export$7dc6752a22ab011a = {}));
const $3a3c515a5a3304d0$export$186d9db1ec46a9ca = (origin = window?.location?.origin)=>[
        'https://trello.com'
    ].includes(origin) ? "prod" : "stg";
const $3a3c515a5a3304d0$var$getProduct = (product)=>{
    if (product) {
        const lowerJira = (0, $h5kHR.Product).JIRA.toLowerCase();
        const lowerProduct = product.toLowerCase();
        if (lowerProduct.includes(lowerJira)) return lowerJira;
        return lowerProduct;
    }
};
const $3a3c515a5a3304d0$export$8abe2e83e8d74da2 = (productType, env = $3a3c515a5a3304d0$export$186d9db1ec46a9ca(), continueUrl = String(window.location), loginHint)=>{
    const baseUrl = env === "prod" ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
    const product = $3a3c515a5a3304d0$var$getProduct(productType);
    return `${baseUrl}?continue=${encodeURIComponent(continueUrl)}${product ? `&application=${encodeURIComponent(product)}` : ''}
  ${loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : ''}`;
};

});

parcelRegister("98BQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $538a7be512dc7764$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $538a7be512dc7764$var$messages = (0, $90IgZ.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    atlassianHome: {
        id: 'fabric.atlassianSwitcher.home',
        defaultMessage: 'Atlassian Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    recent: {
        id: 'fabric.atlassianSwitcher.recent',
        defaultMessage: 'Recent',
        description: "In a context in which users are able to view recent projects or spaces they've viewed, this text is the title of the section displaying all the recent projects or spaces."
    },
    more: {
        id: 'fabric.atlassianSwitcher.more',
        defaultMessage: 'More',
        description: 'In a context in which users are able to view predefined custom links, this text is the title of the section displaying all existing custom links.'
    },
    try: {
        id: 'fabric.atlassianSwitcher.try',
        defaultMessage: 'Try',
        description: 'This text appears as a way to encourage the user to try a new Atlassian product.'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    jiraProject: {
        id: 'fabric.atlassianSwitcher.jiraProject',
        defaultMessage: 'Jira project',
        description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Jira project'
    },
    confluenceSpace: {
        id: 'fabric.atlassianSwitcher.confluenceSpace',
        defaultMessage: 'Confluence space',
        description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Confluence space'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to the site administration'
    },
    moreAtlassianProductsLink: {
        id: 'fabric.atlassianSwitcher.moreAtlassianProducts',
        defaultMessage: 'More Atlassian products',
        description: 'The text of a link redirecting the user to Discover More Atlassian products'
    },
    slackIntegrationLink: {
        id: 'fabric.atlassianSwitcher.slackIntegrationLink',
        defaultMessage: 'Slack',
        description: 'The text of a link which opens the Slack Authentication popup'
    },
    slackIntegrationLinkDescription: {
        id: 'fabric.atlassianSwitcher.slackIntegrationLinkDescription',
        defaultMessage: 'Integrate Slack with your Atlassian products',
        description: 'The description of a link which opens the Slack Authentication popup'
    },
    browseApps: {
        id: 'fabric.atlassianSwitcher.browseApps',
        defaultMessage: 'Browse Marketplace apps',
        description: 'The text of a link redirecting the user to Discover Embedded Marketplace within in the product (Marketplace is a brand name. Please dont translate it)'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your products right now.",
        description: 'Heading of the error message when available products returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorTextLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorTextLoggedOut',
        defaultMessage: 'Log in again to use the Atlassian\u00A0switcher.',
        description: 'Text that is displayed when we detect user is logged out.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your products right now.",
        description: 'Heading of the error message when available products returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    login: {
        id: 'fabric.atlassianSwitcher.login',
        defaultMessage: 'Log in',
        description: 'Text in log in button.'
    },
    discover: {
        id: 'fabric.atlassianSwitcher.discover',
        defaultMessage: 'Discover',
        description: 'The header of "Discover" section'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    }
});
var $538a7be512dc7764$export$2e2bcd8739ae039 = $538a7be512dc7764$var$messages;

});

parcelRegister("iKVU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7584a1082849b01d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");
function $7584a1082849b01d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), props);
}

});

parcelRegister("hJTaO", function(module, exports) {

$parcel$export(module.exports, "SwitcherLoadErrorReason", () => $7fe67013d349dfe3$export$2c6136f6e27d3fdd);
$parcel$export(module.exports, "SwitcherLoadError", () => $7fe67013d349dfe3$export$ff0950b3c2e7f03e);

var $iqXt7 = parcelRequire("iqXt7");
var $7fe67013d349dfe3$export$2c6136f6e27d3fdd;
(function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
})($7fe67013d349dfe3$export$2c6136f6e27d3fdd || ($7fe67013d349dfe3$export$2c6136f6e27d3fdd = {}));
class $7fe67013d349dfe3$export$ff0950b3c2e7f03e extends Error {
    constructor(errorReason, resultError){
        super();
        this.errorReason = errorReason;
        this.resultError = resultError;
    }
    reason() {
        const potentialResultError = this.resultError;
        return {
            ...(0, $iqXt7.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError),
            source: this.errorReason
        };
    }
}

});

parcelRegister("cdkDJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gEBpF');
        const value = parcelRequire('6bZgC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gEBpF").then(()=>parcelRequire('6bZgC'));
}

});



parcelRegister("lCMxV", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $5b36de2732d821ac$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $5b36de2732d821ac$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $bATRZ = parcelRequire("bATRZ");

var $eUqFw = parcelRequire("eUqFw");

var $3Prj6 = parcelRequire("3Prj6");
function $5b36de2732d821ac$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $bATRZ.useExperienceTracker)();
    (0, $3Prj6.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $5b36de2732d821ac$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $bATRZ.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $5b36de2732d821ac$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $bATRZ.useExperienceTracker)();
    (0, $3Prj6.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("3Prj6", function(module, exports) {

$parcel$export(module.exports, "useSingleton", () => $064a92b7cc915d65$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $064a92b7cc915d65$export$ad4f8d0eee7a0e24);

var $eUqFw = parcelRequire("eUqFw");
function $064a92b7cc915d65$export$abf4268d2dd55708(builder) {
    const ref = (0, $eUqFw.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $064a92b7cc915d65$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $eUqFw.useRef)(false);
    const result = (0, $eUqFw.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});



parcelRegister("1XcWE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lr4Hp');
        const value = parcelRequire('lX1CQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lr4Hp").then(()=>parcelRequire('lX1CQ'));
}

});

parcelRegister("bR2AP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('9F4hd')
        ]);
        const value = parcelRequire('3RzCd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("9F4hd")
    ]).then(()=>parcelRequire('3RzCd'));
}

});

parcelRegister("3a4sG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hlC7r')
        ]);
        const value = parcelRequire('bRQyB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hlC7r")
    ]).then(()=>parcelRequire('bRQyB'));
}

});

parcelRegister("4UZyH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('fHtFa')
        ]);
        const value = parcelRequire('f5yZA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("fHtFa")
    ]).then(()=>parcelRequire('f5yZA'));
}

});

parcelRegister("Mrn4V", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('jOgdS')
        ]);
        const value = parcelRequire('908Fo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("jOgdS")
    ]).then(()=>parcelRequire('908Fo'));
}

});





parcelRegister("e2Wjq", function(module, exports) {

$parcel$export(module.exports, "SwitchToTooltipText", () => $3b9608e83b2ec487$export$c5ef4d14b7e18cbd);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $cYoMm = parcelRequire("cYoMm");

var $3H4nu = parcelRequire("3H4nu");
const $3b9608e83b2ec487$export$c5ef4d14b7e18cbd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cYoMm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3H4nu.default).yourAppsTooltip));

});
parcelRegister("cYoMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ddc20e5f453ddea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $4Ri7w = parcelRequire("4Ri7w");


var $j5Yzx = parcelRequire("j5Yzx");

var $bFzGY = parcelRequire("bFzGY");






























function $9ddc20e5f453ddea$var$fetchLanguageFile(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("8vUAO"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("7DrhD"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("2Jqov"));
        case 'en-GB':
            return (parcelRequire("fHf4F"));
        case 'en-ZZ':
            return (parcelRequire("6Bjdr"));
        case 'en-US':
        case 'en':
            return (parcelRequire("9sT9s"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("6GABC"));
        case 'et':
            return (parcelRequire("64NmE"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("d5xAJ"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("eOK86"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("dIaPq"));
        case 'is':
            return (parcelRequire("7j7RG"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("cTJpK"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("3bo0J"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("5RT21"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("gmoaq"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("jDh5C"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("hDbOd"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("iw3Cz"));
        case 'pt-PT':
            return (parcelRequire("bj4KB"));
        case 'ro':
            return (parcelRequire("8FXSk"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("IBzt4"));
        case 'sk':
            return (parcelRequire("1Oarw"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("6Bcln"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("8MFoA"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("hw5Eg"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("exXI6"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("7DYxT"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("50LuW"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("gSL3d"));
    }
    throw Error(`Unable to find translation for locale ${locale}`);
}
const $9ddc20e5f453ddea$var$SwitcherIntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    // Intl.Locale doesn't like underscores
    const [isLocaleLoaded, setIsLocaleLoaded] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [messages, setMessages] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const intlLocale = new Intl.Locale(locale.replace('_', '-'));
            try {
                const module = await $9ddc20e5f453ddea$var$fetchLanguageFile(intlLocale.toString());
                const newMessages = module.default || module;
                setMessages(newMessages);
                setIsLocaleLoaded(true);
            } catch (e) {
                // fail to download message and do nothing because UI will use default language (English) to render
                setIsLocaleLoaded(true);
                createAnalyticsEvent({
                    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                    action: 'not_loaded',
                    actionSubject: 'i18n',
                    attributes: {
                        country: intlLocale.region,
                        language: intlLocale.language
                    }
                }).fire((0, $j5Yzx.NAVIGATION_CHANNEL));
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        createAnalyticsEvent
    ]);
    // delay loading until we have attempted to load the locale data otherwise we can flick from English to the user's language
    if (!isLocaleLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Ri7w.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: locale,
        key: locale,
        messages: messages
    }, children);
};
var $9ddc20e5f453ddea$export$2e2bcd8739ae039 = $9ddc20e5f453ddea$var$SwitcherIntlProvider;

});
parcelRegister("8vUAO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aqhsn');
        const value = parcelRequire('7Qkoa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aqhsn").then(()=>parcelRequire('7Qkoa'));
}

});

parcelRegister("7DrhD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3pHPs');
        const value = parcelRequire('ekN5l');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3pHPs").then(()=>parcelRequire('ekN5l'));
}

});

parcelRegister("2Jqov", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2b5qE');
        const value = parcelRequire('eQO2A');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2b5qE").then(()=>parcelRequire('eQO2A'));
}

});

parcelRegister("fHf4F", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ivuwI');
        const value = parcelRequire('1cobe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ivuwI").then(()=>parcelRequire('1cobe'));
}

});

parcelRegister("6Bjdr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('igd1j');
        const value = parcelRequire('bUKY2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("igd1j").then(()=>parcelRequire('bUKY2'));
}

});

parcelRegister("9sT9s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('53bZV');
        const value = parcelRequire('XEvTK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("53bZV").then(()=>parcelRequire('XEvTK'));
}

});

parcelRegister("6GABC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2MkGS');
        const value = parcelRequire('cUjIw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2MkGS").then(()=>parcelRequire('cUjIw'));
}

});

parcelRegister("64NmE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('MQXqX');
        const value = parcelRequire('lSTMY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("MQXqX").then(()=>parcelRequire('lSTMY'));
}

});

parcelRegister("d5xAJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('40xCl');
        const value = parcelRequire('dC1iE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("40xCl").then(()=>parcelRequire('dC1iE'));
}

});

parcelRegister("eOK86", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gzXxa');
        const value = parcelRequire('l0kPp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gzXxa").then(()=>parcelRequire('l0kPp'));
}

});

parcelRegister("dIaPq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('glLKk');
        const value = parcelRequire('bH8AY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("glLKk").then(()=>parcelRequire('bH8AY'));
}

});

parcelRegister("7j7RG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5sqzW');
        const value = parcelRequire('d094J');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5sqzW").then(()=>parcelRequire('d094J'));
}

});

parcelRegister("cTJpK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iKDRF');
        const value = parcelRequire('8UEQA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iKDRF").then(()=>parcelRequire('8UEQA'));
}

});

parcelRegister("3bo0J", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('84lZb');
        const value = parcelRequire('hbpAq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("84lZb").then(()=>parcelRequire('hbpAq'));
}

});

parcelRegister("5RT21", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eVcss');
        const value = parcelRequire('jAi0j');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eVcss").then(()=>parcelRequire('jAi0j'));
}

});

parcelRegister("gmoaq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('54p1n');
        const value = parcelRequire('cF93q');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("54p1n").then(()=>parcelRequire('cF93q'));
}

});

parcelRegister("jDh5C", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('58KZx');
        const value = parcelRequire('lXje0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("58KZx").then(()=>parcelRequire('lXje0'));
}

});

parcelRegister("hDbOd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jmXVZ');
        const value = parcelRequire('kyvWY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jmXVZ").then(()=>parcelRequire('kyvWY'));
}

});

parcelRegister("iw3Cz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eAftG');
        const value = parcelRequire('e4rqi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eAftG").then(()=>parcelRequire('e4rqi'));
}

});

parcelRegister("bj4KB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1G2QD');
        const value = parcelRequire('alvVI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1G2QD").then(()=>parcelRequire('alvVI'));
}

});

parcelRegister("8FXSk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eAoHI');
        const value = parcelRequire('bfNIX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eAoHI").then(()=>parcelRequire('bfNIX'));
}

});

parcelRegister("IBzt4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b7qaz');
        const value = parcelRequire('3Alfp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b7qaz").then(()=>parcelRequire('3Alfp'));
}

});

parcelRegister("1Oarw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jjcu3');
        const value = parcelRequire('4VSJE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jjcu3").then(()=>parcelRequire('4VSJE'));
}

});

parcelRegister("6Bcln", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l4ZC2');
        const value = parcelRequire('fRuva');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l4ZC2").then(()=>parcelRequire('fRuva'));
}

});

parcelRegister("8MFoA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2GKjM');
        const value = parcelRequire('fi7ET');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2GKjM").then(()=>parcelRequire('fi7ET'));
}

});

parcelRegister("hw5Eg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fCtZm');
        const value = parcelRequire('4s6pb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fCtZm").then(()=>parcelRequire('4s6pb'));
}

});

parcelRegister("exXI6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gcxv0');
        const value = parcelRequire('4FnwN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gcxv0").then(()=>parcelRequire('4FnwN'));
}

});

parcelRegister("7DYxT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fFOcH');
        const value = parcelRequire('eGmuU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fFOcH").then(()=>parcelRequire('eGmuU'));
}

});

parcelRegister("50LuW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jg2EF');
        const value = parcelRequire('kGRuG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jg2EF").then(()=>parcelRequire('kGRuG'));
}

});

parcelRegister("gSL3d", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5UHzf');
        const value = parcelRequire('5VayU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5UHzf").then(()=>parcelRequire('5VayU'));
}

});


parcelRegister("3H4nu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8306605adbc1c709$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $8306605adbc1c709$var$messages = (0, $90IgZ.defineMessages)({
    autoProvisionedSwitcherItemConfluenceDescription: {
        id: 'fabric.atlassianSwitcher.autoProvisionedSwitcherItemDescription',
        defaultMessage: 'Create and link pages to your projects. Free with Jira',
        description: 'When a user gets auto-provisioned Confluence, this is the text that will be in the description of the new Switcher Item'
    },
    autoProvConfluenceUiUpdateExperimentDescription: {
        id: 'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription',
        defaultMessage: 'Document collaboration',
        description: 'When a user gets auto-provisioned Confluence, this is the text that will be in the description of the new Switcher Item'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    atlassianStartAriaLabel: {
        id: 'fabric.atlassianSwitcher.startAriaLabel',
        defaultMessage: 'Atlassian Start opens in a new tab',
        description: 'Aria-label for a link redirecting the user to the Start site'
    },
    switchTo: {
        id: 'fabric.atlassianSwitcher.switchTo',
        defaultMessage: 'Switch to',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    switchToTooltip: {
        id: 'fabric.atlassianSwitcher.switchToTooltip',
        defaultMessage: "Switch to\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    yourApps: {
        id: 'fabric.atlassianSwitcher.yourApps',
        defaultMessage: 'Your apps',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    yourAppsTooltip: {
        id: 'fabric.atlassianSwitcher.yourAppsTooltip',
        defaultMessage: "Your apps\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    jwmInactiveSwitcherWithJSWItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription',
        defaultMessage: 'Manage business projects, free with Jira Software',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated and they have a Jira Software License'
    },
    jwmInactiveSwitcherWithDefaultItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription',
        defaultMessage: 'Manage projects for business teams',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated'
    },
    organisationsLabel: {
        id: 'fabric.atlassianSwitcher.organisationsLabel',
        defaultMessage: 'Organisations',
        description: 'The label of organisation tab list'
    },
    switcherModalLabel: {
        id: 'fabric.atlassianSwitcher.modalLabel',
        defaultMessage: 'Atlassian App Switcher',
        description: 'The label of the switcher modal'
    },
    resizeBarLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarLabel',
        defaultMessage: '"Expand" or "Collapse" depending on state',
        description: 'The label of the resize bar'
    },
    resizeBarTooltipCollapsed: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipCollapsed',
        defaultMessage: 'Drag to resize{separator}Press to expand',
        description: 'The label of the resize bar tooltip when in collapsed state'
    },
    resizeBarTooltipExpanded: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipExpanded',
        defaultMessage: 'Drag to resize{separator}Press to collapse',
        description: 'The label of the resize bar tooltip when in expanded state'
    },
    resizeBarValueTextLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarValueTextLabel',
        defaultMessage: 'Width',
        description: 'The value text label of the resize bar'
    }
});
var $8306605adbc1c709$export$2e2bcd8739ae039 = $8306605adbc1c709$var$messages;

});


parcelRegister("2kDND", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherNudgeToolTip", () => $8f76832c5b69b010$export$c9637de5a973a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9WJJx = parcelRequire("9WJJx");

var $8Wt6T = parcelRequire("8Wt6T");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5ge6s = parcelRequire("5ge6s");

var $8pACs = parcelRequire("8pACs");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jD3pk = parcelRequire("jD3pk");

var $dxcfv = parcelRequire("dxcfv");
var $3e9vj = parcelRequire("3e9vj");

var $fxtgz = parcelRequire("fxtgz");

var $7iyWY = parcelRequire("7iyWY");

var $imn3p = parcelRequire("imn3p");
const $8f76832c5b69b010$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);
const $8f76832c5b69b010$var$StyledNudge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...restProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f76832c5b69b010$var$NudgeWrapper, {
        ...restProps,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));
const $8f76832c5b69b010$var$AppSwitcherNudge = ({ nudge: nudge, fallback: fallback, children: children, cloudId: cloudId, setUserProperty: setUserProperty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const [dismissed, setDismissed] = (0, $eUqFw.useState)(false);
    const { messageId: messageId } = nudge;
    const environment = (0, $3e9vj.useEnvironment)();
    const host = (0, $8pACs.getIdPHost)(environment);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const hideMessage = (0, $eUqFw.useCallback)((stop)=>{
        setDismissed(true);
        stop && stop();
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'endUserActivateSpotlight dismissed', {
            messageId: messageId
        });
    }, [
        createAnalyticsEvent,
        messageId
    ]);
    const handleFireDismissButtonClickEvent = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'endUserActivateSpotlightDismissButton', {
            messageId: messageId
        });
    }, [
        createAnalyticsEvent,
        messageId
    ]);
    const handleFireTourButtonClickEvent = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'endUserActivateSpotlightTourButton', {
            messageId: messageId
        });
    }, [
        createAnalyticsEvent,
        messageId
    ]);
    const nudgeSpotlightRef = (0, $eUqFw.useRef)({});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: messageId,
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f76832c5b69b010$var$CoordinationStopProvider, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "endUserActivateSpotlightNudge",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                messageId: messageId
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
            width: 276,
            hidden: dismissed,
            setHidden: ()=>hideMessage(stop),
            heading: formatMessage(nudge.heading),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                sourceName: "endUserActivateSpotlight",
                sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
            }, formatMessage(nudge.content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
                attributes: {
                    messageId: messageId
                }
            })),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                xcss: $8f76832c5b69b010$var$imgStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                alt: "",
                src: nudge.image
            })),
            actions: [
                {
                    text: formatMessage(nudge.primaryActionText),
                    onClick: ()=>{
                        handleFireTourButtonClickEvent();
                        nudge.primaryOnClickAction(host, orgId, cloudId);
                    }
                },
                {
                    text: formatMessage((0, $7iyWY.default).secondaryAction),
                    onClick: ()=>{
                        handleFireDismissButtonClickEvent();
                        hideMessage(stop);
                    }
                }
            ],
            position: "bottom-end",
            onOutsideClick: ()=>hideMessage(stop),
            nudgeTestId: `${messageId}-nudge`,
            cardTestId: `${messageId}-card`,
            showSpotlightCardOnFirstRender: false,
            onShow: ()=>setUserProperty(),
            nudge: $8f76832c5b69b010$var$StyledNudge,
            ref: nudgeSpotlightRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Wt6T.Pulse), {
            testId: `${messageId}-nudge-pulsing-border`,
            radius: 50,
            pulse: !dismissed,
            onFocus: ()=>{
                !dismissed && nudgeSpotlightRef.current?.toggleCardVisibility?.(true);
            }
        }, children)))));
};
const $8f76832c5b69b010$export$c9637de5a973a = ({ children: children, cloudId: cloudId })=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const [filteredNudges, setFilteredNudges] = (0, $eUqFw.useState)([]);
    (0, $eUqFw.useEffect)(()=>{
        Promise.all((0, $fxtgz.APP_SWITCHER_NUDGES).map((nudge)=>(0, $imn3p.getUserHaveSeenSpotlightProperty)(accountId, nudge.messageId))).then((properties)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const seenNudgeIds = properties.filter((nudgeId)=>nudgeId !== null);
            setFilteredNudges((0, $fxtgz.APP_SWITCHER_NUDGES).filter((nudge)=>!seenNudgeIds.includes(nudge.messageId)));
        });
    }, [
        accountId
    ]);
    return filteredNudges.reduce((acc, nudge)=>{
        const setUserProperty = ()=>(0, $imn3p.setUserHaveSeenSpotlightProperty)(accountId, nudge.messageId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f76832c5b69b010$var$AppSwitcherNudge, {
            nudge: nudge,
            fallback: acc,
            cloudId: cloudId,
            setUserProperty: setUserProperty
        }, children);
    }, children);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f76832c5b69b010$var$NudgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81nxw _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _shbiidpf _b9uxidpf _15q3idpf _uoh1idpf _1689idpf _1s2fidpf _egytidpf _yl3tidpf _1cmlidpf _hzefidpf _1q5lidpf _97vyidpf _2ynaidpf _1uv9idpf _5gciidpf _17fyidpf",
            __cmplp.className
        ])
    });
});
const $8f76832c5b69b010$var$imgStyles = (0, $1ZAYh.xcss)({
    height: '154px',
    width: '276px',
    marginBottom: 'space.negative.050'
});

});
parcelRegister("8pACs", function(module, exports) {

$parcel$export(module.exports, "isPublicGroupId", () => $43f152ca047b253f$export$5860837360ac4cd);
$parcel$export(module.exports, "isPublicGroup", () => $43f152ca047b253f$export$99c0f215c8fdf5ca);
$parcel$export(module.exports, "getIdPHost", () => $43f152ca047b253f$export$1b56207567e26604);
$parcel$export(module.exports, "getGroupUrl", () => $43f152ca047b253f$export$98a6e8ca23d7f4);
$parcel$export(module.exports, "getGroupAri", () => $43f152ca047b253f$export$2d3a61d72249749c);
$parcel$export(module.exports, "getUsersUrl", () => $43f152ca047b253f$export$3e300d9f367d7256);
$parcel$export(module.exports, "getLegacyGroupUrl", () => $43f152ca047b253f$export$2fbe649f181ef7e9);
$parcel$export(module.exports, "getLegacyUsersUrl", () => $43f152ca047b253f$export$70a213e9d2c62c44);

var $bW292 = parcelRequire("bW292");

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");
const $43f152ca047b253f$var$MAGIC_PUBLIC_ANYONE_GROUP_UUID = '00000000-0000-0000-0000-000000000000';
const $43f152ca047b253f$var$USER_BROWSER_URL = '/secure/admin/user/UserBrowser.jspa';
const $43f152ca047b253f$export$5860837360ac4cd = (groupId)=>groupId === $43f152ca047b253f$var$MAGIC_PUBLIC_ANYONE_GROUP_UUID;
const $43f152ca047b253f$export$99c0f215c8fdf5ca = (group)=>$43f152ca047b253f$export$5860837360ac4cd(group.groupId);
const $43f152ca047b253f$export$1b56207567e26604 = (environment)=>{
    if ((0, $1ybV0.ff)('olympus-50-fix-hardcoded-url_lsyvm')) return `https://${(0, $bW292.getATLContextDomain)('admin')}`;
    return environment === 'staging' || environment === 'dev' || environment === 'local' ? 'https://admin.stg.atlassian.com' : 'https://admin.atlassian.com';
};
const $43f152ca047b253f$export$98a6e8ca23d7f4 = (environment, orgId, group)=>{
    const host = $43f152ca047b253f$export$1b56207567e26604(environment);
    return orgId ? `${host}/o/${orgId}/groups/${group.groupId}` : undefined;
};
const $43f152ca047b253f$export$2d3a61d72249749c = (groupId)=>(0, $huI7r.createAri)({
        resourceOwner: 'identity',
        resourceType: 'group',
        resourceId: groupId
    });
const $43f152ca047b253f$export$3e300d9f367d7256 = (environment, orgId)=>{
    const host = $43f152ca047b253f$export$1b56207567e26604(environment);
    return orgId ? `${host}/o/${orgId}/users?status=ACTIVE` : undefined;
};
const $43f152ca047b253f$export$2fbe649f181ef7e9 = (group)=>`${$43f152ca047b253f$var$USER_BROWSER_URL}?group=${group.name}`;
const $43f152ca047b253f$export$70a213e9d2c62c44 = ()=>$43f152ca047b253f$var$USER_BROWSER_URL;

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("fxtgz", function(module, exports) {

$parcel$export(module.exports, "APP_SWITCHER_NUDGES", () => $25e94b22e3a8231a$export$5871aa9763d9526b);

var $hEBIK = parcelRequire("hEBIK");
var $eLbjs = parcelRequire("eLbjs");
var $cXpna = parcelRequire("cXpna");

var $7iyWY = parcelRequire("7iyWY");
const $25e94b22e3a8231a$export$5871aa9763d9526b = [
    {
        messageId: 'jsw-end-user-activated-jpd_v2',
        heading: (0, $7iyWY.default).heading,
        content: (0, $7iyWY.default).jpdContent,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($eLbjs))),
        primaryActionText: (0, $7iyWY.default).jpdPrimaryButtonText,
        primaryOnClickAction: (host, orgId, cloudId)=>{
            window.open(`${host}/o/${orgId}/products/jira-product-discovery/${cloudId}`, '_blank');
        }
    },
    {
        messageId: 'jsw-end-user-activated-jsm_v2',
        heading: (0, $7iyWY.default).heading,
        content: (0, $7iyWY.default).jsmContent,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cXpna))),
        primaryActionText: (0, $7iyWY.default).confluenceAndJsmPrimaryButtonText,
        primaryOnClickAction: ()=>window.open('/secure/WelcomeToSD.jspa?decorator=jsd-onboarding', '_blank')
    },
    {
        messageId: 'jsw-end-user-activated-confluence_v2',
        heading: (0, $7iyWY.default).heading,
        content: (0, $7iyWY.default).confluenceContent,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($hEBIK))),
        primaryActionText: (0, $7iyWY.default).confluenceAndJsmPrimaryButtonText,
        primaryOnClickAction: ()=>window.open('/wiki/welcome', '_blank')
    }
];

});
parcelRegister("hEBIK", function(module, exports) {
module.exports = new URL("confluence-try-end-learn.087e0017.svg", import.meta.url).toString();

});

parcelRegister("eLbjs", function(module, exports) {
module.exports = new URL("jpd-try-end-learn.db348fdd.svg", import.meta.url).toString();

});

parcelRegister("cXpna", function(module, exports) {
module.exports = new URL("jsm-try-end-learn.07226de3.svg", import.meta.url).toString();

});

parcelRegister("7iyWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1d56a4780a8d0f0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e1d56a4780a8d0f0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.heading",
        "defaultMessage": "New product added"
    },
    confluenceContent: {
        "id": "atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.confluence-content",
        "defaultMessage": "Someone in your team has just started using Confluence. It's been added to your site for free."
    },
    jsmContent: {
        "id": "atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.jsm-content",
        "defaultMessage": "Someone in your team has just started using Jira Service Management. It's been added to your site for free."
    },
    jpdContent: {
        "id": "atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.jpd-content",
        "defaultMessage": "Someone in your team has just started using Jira Product Discovery. It's been added to your site for free."
    },
    confluenceAndJsmPrimaryButtonText: {
        "id": "atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.confluence-and-jsm-primary-button-text",
        "defaultMessage": "Take a tour"
    },
    jpdPrimaryButtonText: {
        "id": "atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.jpd-primary-button-text",
        "defaultMessage": "Show details"
    },
    secondaryAction: {
        "id": "atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.secondary-action",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("imn3p", function(module, exports) {

$parcel$export(module.exports, "getUserHaveSeenSpotlightProperty", () => $7e63839d05333741$export$ffafc31d2f63ded4);
$parcel$export(module.exports, "setUserHaveSeenSpotlightProperty", () => $7e63839d05333741$export$7285a85b75b6a9b9);

var $48bs8 = parcelRequire("48bs8");

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");

var $6vrw7 = parcelRequire("6vrw7");
const $7e63839d05333741$export$ffafc31d2f63ded4 = (accountId, messageId)=>{
    const propertyKey = `${messageId}-seen`;
    if (accountId) return (0, $48bs8.getUserProperty)((0, $6vrw7.toBaseUrl)(''), accountId, propertyKey) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .then((res)=>res).catch((error)=>{
        // If we can't find key, we know user never seen the spotlight
        if (error.statusCode === 404) return null;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('getUserHaveSeenSpotlightProperty', `Error reading data from getUserHaveSeenSpotlightProperty with property key ${propertyKey}`, error);
        return null;
    });
    return new Promise((resolve)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('getUserHaveSeenSpotlightProperty', `Failed to get getUserHaveSeenSpotlightProperty with property key ${propertyKey} - no accountId`);
        return resolve(null);
    });
};
const $7e63839d05333741$export$7285a85b75b6a9b9 = (accountId, messageId)=>{
    const propertyKey = `${messageId}-seen`;
    if (accountId) return (0, $48bs8.setUserProperties)((0, $6vrw7.toBaseUrl)(''), accountId, propertyKey, JSON.stringify(messageId)).then((res)=>{
        if (res.ok) return res;
        return res.text().then((errResp)=>{
            throw new (0, $7EhAs.default)(res.status, errResp);
        });
    }).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('setUserHaveSeenSpotlightProperty', `Failed to update the value in setUserHaveSeenSpotlightProperty with property key ${propertyKey}`, error);
        throw new Error('Failed to save');
    });
    return new Promise(()=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('setUserHaveSeenSpotlightProperty', `Failed to update the value in setUserHaveSeenSpotlightProperty with property key ${propertyKey} - no accountId`);
        throw new Error('No AccountId');
    });
};

});


parcelRegister("eSDUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3bfd0e532518cb0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iMRBA = parcelRequire("iMRBA");

var $2ziLQ = parcelRequire("2ziLQ");
const $d3bfd0e532518cb0$var$AppSwitcherNav4IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5 7C5 5.89543 5.89543 5 7 5H9C10.1046 5 11 5.89543 11 7V9C11 10.1046 10.1046 11 9 11H7C5.89543 11 5 10.1046 5 9V7ZM7 6.5C6.72386 6.5 6.5 6.72386 6.5 7V9C6.5 9.27614 6.72386 9.5 7 9.5H9C9.27614 9.5 9.5 9.27614 9.5 9V7C9.5 6.72386 9.27614 6.5 9 6.5H7ZM13 7C13 5.89543 13.8954 5 15 5H17C18.1046 5 19 5.89543 19 7V9C19 10.1046 18.1046 11 17 11H15C13.8954 11 13 10.1046 13 9V7ZM15 6.5C14.7239 6.5 14.5 6.72386 14.5 7V9C14.5 9.27614 14.7239 9.5 15 9.5H17C17.2761 9.5 17.5 9.27614 17.5 9V7C17.5 6.72386 17.2761 6.5 17 6.5H15ZM5 15C5 13.8954 5.89543 13 7 13H9C10.1046 13 11 13.8954 11 15V17C11 18.1046 10.1046 19 9 19H7C5.89543 19 5 18.1046 5 17V15ZM7 14.5C6.72386 14.5 6.5 14.7239 6.5 15V17C6.5 17.2761 6.72386 17.5 7 17.5H9C9.27614 17.5 9.5 17.2761 9.5 17V15C9.5 14.7239 9.27614 14.5 9 14.5H7ZM13 15C13 13.8954 13.8954 13 15 13H17C18.1046 13 19 13.8954 19 15V17C19 18.1046 18.1046 19 17 19H15C13.8954 19 13 18.1046 13 17V15ZM15 14.5C14.7239 14.5 14.5 14.7239 14.5 15V17C14.5 17.2761 14.7239 17.5 15 17.5H17C17.2761 17.5 17.5 17.2761 17.5 17V15C17.5 14.7239 17.2761 14.5 17 14.5H15Z",
        fill: "currentColor"
    }));
const $d3bfd0e532518cb0$var$AppSwitcherNav4Icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $d3bfd0e532518cb0$var$AppSwitcherNav4IconGlyph,
        ...props
    });
const $d3bfd0e532518cb0$var$AppSwitcherNav4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3bfd0e532518cb0$var$AppSwitcherNav4Icon, {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        tooltip: tooltip,
        ref: ref,
        ...iconButtonProps
    });
});
var $d3bfd0e532518cb0$export$2e2bcd8739ae039 = $d3bfd0e532518cb0$var$AppSwitcherNav4;

});

parcelRegister("gATOG", function(module, exports) {

$parcel$export(module.exports, "StyledSwitcherContainer", () => $10656c8b65c9f4ad$export$a64c5aced5ec4967);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lcnyw = parcelRequire("lcnyw");
const $10656c8b65c9f4ad$var$gridSize = (0, $lcnyw.gridSize)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10656c8b65c9f4ad$var$SwitcherWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l54ef",
            __cmplp.className
        ])
    });
});
const $10656c8b65c9f4ad$var$SKELETON_ITEM_COUNT = 3;
const $10656c8b65c9f4ad$var$skeletonItemHeight = 32 + $10656c8b65c9f4ad$var$gridSize * 4;
const $10656c8b65c9f4ad$var$totalSkeletonItemsHeight = $10656c8b65c9f4ad$var$skeletonItemHeight * $10656c8b65c9f4ad$var$SKELETON_ITEM_COUNT;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10656c8b65c9f4ad$var$SwitcherContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1tkeuuw1",
            __cmplp.className
        ])
    });
});
const $10656c8b65c9f4ad$export$a64c5aced5ec4967 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10656c8b65c9f4ad$var$SwitcherWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10656c8b65c9f4ad$var$SwitcherContent, null, children));

});



parcelRegister("77gCP", function(module, exports) {

$parcel$export(module.exports, "AtlassianSwitcherIntegration", () => $2c4dff2420821a75$export$c9b4f2d910f885a4);

var $eUqFw = parcelRequire("eUqFw");

var $fbeIa = parcelRequire("fbeIa");

var $jkH4Q = parcelRequire("jkH4Q");

var $aw5Sy = parcelRequire("aw5Sy");

var $jWuk1 = parcelRequire("jWuk1");

var $7NQrJ = parcelRequire("7NQrJ");

var $1ybV0 = parcelRequire("1ybV0");

var $4vWQL = parcelRequire("4vWQL");
var $fzPXJ = parcelRequire("fzPXJ");

var $2MjDU = parcelRequire("2MjDU");
var $6YtCU = parcelRequire("6YtCU");

var $cPEpP = parcelRequire("cPEpP");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $gd0Sp = parcelRequire("gd0Sp");

var $k09VB = parcelRequire("k09VB");

var $858Yq = parcelRequire("858Yq");

var $7Ekqe = parcelRequire("7Ekqe");
const $2c4dff2420821a75$var$isEnrolledInUPaasRecommendationForInstance = ()=>(0, $fzPXJ.getFeatureFlagValue)('appswitcher.ranking.jsw.xflow').value !== 'not-enrolled';
const $2c4dff2420821a75$var$UPAAS_RECOMMENDATIONS_FLAG = 'appswitcher.ranking.jsw.xflow';
const $2c4dff2420821a75$var$getUPaasRecommendationForInstance = ()=>({
        [$2c4dff2420821a75$var$UPAAS_RECOMMENDATIONS_FLAG]: (0, $fzPXJ.getFeatureFlagValue)('appswitcher.ranking.jsw.xflow').value || 'not-enrolled'
    });
const $2c4dff2420821a75$var$fireUPaasRecommendationExposureEvent = ()=>{
    const upaasRecommendationFeatureFlagValue = (0, $fzPXJ.getFeatureFlagValue)('appswitcher.ranking.jsw.xflow');
    (0, $4vWQL.fireExposureEvent)($2c4dff2420821a75$var$UPAAS_RECOMMENDATIONS_FLAG, upaasRecommendationFeatureFlagValue);
};
const $2c4dff2420821a75$var$JIRA_PRODUCT = 'jira';
const $2c4dff2420821a75$var$CONFLUENCE = 'CONFLUENCE';
const $2c4dff2420821a75$export$c9b4f2d910f885a4 = ({ isOpen: isOpen, onOpen: onOpen, onClose: onClose, TenantContextSubscriber: TenantContextSubscriber = (0, $gd0Sp.TenantContextSubscriber), IntegrationViewRenderer: IntegrationViewRenderer, BeforeComponent: BeforeComponent = ()=>null })=>{
    (0, $7NQrJ.useCrossJoinNudgeExperiment)();
    if (isOpen && $2c4dff2420821a75$var$isEnrolledInUPaasRecommendationForInstance()) $2c4dff2420821a75$var$fireUPaasRecommendationExposureEvent();
    const { isLoading: isLoading, isSlackIntegrationEnabled: isSlackIntegrationEnabled, isSlackIntegrationConnected: isSlackIntegrationConnected } = (0, $6YtCU.useFetchSlackStatus)(!isOpen);
    const isSlackDiscoveryEnabled = !isLoading && isSlackIntegrationEnabled && !isSlackIntegrationConnected;
    const crossFlow = (0, $fbeIa.useCrossFlow)();
    const postOfficeContext = (0, $eUqFw.useContext)((0, $k09VB.PostOfficeContext));
    (0, $eUqFw.useEffect)(()=>{}, [
        postOfficeContext
    ]);
    const slackDiscoveryClickHandler = (0, $eUqFw.useCallback)(()=>{
        (0, $2MjDU.openSlackIntegrationPopup)('switcher');
        onClose();
    }, [
        onClose
    ]);
    const onTriggerXFlow = (0, $eUqFw.useCallback)((targetProduct)=>{
        crossFlow.isEnabled && crossFlow.api.open({
            journey: (0, $fbeIa.Journeys).DECIDE,
            targetProduct: targetProduct,
            sourceComponent: 'atlassian-switcher',
            sourceContext: 'recommendation',
            experimentalOptions: {
                isCrossSell: true
            }
        });
        onClose();
    }, [
        crossFlow,
        onClose
    ]);
    const onDiscoverMoreClicked = (0, $eUqFw.useCallback)(()=>{
        crossFlow.isEnabled && crossFlow.api.open({
            sourceComponent: 'atlassian-switcher',
            sourceContext: 'more',
            journey: (0, $fbeIa.Journeys).DISCOVER
        });
        onClose();
    }, [
        crossFlow,
        onClose
    ]);
    const origin = new (0, $jkH4Q.default)({
        product: $2c4dff2420821a75$var$JIRA_PRODUCT
    });
    const project = (0, $cPEpP.useProject)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Ekqe.DiscoverySurfaceContextCollector), {
        isOpen: isOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TenantContextSubscriber, null, ({ tenantContext: tenantContext })=>{
        if (!tenantContext) return null;
        const { cloudId: cloudId, locale: locale } = tenantContext;
        let isDiscoverySurfaceEnabled;
        let ffEnableOverFiftyUsers;
        let ffAllLocales;
        if (locale.startsWith('en')) {
            const val = (0, $1ybV0.ff)('jira.frontend.atlassian-switcher.discovery-sdk');
            isDiscoverySurfaceEnabled = val;
            ffEnableOverFiftyUsers = val;
            ffAllLocales = undefined;
        } else {
            const val = (0, $1ybV0.ff)('jira.app-recommendations.discovery-sdk.all-locale');
            isDiscoverySurfaceEnabled = val;
            ffAllLocales = val;
            ffEnableOverFiftyUsers = undefined;
        }
        const switcherProps = {
            cloudId: cloudId,
            product: $2c4dff2420821a75$var$JIRA_PRODUCT,
            subproduct: project.data?.type,
            triggerXFlow: onTriggerXFlow,
            customizeLinks: ()=>({
                    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type. | TS7006 - Parameter 'product' implicitly has an 'any' type.
                    mapUrl: (url, product)=>product === $2c4dff2420821a75$var$CONFLUENCE ? origin.addToUrl(url) : url,
                    // @ts-expect-error - TS7006 - Parameter 'product' implicitly has an 'any' type.
                    getExtendedAnalyticsAttributes: (product)=>product === $2c4dff2420821a75$var$CONFLUENCE ? origin.toAnalyticsAttributes() : {}
                }),
            recommendationsFeatureFlags: {
                ...$2c4dff2420821a75$var$getUPaasRecommendationForInstance()
            },
            onDiscoverMoreClicked: crossFlow.isEnabled ? onDiscoverMoreClicked : null,
            joinableSitesDataProvider: null,
            isSlackDiscoveryEnabled: isSlackDiscoveryEnabled,
            slackDiscoveryClickHandler: isSlackDiscoveryEnabled && slackDiscoveryClickHandler,
            isUFOEnabled: (0, $1ybV0.ff)('jira.frontend.atlassian-switcher.enable-ufo'),
            discoverySurface: isDiscoverySurfaceEnabled ? (0, $7Ekqe.DiscoverySurface) : undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "atlassianSwitcherDiscoverSection",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            attributes: {
                discoverySurfaceCohort: {
                    value: isDiscoverySurfaceEnabled
                }
            }
        }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                availableProducts: isSlackIntegrationEnabled && !isSlackIntegrationConnected ? [
                    'slackForAtlassianApp'
                ] : []
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
            data: {
                source: 'atlassianSwitcher'
            }
        }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "section",
            actionSubjectId: "switcherDiscoveryExposure",
            attributes: {
                locale: locale,
                featureFlags: {
                    ffEnableOverFiftyUsers: ffEnableOverFiftyUsers,
                    ffAllLocales: ffAllLocales
                }
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BeforeComponent, {
            cloudId: cloudId,
            onOpen: onOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IntegrationViewRenderer, null, ({ IntegrationView: IntegrationView, atlassianSwitcherCustomizationProps: atlassianSwitcherCustomizationProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IntegrationView, {
                isOpen: isOpen,
                onOpen: onOpen,
                onClose: onClose,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1)))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $858Yq.AtlassianSwitcherLoader), {
                ...switcherProps,
                ...atlassianSwitcherCustomizationProps
            }))));
    }));
};
var $2c4dff2420821a75$export$2e2bcd8739ae039 = $2c4dff2420821a75$export$c9b4f2d910f885a4;

});
parcelRegister("7NQrJ", function(module, exports) {

$parcel$export(module.exports, "useCrossJoinNudgeExperiment", () => $9e3a4b505b4ce8af$export$c30730c5d28616da);

var $eUqFw = parcelRequire("eUqFw");

var $dFBS3 = parcelRequire("dFBS3");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $45ckx = parcelRequire("45ckx");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");
var $j3FUN = parcelRequire("j3FUN");

var $dhGdR = parcelRequire("dhGdR");

var $kBSDj = parcelRequire("kBSDj");

var $8ISXc = parcelRequire("8ISXc");

var $bzek1 = parcelRequire("bzek1");

var $kv4Xz = parcelRequire("kv4Xz");

var $dhiCb = parcelRequire("dhiCb");

var $dm1Hz = parcelRequire("dm1Hz");

var $3eucn = parcelRequire("3eucn");

var $ksq0I = parcelRequire("ksq0I");

var $1fKAJ = parcelRequire("1fKAJ");

var $eCji9 = parcelRequire("eCji9");

var $7ILIy = parcelRequire("7ILIy");

var $cQtop = parcelRequire("cQtop");

var $btURX = parcelRequire("btURX");

var $6GdGo = parcelRequire("6GdGo");

var $i7z2u = parcelRequire("i7z2u");
const $9e3a4b505b4ce8af$var$MAX_NUMBER_OF_COLLABORATORS = 5;
const $9e3a4b505b4ce8af$export$c30730c5d28616da = ()=>{
    const sessionId = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))());
    const cloudId = (0, $dWLk9.useCloudId)();
    const fireExposure = (0, $8ISXc.useFeatureExposed)();
    const fireV2bExposure = (0, $8ISXc.useFeatureExposedForV2b)();
    const getNudgeRecommendations = (0, $3eucn.useNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const hasAccessToConfluence = (0, $dhiCb.useConfluenceAccessCheck)(cloudId);
    const isRequestCapabilitiesEligible = (0, $1fKAJ.useConfluenceRequestCapabilitiesCheck)(cloudId);
    const isSite7DaysOlder = (0, $eCji9.useSiteEligibilityCheck)(cloudId);
    const getCollaborators = (0, $bzek1.useUsersFromCollaborationGraph)(cloudId);
    const showRequestAccessPromptFlag = (0, $cQtop.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $btURX.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $7ILIy.useRequestAccessErrorFlag)();
    const requestAccess = (0, $ksq0I.useConfluenceRequestAccess)();
    const { getNudgeState: getNudgeStateV1, setNudgeDismissed: setNudgeDismissedV1 } = (0, $kv4Xz.useNudgeStateV1)();
    const { getNudgeState: getNudgeStateV2a, setNudgeDismissed: setNudgeDismissedV2a } = (0, $kv4Xz.useNudgeStateV2a)();
    const { push: push } = (0, $45ckx.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const userId = (0, $dxcfv.useAccountId)() || '';
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    (0, $eUqFw.useEffect)(()=>{
        const runExperiment = async ()=>{
            if (!(0, $eI5EY.fg)('cross_join_nudges_gate')) return;
            try {
                if (!licensedProducts.confluence) {
                    fireExposure('NO_CONFLUENCE_LICENSE');
                    return;
                }
                if ((0, $kBSDj.isFeatureVisited)()) return;
                if (await hasAccessToConfluence()) {
                    fireExposure('ALREADY_HAVE_ACCESS');
                    return;
                }
                if (!await isRequestCapabilitiesEligible()) {
                    fireExposure('NOT_ELIGIBLE_FOR_REQUEST_ACCESS');
                    return;
                }
                if (!await isSite7DaysOlder()) {
                    fireExposure('NEW_SITE_LESS_THAN_7_DAYS_OLD');
                    return;
                }
                const onSubmit = async ()=>{
                    try {
                        const accessStatus = await requestAccess();
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                        else showErrorFlag();
                    } catch  {
                        showErrorFlag();
                    }
                };
                const collaborators = await getCollaborators();
                if (!collaborators || collaborators.length === 0) {
                    fireExposure('NO_COLLABORATORS_FOUND');
                    const isEligibleForV2b = (0, $79xbN.expValEquals)('cross-join-nudge-via-contextual-bandit-v2b', 'cohort', 'variation');
                    fireV2bExposure();
                    if (!isEligibleForV2b) // no-collab and not in v2b variation
                    return;
                    const entityId = await getNudgeRecommendations();
                    if (await getNudgeStateV2a() === 'DISMISSED') return;
                    const featureVisitedCount = await (0, $kBSDj.getFeatureVisitedCount)(userId);
                    showRequestAccessPromptFlag({
                        isV2b: true,
                        entityId: entityId,
                        users: [],
                        onSubmit: onSubmit,
                        onOptout: setNudgeDismissedV2a,
                        snoozeFor30Days: (0, $kBSDj.snoozeFeatureFor30Days),
                        sessionId: sessionId.current,
                        featureVisitedCount: featureVisitedCount
                    });
                    (0, $kBSDj.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1);
                } else {
                    const confluenceUsers = await (0, $dm1Hz.getConfluenceUsers)(collaborators, cloudId);
                    if (confluenceUsers.length === 0) {
                        fireExposure('COLLABORATORS_HAVE_NO_ACCESS');
                        return;
                    }
                    const users = confluenceUsers.slice(0, $9e3a4b505b4ce8af$var$MAX_NUMBER_OF_COLLABORATORS);
                    const isEligibleForV2a = (0, $79xbN.expValEquals)('cross_join_nudges_confluence_v2a', 'cohort', 'variation');
                    // fire manual exposure as it passed all common eligibility checks
                    fireExposure('ELIGIBLE');
                    // check if the user is eligible for v2a
                    if (isEligibleForV2a) {
                        if (await getNudgeStateV2a() === 'DISMISSED') return;
                        const featureVisitedCount = await (0, $kBSDj.getFeatureVisitedCount)(userId);
                        showRequestAccessPromptFlag({
                            isV2a: true,
                            users: users,
                            onSubmit: onSubmit,
                            onOptout: setNudgeDismissedV2a,
                            snoozeFor30Days: (0, $kBSDj.snoozeFeatureFor30Days),
                            featureVisitedCount: featureVisitedCount
                        });
                        (0, $kBSDj.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1);
                    // else check if the user is eligible for v1 (has been rolled out to 100%)
                    } else {
                        if ((0, $79xbN.expValEquals)('cross_join_nudges_confluence', 'cohort', 'control')) return;
                        if (await getNudgeStateV1() === 'DISMISSED') return;
                        showRequestAccessPromptFlag({
                            users: users,
                            onSubmit: onSubmit,
                            onOptout: setNudgeDismissedV1,
                            snoozeFor30Days: (0, $dhGdR.noop)
                        });
                    }
                }
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useCrossJoinNudgesExperiment',
                        packageName: 'jiraCrossJoinNudges'
                    },
                    attributes: {
                        cloudId: cloudId
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        runExperiment();
    }, [
        cloudId,
        createAnalyticsEvent,
        fireExposure,
        getCollaborators,
        getNudgeStateV1,
        getNudgeStateV2a,
        getNudgeRecommendations,
        hasAccessToConfluence,
        isRequestCapabilitiesEligible,
        isSite7DaysOlder,
        push,
        requestAccess,
        setNudgeDismissedV1,
        setNudgeDismissedV2a,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        fireV2bExposure,
        userId,
        licensedProducts.confluence
    ]);
};
const $9e3a4b505b4ce8af$var$CrossJoinNudgeYourWorkWithChecks = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const trackIneligibility = (0, $8ISXc.useIneligibilityAnalytics)();
    const hasAccessToConfluence = (0, $dhiCb.useConfluenceAccessCheck)(cloudId);
    const isRequestCapabilitiesEligible = (0, $1fKAJ.useConfluenceRequestCapabilitiesCheck)(cloudId);
    const isSite7DaysOlder = (0, $eCji9.useSiteEligibilityCheck)(cloudId);
    const showSuccessFlag = (0, $btURX.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $7ILIy.useRequestAccessErrorFlag)();
    const requestAccess = (0, $ksq0I.useConfluenceRequestAccess)('crossJoinNudgesYourWork');
    const getCollaborators = (0, $bzek1.useUsersFromCollaborationGraph)(cloudId);
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $kv4Xz.useNudgeStateYourWork)();
    const { snoozeFor7Days: snoozeFor7Days, snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount, isVisited: isVisited } = (0, $kBSDj.useSnooze)('cross.join.nudges.your.work');
    const { push: push } = (0, $45ckx.useRouterActions)();
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [featureVisitedCount, setFeatureVisitedCount] = (0, $eUqFw.useState)(0);
    const [isEligible, setIsEligible] = (0, $eUqFw.useState)(false);
    const [collaborators, setCollaborators] = (0, $eUqFw.useState)([]);
    const [isDismissed, setIsDismissed] = (0, $eUqFw.useState)(false);
    const accountId = (0, $dxcfv.useAccountId)() || '';
    (0, $eUqFw.useEffect)(()=>{
        const checkEligibility = async ()=>{
            try {
                if (!(0, $eI5EY.fg)('team_expansion_cross_join_nudge_jira_your_work')) return;
                if (!licensedProducts.confluence) {
                    trackIneligibility('NO_CONFLUENCE_LICENSE');
                    return;
                }
                if (isVisited()) {
                    setIsEligible(false);
                    return;
                }
                if (await getNudgeState() === 'DISMISSED') return;
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluenceAccessCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                if (await hasAccessToConfluence()) {
                    trackIneligibility('ALREADY_HAVE_ACCESS');
                    return;
                }
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                if (!await isRequestCapabilitiesEligible()) {
                    trackIneligibility('NOT_ELIGIBLE_FOR_REQUEST_ACCESS');
                    return;
                }
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'siteAgeCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                if (!await isSite7DaysOlder()) {
                    trackIneligibility('NEW_SITE_LESS_THAN_7_DAYS_OLD');
                    return;
                }
                const users = await getCollaborators();
                if (!!users && users.length !== 0) {
                    const confluenceUsers = await (0, $dm1Hz.getConfluenceUsers)(users, cloudId);
                    setCollaborators(confluenceUsers);
                }
                const visitedCount = await getVisitedCount();
                setFeatureVisitedCount(visitedCount);
                setIsEligible((0, $79xbN.expValEquals)('cross_join_nudge_jira_your_work', 'cohort', 'variation'));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'CrossJoinNudgeYourWork',
                        packageName: 'jiraCrossJoinNudges'
                    },
                    attributes: {
                        cloudId: cloudId
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        checkEligibility();
    }, [
        accountId,
        cloudId,
        getCollaborators,
        getNudgeState,
        getVisitedCount,
        hasAccessToConfluence,
        isRequestCapabilitiesEligible,
        isSite7DaysOlder,
        isVisited,
        licensedProducts.confluence,
        trackIneligibility,
        createAnalyticsEvent
    ]);
    const onDismiss = (0, $eUqFw.useCallback)(()=>{
        snoozeFor7Days();
        increaseVisitedCount(featureVisitedCount);
        setIsDismissed(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard dismissed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        featureVisitedCount,
        increaseVisitedCount,
        snoozeFor7Days
    ]);
    const onSubmit = (0, $eUqFw.useCallback)(async ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard submitted', 'crossJoinNudges');
        try {
            const accessStatus = await requestAccess();
            if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
            else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') {
                showSuccessFlag();
                setIsDismissed(true);
            } else showErrorFlag();
        } catch  {
            showErrorFlag();
        }
    }, [
        createAnalyticsEvent,
        push,
        requestAccess,
        showErrorFlag,
        showSuccessFlag
    ]);
    const onSnooze = (0, $eUqFw.useCallback)(()=>{
        snoozeFor30Days();
        increaseVisitedCount(featureVisitedCount + 1);
        setIsDismissed(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard snoozed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        featureVisitedCount,
        increaseVisitedCount,
        snoozeFor30Days
    ]);
    const onOptOut = (0, $eUqFw.useCallback)(()=>{
        setNudgeDismissed();
        setIsDismissed(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard optedOut', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        setNudgeDismissed
    ]);
    let secondaryAction;
    switch(featureVisitedCount){
        case 0:
            secondaryAction = 'none';
            break;
        case 1:
            secondaryAction = 'snooze';
            break;
        default:
            secondaryAction = 'opt-out';
    }
    const onRender = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard shown', 'crossJoinNudges', {
            secondaryAction: secondaryAction,
            collaborators: collaborators.length
        });
    }, [
        collaborators.length,
        createAnalyticsEvent,
        secondaryAction
    ]);
    const shouldShowCard = !isDismissed && isEligible;
    return shouldShowCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6GdGo.CrossJoinNudgeYourWorkCard), {
        collaborators: collaborators,
        onRender: onRender,
        onDismiss: secondaryAction === 'none' ? onDismiss : onSnooze,
        onSubmit: onSubmit,
        onSnooze: secondaryAction === 'snooze' ? onSnooze : undefined,
        onOptOut: secondaryAction === 'opt-out' ? onOptOut : undefined
    }) : null;
};
const $9e3a4b505b4ce8af$export$eb1ab086083a0ea3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i7z2u.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e3a4b505b4ce8af$var$CrossJoinNudgeYourWorkWithChecks, null));

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("dhGdR", function(module, exports) {

$parcel$export(module.exports, "noop", () => $b3243f0b71270516$export$8793edee2d425525);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b3243f0b71270516$export$8793edee2d425525 = ()=>{};

});

parcelRegister("kBSDj", function(module, exports) {

$parcel$export(module.exports, "isFeatureVisited", () => $f0fa987b4412ed58$export$262c003deb93a450);
$parcel$export(module.exports, "snoozeFeatureFor30Days", () => $f0fa987b4412ed58$export$788659dbff920e5f);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $f0fa987b4412ed58$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $f0fa987b4412ed58$export$41554dcbb74e65ef);
$parcel$export(module.exports, "useSnooze", () => $f0fa987b4412ed58$export$26ba987533188b38);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");

var $dxcfv = parcelRequire("dxcfv");

var $kQJl1 = parcelRequire("kQJl1");
const $f0fa987b4412ed58$var$CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY = 'cross.join.nudges.confluence.visited';
const $f0fa987b4412ed58$var$VISITED_COUNT_KEY = 'CROSS_JOIN_NUDGE_CONFLUENCE_VISITED_COUNT';
const $f0fa987b4412ed58$var$SNOOZE_DAYS_AFTER_FEATURE_IGNORED = 7;
const $f0fa987b4412ed58$var$SNOOZE_DAYS_AFTER_NOT_INTERESTED_CLICKED = 30;
const $f0fa987b4412ed58$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $f0fa987b4412ed58$var$crossJoinNudgeVisitedCache = (0, $aZaPn.createLocalStorageProvider)('cross-join-nudge-visited');
const $f0fa987b4412ed58$export$262c003deb93a450 = ()=>{
    try {
        if ($f0fa987b4412ed58$var$getFeatureVisited()) return true;
        $f0fa987b4412ed58$export$7a91674e4b755c4b();
        if (!$f0fa987b4412ed58$var$getFeatureVisited()) {
            (0, $guiFP.default)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $f0fa987b4412ed58$var$setFeatureVisited = (numOfDaysSnoozed, key = $f0fa987b4412ed58$var$CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY)=>{
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $f0fa987b4412ed58$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $f0fa987b4412ed58$var$crossJoinNudgeVisitedCache.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $f0fa987b4412ed58$export$7a91674e4b755c4b = (key = $f0fa987b4412ed58$var$CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY)=>{
    $f0fa987b4412ed58$var$setFeatureVisited($f0fa987b4412ed58$var$SNOOZE_DAYS_AFTER_FEATURE_IGNORED, key);
};
const $f0fa987b4412ed58$export$788659dbff920e5f = (key = $f0fa987b4412ed58$var$CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY)=>{
    $f0fa987b4412ed58$var$setFeatureVisited($f0fa987b4412ed58$var$SNOOZE_DAYS_AFTER_NOT_INTERESTED_CLICKED, key);
};
const $f0fa987b4412ed58$var$getFeatureVisited = (key = $f0fa987b4412ed58$var$CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY)=>{
    const snoozeUntilTimestampString = $f0fa987b4412ed58$var$crossJoinNudgeVisitedCache.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $f0fa987b4412ed58$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $f0fa987b4412ed58$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $kQJl1.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $f0fa987b4412ed58$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $f0fa987b4412ed58$var$VISITED_COUNT_KEY)=>{
    await (0, $kQJl1.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};
const $f0fa987b4412ed58$export$26ba987533188b38 = (key)=>{
    const accountId = (0, $dxcfv.useAccountId)() || '';
    const countKey = `${key}.count`;
    return (0, $eUqFw.useMemo)(()=>({
            snoozeFor7Days: ()=>$f0fa987b4412ed58$export$7a91674e4b755c4b(key),
            snoozeFor30Days: ()=>$f0fa987b4412ed58$export$788659dbff920e5f(key),
            getVisitedCount: ()=>$f0fa987b4412ed58$export$64c6861c3bbd89a2(accountId, countKey),
            increaseVisitedCount: (incrementedCount)=>$f0fa987b4412ed58$export$41554dcbb74e65ef(accountId, incrementedCount, countKey),
            isVisited: ()=>$f0fa987b4412ed58$var$getFeatureVisited(key)
        }), [
        accountId,
        countKey,
        key
    ]);
};

});
parcelRegister("kQJl1", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $8517cb28683921da$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $8517cb28683921da$export$b3126db2ef6e34ed);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $8517cb28683921da$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $8517cb28683921da$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $8517cb28683921da$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinNudges'
            },
            error: error
        });
    }
};
const $8517cb28683921da$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $8517cb28683921da$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $lRmyA.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("8ISXc", function(module, exports) {

$parcel$export(module.exports, "useFeatureExposed", () => $0dfd25d24ba8e87f$export$700e85d1c81b218b);
$parcel$export(module.exports, "useFeatureExposedForV2b", () => $0dfd25d24ba8e87f$export$ea0eadc28f6474f8);
$parcel$export(module.exports, "useIneligibilityAnalytics", () => $0dfd25d24ba8e87f$export$8bdc1ff53bd5e153);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $0dfd25d24ba8e87f$export$700e85d1c81b218b = ()=>{
    const flagKey = 'cross_join_nudges_confluence_v2a';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [v2aExperimentConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cross_join_nudges_confluence_v2a');
    const cohort = v2aExperimentConfig.get('cohort', 'not-enrolled');
    return (0, $eUqFw.useCallback)((ineligibilityReason)=>{
        try {
            if (cohort !== 'not-enrolled' && ineligibilityReason === 'ELIGIBLE') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
                flagKey: flagKey,
                cohort: cohort,
                ineligibilityReason: ineligibilityReason
            });
            else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
                flagKey: flagKey,
                flagCohort: cohort,
                ineligibilityReason: ineligibilityReason
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useFeatureExposed',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        cohort,
        createAnalyticsEvent,
        flagKey
    ]);
};
const $0dfd25d24ba8e87f$export$ea0eadc28f6474f8 = ()=>{
    const flagKey = 'cross-join-nudge-via-contextual-bandit-v2b';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [v2bExperimentConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cross-join-nudge-via-contextual-bandit-v2b');
    const cohort = v2bExperimentConfig.get('cohort', 'not-enrolled');
    return (0, $eUqFw.useCallback)(()=>{
        try {
            if (cohort !== 'not-enrolled') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
                flagKey: flagKey,
                cohort: cohort
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useFeatureExposed',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        cohort,
        createAnalyticsEvent,
        flagKey
    ]);
};
const $0dfd25d24ba8e87f$export$8bdc1ff53bd5e153 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((ineligibilityReason)=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
            flagKey: 'cross_join_nudge_jira_your_work',
            ineligibilityReason: ineligibilityReason
        });
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("bzek1", function(module, exports) {

$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $2029949fdbf1c045$export$b05786e1a14be004);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gd0Sp = parcelRequire("gd0Sp");
const $2029949fdbf1c045$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $2029949fdbf1c045$export$b05786e1a14be004 = (cloudId)=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    return (0, $eUqFw.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $2029949fdbf1c045$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $lRmyA.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined).map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};

});

parcelRegister("kv4Xz", function(module, exports) {

$parcel$export(module.exports, "useNudgeStateV1", () => $70253d01f1933ade$export$c50db6713418f20c);
$parcel$export(module.exports, "useNudgeStateV2a", () => $70253d01f1933ade$export$1721ab60f4854021);
$parcel$export(module.exports, "useNudgeStateYourWork", () => $70253d01f1933ade$export$766742495b6411cb);

var $eUqFw = parcelRequire("eUqFw");

var $dxcfv = parcelRequire("dxcfv");

var $kQJl1 = parcelRequire("kQJl1");
const $70253d01f1933ade$var$KEY_V1 = 'CROSS_JOIN_NUDGES_CONFLUENCE';
const $70253d01f1933ade$var$KEY_V2A = 'CROSS_JOIN_NUDGES_CONFLUENCE_V2A';
const $70253d01f1933ade$var$KEY_YOUR_WORK = 'CROSS_JOIN_NUDGES_YOUR_WORK';
const $70253d01f1933ade$var$getNudgeState = async (key, accountId)=>{
    if (!accountId) return 'NONE';
    const nudgeState = await (0, $kQJl1.getUserProperty)({
        accountId: accountId,
        propertyKey: key,
        defaultValue: 'NONE'
    });
    return nudgeState.value;
};
const $70253d01f1933ade$var$setNudgeDismissState = async (key, accountId)=>{
    if (!accountId) return;
    await (0, $kQJl1.setUserProperty)({
        accountId: accountId,
        propertyKey: key,
        propertyValue: 'DISMISSED'
    });
};
const $70253d01f1933ade$var$useNudgeState = (key)=>{
    const accountId = (0, $dxcfv.useAccountId)();
    return (0, $eUqFw.useMemo)(()=>({
            getNudgeState: ()=>$70253d01f1933ade$var$getNudgeState(key, accountId),
            setNudgeDismissed: ()=>$70253d01f1933ade$var$setNudgeDismissState(key, accountId)
        }), [
        accountId,
        key
    ]);
};
const $70253d01f1933ade$export$c50db6713418f20c = ()=>$70253d01f1933ade$var$useNudgeState($70253d01f1933ade$var$KEY_V1);
const $70253d01f1933ade$export$1721ab60f4854021 = ()=>$70253d01f1933ade$var$useNudgeState($70253d01f1933ade$var$KEY_V2A);
const $70253d01f1933ade$export$766742495b6411cb = ()=>$70253d01f1933ade$var$useNudgeState($70253d01f1933ade$var$KEY_YOUR_WORK);

});

parcelRegister("dhiCb", function(module, exports) {

$parcel$export(module.exports, "useConfluenceAccessCheck", () => $bcc8e1f706a5c631$export$8831028cddbf8467);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $bcc8e1f706a5c631$var$URL = '/gateway/api/permissions/permitted';
const $bcc8e1f706a5c631$export$8831028cddbf8467 = (cloudId)=>(0, $eUqFw.useCallback)(async ()=>{
        const data = {
            permissionId: 'write',
            resourceId: `ari:cloud:confluence::site/${cloudId}`
        };
        try {
            return (0, $2OdyW.default)($bcc8e1f706a5c631$var$URL, {
                method: 'POST',
                body: JSON.stringify(data)
            }).then((response)=>response.permitted);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useConfluenceAccessCheck',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Confluence permission check error');
        }
    }, [
        cloudId
    ]);

});

parcelRegister("dm1Hz", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUsers", () => $d92cbf5bfd9d399c$export$71bcfe5bb11155f7);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $d92cbf5bfd9d399c$var$URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';
const $d92cbf5bfd9d399c$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $2OdyW.default)($d92cbf5bfd9d399c$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $d92cbf5bfd9d399c$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $d92cbf5bfd9d399c$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};

});

parcelRegister("3eucn", function(module, exports) {

$parcel$export(module.exports, "useNudgeRecommendations", () => $c1b54f7ee1e60fb4$export$20e6812ba5f3fc39);

var $eUqFw = parcelRequire("eUqFw");

var $5JrsA = parcelRequire("5JrsA");

var $guiFP = parcelRequire("guiFP");

var $dWlsy = parcelRequire("dWlsy");

var $gd0Sp = parcelRequire("gd0Sp");

var $aQ8Z7 = parcelRequire("aQ8Z7");
const $c1b54f7ee1e60fb4$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudge';
function $c1b54f7ee1e60fb4$export$20e6812ba5f3fc39({ sessionId: sessionId }) {
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const contextResolver = (0, $eUqFw.useCallback)(()=>({
            product: 'jira',
            useCase: $c1b54f7ee1e60fb4$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $5JrsA.default)({
        contextResolver: contextResolver
    });
    return (0, $eUqFw.useCallback)(async ()=>{
        try {
            const result = await getRecommendations(1, $c1b54f7ee1e60fb4$var$asEntityIdList((0, $aQ8Z7.EntityList)));
            const { response: { data: data } = {} } = result;
            // This type assertion is necessary because useRecommendations don't support generic entityId
            const recommendedEntityId = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'recommendationFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'groot-growth'
                },
                error: error
            });
            throw new Error('Get nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
const $c1b54f7ee1e60fb4$var$asEntityIdList = (entities)=>entities.map((entity)=>({
            entityId: entity
        }));

});
parcelRegister("5JrsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f888a22489fbcc06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fUSEQ = parcelRequire("fUSEQ");

var $e7eWl = parcelRequire("e7eWl");

var $bVDwz = parcelRequire("bVDwz");

var $cQTrQ = parcelRequire("cQTrQ");
const $f888a22489fbcc06$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
	 * Fetch recommendations for a given context
	 */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $e7eWl.default)(endpoint);
        const requester = new (0, $cQTrQ.default)(new (0, $bVDwz.RecommendationsRequestBroker)());
        const context = (0, $fUSEQ.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $69c277e0e160e758$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $f888a22489fbcc06$export$2e2bcd8739ae039 = $f888a22489fbcc06$var$useRecommendations;

});
// Events
const $69c277e0e160e758$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $69c277e0e160e758$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $69c277e0e160e758$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $69c277e0e160e758$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $69c277e0e160e758$export$14b7e2c312f27acd = 'atlassian-growth-recos';

parcelRegister("fUSEQ", function(module, exports) {

$parcel$export(module.exports, "isNotEmpty", () => $a5020edf94844f86$export$a079a83b07f794bf);
$parcel$export(module.exports, "getContext", () => $a5020edf94844f86$export$31553aaa555c1514);
function $a5020edf94844f86$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $a5020edf94844f86$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("e7eWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $211adb0c5429a9ff$export$2e2bcd8739ae039);

var $bmrxu = parcelRequire("bmrxu");
class $211adb0c5429a9ff$export$2e2bcd8739ae039 extends (0, $bmrxu.default) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $211adb0c5429a9ff$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $211adb0c5429a9ff$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;

});
parcelRegister("bmrxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $97f5ade1207c2e92$export$2e2bcd8739ae039);

var $fUSEQ = parcelRequire("fUSEQ");
class $97f5ade1207c2e92$export$2e2bcd8739ae039 {
    constructor(endpoint){
        this.endpoint = endpoint;
    }
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $fUSEQ.getContext)(contextResolver);
    }
}

});


parcelRegister("bVDwz", function(module, exports) {

$parcel$export(module.exports, "RecommendationsRequestBroker", () => $8e11a95966e9d974$export$7f19312509e0d2c0);

var $c9Srb = parcelRequire("c9Srb");
class $8e11a95966e9d974$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $c9Srb.RecommendationSuccessResultCreator)(response, result);
    }
}

});
parcelRegister("c9Srb", function(module, exports) {

$parcel$export(module.exports, "RecommendationSuccessResultCreator", () => $8a1c6dcb7c806cc8$export$c02f0b31b3b527a3);

var $bR1q2 = parcelRequire("bR1q2");
class $8a1c6dcb7c806cc8$export$c02f0b31b3b527a3 extends (0, $bR1q2.QuerySuccessResultCreator) {
    constructor(response, data){
        super(response, data);
        this.response = response;
    }
    makeQueryResult() {
        return new (0, $bR1q2.GraphQlQueryResult)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
}

});
parcelRegister("bR1q2", function(module, exports) {

$parcel$export(module.exports, "GraphQlQueryResult", () => $3860418ee2bedff2$export$d0a1abfd57dc5018);
$parcel$export(module.exports, "NonOkQueryResultCreator", () => $3860418ee2bedff2$export$ad7cb7f4450dd7c4);
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", () => $3860418ee2bedff2$export$553722ecbbe27276);
$parcel$export(module.exports, "MissingQueryDataResultCreator", () => $3860418ee2bedff2$export$ff264bfdc9a404eb);
$parcel$export(module.exports, "QuerySuccessResultCreator", () => $3860418ee2bedff2$export$6b16771e962990ff);
class $3860418ee2bedff2$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $3860418ee2bedff2$var$QueryResultCreator {
}
class $3860418ee2bedff2$export$ad7cb7f4450dd7c4 extends $3860418ee2bedff2$var$QueryResultCreator {
    constructor(fetchResponse){
        super();
        this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $3860418ee2bedff2$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
}
class $3860418ee2bedff2$export$553722ecbbe27276 extends $3860418ee2bedff2$var$QueryResultCreator {
    constructor(errors){
        super();
        this.errors = errors;
    }
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $3860418ee2bedff2$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
}
class $3860418ee2bedff2$export$ff264bfdc9a404eb extends $3860418ee2bedff2$var$QueryResultCreator {
    constructor(fetchResponse){
        super();
        this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $3860418ee2bedff2$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
}
class $3860418ee2bedff2$export$6b16771e962990ff extends $3860418ee2bedff2$var$QueryResultCreator {
    constructor(response, data){
        super();
        this.response = response;
        this.data = data;
    }
}

});



parcelRegister("cQTrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91cb4a699c44373$export$2e2bcd8739ae039);

var $bR1q2 = parcelRequire("bR1q2");

var $cMfoI = parcelRequire("cMfoI");
class $a91cb4a699c44373$export$2e2bcd8739ae039 {
    constructor(broker){
        this.broker = broker;
    }
    /**
	 * Fetches the response by the given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The query result
	 */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $bR1q2.NonOkQueryResultCreator)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $bR1q2.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $bR1q2.MissingQueryDataResultCreator)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
	 * Fetches the response by tha given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The response from the request
	 */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $cMfoI.default).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
}

});
parcelRegister("cMfoI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5585b5f4b6dfa248$export$2e2bcd8739ae039);

var $8ts4a = parcelRequire("8ts4a");

var $glyMA = parcelRequire("glyMA");
class $5585b5f4b6dfa248$export$2e2bcd8739ae039 {
    /**
	 * Returns the cache provider based on the given cache configuration
	 *
	 * @param cacheConfig The cache configuration to use
	 * @returns The cache provider
	 */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $glyMA.default)(cacheConfig);
        return new (0, $8ts4a.default)();
    }
}

});
parcelRegister("8ts4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $0410f9e6e91b3ba2$export$2e2bcd8739ae039);
class $0410f9e6e91b3ba2$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}

});

parcelRegister("glyMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $adfb59009f04234e$export$2e2bcd8739ae039);

var $cUPxW = parcelRequire("cUPxW");

var $lW1nB = parcelRequire("lW1nB");
class $adfb59009f04234e$export$2e2bcd8739ae039 {
    /**
	 * Initialise the WebCacheStorage
	 * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
	 * @param onError a callback when any error occurs
	 */ constructor(cacheProviderConfig){
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $cUPxW.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $lW1nB.default)(this.cacheConfig);
    }
    /**
	 * Get cached response
	 */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Put response in cache
	 */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Delete cached response
	 */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
	 * Check if the cached response is expired
	 */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
	 * Compose the URL and the use case as the search params to cache the response
	 */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
	 * Get the key to store the response
	 * Interally, it hashes the request body to get a unique key
	 */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
}

});
parcelRegister("cUPxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b9c91fd5d03c34$export$2e2bcd8739ae039);
const $39b9c91fd5d03c34$var$DEFAULT_TTL = 60;
class $39b9c91fd5d03c34$export$2e2bcd8739ae039 {
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $39b9c91fd5d03c34$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
}

});

parcelRegister("lW1nB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f5e8e89233285c2$export$2e2bcd8739ae039);
class $6f5e8e89233285c2$export$2e2bcd8739ae039 {
    /**
	 * Initialise the ExpiryStorage
	 */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
    /**
	 * Set the expiry date of the cached response
	 */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Get the expiry date of the cached response
	 */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Initialise the IndexedDB
	 */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
	 * Get the object store from the IndexedDB
	 */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
}

});





parcelRegister("aQ8Z7", function(module, exports) {

$parcel$export(module.exports, "EntityList", () => $16a63310bcc47fa7$export$8bb466c13870163e);
$parcel$export(module.exports, "useDynamicMessaging", () => $16a63310bcc47fa7$export$a926e6dcf8f98b36);

var $cTcVj = parcelRequire("cTcVj");
const $16a63310bcc47fa7$export$8bb466c13870163e = [
    'nudgeCandidate01',
    'nudgeCandidate02',
    'nudgeCandidate03',
    'nudgeCandidate04',
    'nudgeCandidate05',
    'nudgeCandidate06',
    'nudgeCandidate07'
];
const $16a63310bcc47fa7$var$messageVariantsKeyMap = {
    default: {
        title: 'title',
        description: 'description',
        joinButton: 'joinButton'
    },
    nudgeCandidate01: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04: {
        title: 'titleNudgeCandidate04',
        description: 'descriptionNudgeCandidate04',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05: {
        title: 'titleNudgeCandidate05',
        description: 'descriptionNudgeCandidate05',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07',
        joinButton: 'joinButtonNudgeCandidate07'
    }
};
const $16a63310bcc47fa7$export$a926e6dcf8f98b36 = (isV2b, entityId)=>{
    // Handle case when entityId is unexpected
    if (!(entityId in $16a63310bcc47fa7$var$messageVariantsKeyMap)) return undefined;
    // If v2B is not enabled we just passthrough default message keys
    const usedEntityId = isV2b ? entityId : 'default';
    const titleKey = $16a63310bcc47fa7$var$messageVariantsKeyMap[usedEntityId].title;
    const descriptionKey = $16a63310bcc47fa7$var$messageVariantsKeyMap[usedEntityId].description;
    const joinButtonKey = $16a63310bcc47fa7$var$messageVariantsKeyMap[usedEntityId].joinButton;
    return {
        title: (0, $cTcVj.messages)[titleKey],
        description: (0, $cTcVj.messages)[descriptionKey],
        joinButton: (0, $cTcVj.messages)[joinButtonKey]
    };
};

});
parcelRegister("cTcVj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $138fc8eb56629a0b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $138fc8eb56629a0b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title",
        "defaultMessage": "Your team is now using Confluence"
    },
    titleNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01",
        "defaultMessage": "Join your teammates in Confluence"
    },
    titleNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02",
        "defaultMessage": "Collaborate together in Confluence"
    },
    titleNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03",
        "defaultMessage": "Your team is working in Confluence"
    },
    titleNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04",
        "defaultMessage": "Unify your projects in Confluence"
    },
    titleNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05",
        "defaultMessage": "Bring projects together in Confluence"
    },
    titleNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06",
        "defaultMessage": "Create a single source of truth"
    },
    titleNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07",
        "defaultMessage": "Create a single source of truth"
    },
    description: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    descriptionNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01",
        "defaultMessage": "Create a single source of truth for project decisions and software documentation."
    },
    descriptionNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02",
        "defaultMessage": "Capture, consolidate, and share team knowledge, in one centralized place."
    },
    descriptionNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03",
        "defaultMessage": "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04",
        "defaultMessage": "Organize project information and sync it to Jira tasks to track and hit your goals faster."
    },
    descriptionNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05",
        "defaultMessage": "Capture information in project pages and sync to Jira tasks to track your milestones."
    },
    descriptionNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06",
        "defaultMessage": "Consolidate information in one place and sync to Jira tasks for automatic updates."
    },
    descriptionNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07",
        "defaultMessage": "Join your team in Confluence to consolidate project information in one place."
    },
    joinButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07",
        "defaultMessage": "Join Confluence"
    },
    remindMeLaterButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button",
        "defaultMessage": "Remind me later"
    },
    notInterestedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.not-interested-button",
        "defaultMessage": "Not interested"
    },
    urgencyTitle: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.urgency-title",
        "defaultMessage": "{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}"
    }
});

});



parcelRegister("ksq0I", function(module, exports) {

$parcel$export(module.exports, "useConfluenceRequestAccess", () => $f3aa0a746ea66fa8$export$7a3505014099f607);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");
const $f3aa0a746ea66fa8$var$URL = '/gateway/api/invitations/v1/access-requests/request';
const $f3aa0a746ea66fa8$var$product = 'confluence';
const $f3aa0a746ea66fa8$export$7a3505014099f607 = (integration = 'crossJoinNudgesConfluence')=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const userId = (0, $dxcfv.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const resource = `ari:cloud:${$f3aa0a746ea66fa8$var$product}::site/${cloudId}`;
    return (0, $eUqFw.useCallback)(async ()=>{
        try {
            return (0, $2OdyW.default)($f3aa0a746ea66fa8$var$URL, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    resource: resource
                })
            }).then((response)=>{
                const { results: results } = response;
                const result = results[resource];
                const analyticsAttributes = {
                    userId: userId,
                    products: [
                        $f3aa0a746ea66fa8$var$product
                    ],
                    inviteResult: [
                        {
                            resourceAri: resource,
                            status: result
                        }
                    ],
                    integration: integration
                };
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
                return result;
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useConfluenceRequestAccess',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Confluence request access error');
        }
    }, [
        createAnalyticsEvent,
        integration,
        resource,
        userId
    ]);
};

});

parcelRegister("1fKAJ", function(module, exports) {

$parcel$export(module.exports, "useConfluenceRequestCapabilitiesCheck", () => $2102015b083c7e71$export$46d687ec5563683e);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $2102015b083c7e71$export$46d687ec5563683e = (cloudId)=>{
    const resource = `ari:cloud:confluence::site/${cloudId}`;
    return (0, $eUqFw.useCallback)(async ()=>{
        try {
            const URL = $2102015b083c7e71$var$getConfluenceRequestCapabilitiesUrl(resource);
            return (0, $2OdyW.default)(URL, {
                credentials: 'include'
            }).then((response)=>{
                const requestCapabilities = response.results[resource];
                return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useConfluenceRequestCapabilitiesCheck',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get request capabilities error');
        }
    }, [
        resource
    ]);
};
const $2102015b083c7e71$var$getConfluenceRequestCapabilitiesUrl = (resource)=>{
    const params = new URLSearchParams({
        resource: resource
    });
    return `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
};

});

parcelRegister("eCji9", function(module, exports) {

$parcel$export(module.exports, "useSiteEligibilityCheck", () => $f4dadef39fde17a7$export$6d7dfd5017341421);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $ccm3Y = parcelRequire("ccm3Y");
const $f4dadef39fde17a7$export$79555f8f9058b0b6 = 'confluence.ondemand.activationDate';
const $f4dadef39fde17a7$export$6d7dfd5017341421 = (cloudId)=>(0, $eUqFw.useCallback)(async ()=>{
        try {
            const siteTraits = await (0, $ccm3Y.memoizedFetchSitePersonalization)({
                cloudId: cloudId
            });
            return $f4dadef39fde17a7$var$isSite7DaysOlder(siteTraits);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useSiteEligibilityCheck',
                    packageName: 'jiraCrossJoinNudges'
                },
                attributes: {
                    cloudId: cloudId,
                    errorResponse: JSON.stringify(error)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Site eligibility check error');
        }
    }, [
        cloudId
    ]);
const $f4dadef39fde17a7$var$isSite7DaysOlder = (traits)=>{
    const confluenceActivation = traits.find((trait)=>trait.name === $f4dadef39fde17a7$export$79555f8f9058b0b6);
    if (confluenceActivation?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(confluenceActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};

});
parcelRegister("ccm3Y", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $23253fa24cdf456f$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $23253fa24cdf456f$export$58982988039b926f);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $23253fa24cdf456f$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $23253fa24cdf456f$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $2OdyW.default)($23253fa24cdf456f$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $23253fa24cdf456f$export$671fb03be30194c3 = (0, $5iWql.default)($23253fa24cdf456f$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $23253fa24cdf456f$export$58982988039b926f = ()=>(0, $eEzyV.useService)($23253fa24cdf456f$export$671fb03be30194c3);

});


parcelRegister("7ILIy", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessErrorFlag", () => $1adac71c1a70e257$export$d8e2d94eec4efe85);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jBHpa = parcelRequire("jBHpa");

var $doRwh = parcelRequire("doRwh");
const $1adac71c1a70e257$export$d8e2d94eec4efe85 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    return (0, $eUqFw.useCallback)(()=>{
        const id = `error-${(0, $jBHpa.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1adac71c1a70e257$export$e1d0d64874873c8b, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $1adac71c1a70e257$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $1adac71c1a70e257$export$e1d0d64874873c8b = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $doRwh.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $doRwh.messages).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: $1adac71c1a70e257$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $doRwh.messages).action)), "."))
    });
};

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("70r4x")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("70r4x")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("70r4x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});


parcelRegister("jBHpa", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $d853c7fe903915c5$export$567fc7097e064344);
let $d853c7fe903915c5$var$id = 0;
const $d853c7fe903915c5$export$567fc7097e064344 = ()=>{
    $d853c7fe903915c5$var$id += 1;
    return String($d853c7fe903915c5$var$id);
};

});

parcelRegister("doRwh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fd82bc6944a34186$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $fd82bc6944a34186$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-error-flag.title",
        "defaultMessage": "We couldn't add you to Confluence"
    },
    description: {
        "id": "cross-join-nudges.request-access-error-flag.description",
        "defaultMessage": "Try again in a few minutes. If you still aren't able to join, "
    },
    action: {
        "id": "cross-join-nudges.request-access-error-flag.action",
        "defaultMessage": "contact support"
    }
});

});


parcelRegister("cQtop", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessPromptFlag", () => $a04a9ac9bf52be76$export$233a6a0aca8c9091);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $8vPhU = parcelRequire("8vPhU");
var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dxcfv = parcelRequire("dxcfv");

var $jBHpa = parcelRequire("jBHpa");

var $jkCs4 = parcelRequire("jkCs4");

var $4xHBK = parcelRequire("4xHBK");
const $a04a9ac9bf52be76$export$233a6a0aca8c9091 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const userId = (0, $dxcfv.useAccountId)() || '';
    return (0, $eUqFw.useCallback)(({ users: users, onOptout: onOptout, onSubmit: onSubmit, snoozeFor30Days: snoozeFor30Days, isV2a: isV2a = false, isV2b: isV2b = false, entityId: entityId = 'default', sessionId: sessionId = '', featureVisitedCount: featureVisitedCount = 0 })=>{
        try {
            const id = `request-access-${(0, $jBHpa.generateId)()}`;
            const dismissTheFlag = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
            const eventAttributes = {
                collaborators: users.length,
                userId: userId,
                isV2a: isV2a,
                isV2b: isV2b,
                entityId: entityId,
                featureVisitedCount: featureVisitedCount,
                sessionId: sessionId
            };
            const submit = async ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'crossJoinNudgesConfluence', eventAttributes);
                dismissTheFlag();
                await onSubmit();
            };
            const dismiss = ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'crossJoinNudgesConfluence', eventAttributes);
                dismissTheFlag();
            };
            const dismissAndOptout = ()=>{
                dismiss();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'flag optedOut', 'crossJoinNudgesConfluence', eventAttributes);
                onOptout();
            };
            const dismissAndSnooze = ()=>{
                dismissTheFlag();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', 'crossJoinNudgesConfluence', eventAttributes);
                snoozeFor30Days();
            };
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', 'crossJoinNudgesConfluence', eventAttributes);
            showFlag({
                id: id,
                render: (props)=>isV2a || isV2b ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xHBK.RequestAccessPromptFlag), {
                        ...props,
                        id: id,
                        users: users,
                        onDismiss: dismiss,
                        onSnoozeAndDismiss: dismissAndSnooze,
                        onOptoutAndDismiss: dismissAndOptout,
                        onSubmit: submit,
                        isV2b: isV2b,
                        entityId: entityId,
                        featureVisitedCount: featureVisitedCount
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkCs4.RequestAccessPromptFlag), {
                        ...props,
                        id: id,
                        users: users,
                        onDismiss: dismissAndOptout,
                        onSubmit: submit
                    })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useRequestAccessPromptFlag',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Show request access prompt flag error');
        }
    }, [
        createAnalyticsEvent,
        dismissFlag,
        showFlag,
        userId
    ]);
};

});
parcelRegister("jkCs4", function(module, exports) {

$parcel$export(module.exports, "RequestAccessPromptFlag", () => $adffa68d734a7e80$export$9b8813c3601640da);
/* flag.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2bv8J = parcelRequire("2bv8J");

var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");

var $PdmhA = parcelRequire("PdmhA");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7NgkV = parcelRequire("7NgkV");

var $cTcVj = parcelRequire("cTcVj");

var $dhGdR = parcelRequire("dhGdR");
const $adffa68d734a7e80$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, ...props })=>{
    const handleOnSubmit = (0, $eUqFw.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const customFlagFooterProps = (0, $eUqFw.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $dhGdR.noop)
                }
            ],
            linkComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    alignInline: "end",
                    grow: "fill",
                    spread: "space-between",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($adffa68d734a7e80$var$LinkButton, {
                    onClick: handleOnSubmit
                }, formatMessage((0, $cTcVj.messages).joinButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NgkV.FlagCompatibleAvatarGroup), {
                    alignment: "horizontal",
                    data: users.map((user)=>({
                            name: user.name,
                            src: user.avatar,
                            appearance: 'circle',
                            size: 'medium'
                        })),
                    boundariesElement: "scrollParent"
                }))
        }), [
        handleOnSubmit,
        formatMessage,
        users
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $cTcVj.messages).title, {
            relevantUser: 'Sam Smith'
        })),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($adffa68d734a7e80$var$MainContentContainer, null, formatMessage((0, $cTcVj.messages).description))),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            primaryColor: `var(--ds-icon-information, ${(0, $PdmhA.B300)})`,
            label: "Info"
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $adffa68d734a7e80$var$MainContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ccj1k _1yyj11wp _sudp1e54 _1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $adffa68d734a7e80$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz14q2 _bfhk1kw7 _189eidpf _11c81oud _k48p1wq8 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1974c390fcca76c2$var$_information = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $1974c390fcca76c2$var$_information.default
    }));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = module.exports.default = $1974c390fcca76c2$var$InfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Information".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Known uses: helper message under textfield, information state insection messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("7NgkV", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $1b7f2700911adde3$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4XQdE = parcelRequire("4XQdE");

var $dhGdR = parcelRequire("dhGdR");
const $1b7f2700911adde3$var$MAX_AVATARS_FEATURED_HORIZONTAL = 4;
const $1b7f2700911adde3$var$MAX_AVATARS_FEATURED_VERTICAL = 2;
const $1b7f2700911adde3$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $1b7f2700911adde3$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $1b7f2700911adde3$export$29beada2d5f93289 = ({ alignment: alignment = 'horizontal', data: data, ...props })=>{
    const maxAvatarCount = alignment === 'horizontal' ? $1b7f2700911adde3$var$MAX_AVATARS_FEATURED_HORIZONTAL : $1b7f2700911adde3$var$MAX_AVATARS_FEATURED_VERTICAL;
    const tooltipPosition = alignment === 'horizontal' ? 'top' : 'right';
    const { data: customData, overrides: customOverrides } = (0, $eUqFw.useMemo)(()=>$1b7f2700911adde3$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ // @ts-ignore
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, $dhGdR.noop),
        ...props
    });
    if (alignment === 'vertical') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b7f2700911adde3$var$VerticalAvatarGroupContainer, null, avatarGroup);
    return avatarGroup;
};
const $1b7f2700911adde3$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount = $1b7f2700911adde3$var$MAX_AVATARS_FEATURED_HORIZONTAL })=>{
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $1b7f2700911adde3$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $1b7f2700911adde3$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $1b7f2700911adde3$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $1b7f2700911adde3$var$OVERFLOW_USER_MARKER
    });
const $1b7f2700911adde3$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, (avatarChildrenProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b7f2700911adde3$var$AvatarOverflowCountContainer, avatarChildrenProps, `+${Math.min(overflowCount, $1b7f2700911adde3$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b7f2700911adde3$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkj6p2 _syaz1ktl _y3gn1s23 _k48p124r",
            __cmplp.className
        ])
    });
});
const $1b7f2700911adde3$var$VerticalAvatarGroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogvv1bp4 _3mc9idpf _1hlaidpf _1qu0x0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-text, ${(0, $PdmhA.N500)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text, ${(0, $PdmhA.B400)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $PdmhA.N0})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});




parcelRegister("4xHBK", function(module, exports) {

$parcel$export(module.exports, "RequestAccessPromptFlag", () => $e83691ef2f74e038$export$9b8813c3601640da);
/* flag-v2a.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2bv8J = parcelRequire("2bv8J");

var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7NgkV = parcelRequire("7NgkV");

var $cTcVj = parcelRequire("cTcVj");

var $dhGdR = parcelRequire("dhGdR");

var $aQ8Z7 = parcelRequire("aQ8Z7");
const $e83691ef2f74e038$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptoutAndDismiss: onOptoutAndDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, isV2b: isV2b, entityId: entityId = 'default', featureVisitedCount: featureVisitedCount, ...props })=>{
    const handleOnSubmit = (0, $eUqFw.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const dynamicMessages = (0, $aQ8Z7.useDynamicMessaging)(!!isV2b, entityId) || (0, $cTcVj.messages);
    const customFlagFooterProps = (0, $eUqFw.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $dhGdR.noop)
                }
            ],
            linkComponent: ()=>{
                let secondETA = null;
                if (featureVisitedCount === 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e83691ef2f74e038$var$LinkButton, {
                    onClick: onSnoozeAndDismiss
                }, formatMessage((0, $cTcVj.messages).remindMeLaterButton));
                else if (featureVisitedCount > 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e83691ef2f74e038$var$LinkButton, {
                    onClick: onOptoutAndDismiss
                }, formatMessage((0, $cTcVj.messages).notInterestedButton));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e83691ef2f74e038$var$LinkButton, {
                    onClick: handleOnSubmit
                }, formatMessage(dynamicMessages.joinButton)), !!secondETA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e83691ef2f74e038$var$LinkButtonSeparator, null), secondETA);
            }
        }), [
        featureVisitedCount,
        handleOnSubmit,
        formatMessage,
        onOptoutAndDismiss,
        onSnoozeAndDismiss,
        dynamicMessages
    ]);
    const customIcon = (0, $eUqFw.useMemo)(()=>{
        if (isV2b) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            primaryColor: "var(--ds-icon-information, #1D7AFC)",
            label: "Info"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NgkV.FlagCompatibleAvatarGroup), {
            alignment: "vertical",
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle',
                    size: 'medium'
                })),
            boundariesElement: "scrollParent"
        });
    }, [
        isV2b,
        users
    ]);
    const infoFlagTitle = isV2b ? formatMessage(dynamicMessages.title) : formatMessage((0, $cTcVj.messages).urgencyTitle, {
        viewCount: featureVisitedCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: featureVisitedCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: infoFlagTitle,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e83691ef2f74e038$var$MainContentContainer, null, formatMessage(dynamicMessages.description))),
        icon: customIcon
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e83691ef2f74e038$var$MainContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ccj1k _1yyj11wp _sudp1e54 _1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e83691ef2f74e038$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1w81 _c71loyo4 _1reo15vq _18m915vq _syaz14q2 _bfhk1kw7 _189eidpf _11c81oud _k48p1wq8 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e83691ef2f74e038$var$LinkButtonSeparator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kt95qml _fntnutpp _eid3utpp",
            __cmplp.className
        ])
    });
});

});


parcelRegister("btURX", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessSuccessFlag", () => $33d82b3dca57d388$export$184b02cbba392fc0);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jBHpa = parcelRequire("jBHpa");

var $lrhE6 = parcelRequire("lrhE6");
const $33d82b3dca57d388$export$184b02cbba392fc0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    return (0, $eUqFw.useCallback)(()=>{
        const id = `success-${(0, $jBHpa.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d82b3dca57d388$export$567128fc1024c9cf, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $33d82b3dca57d388$export$567128fc1024c9cf = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $lrhE6.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $lrhE6.messages).description))
    });
};

});
parcelRegister("lrhE6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d3ff6a36abeeb906$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d3ff6a36abeeb906$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-success-flag.title",
        "defaultMessage": "A request was sent to your admins"
    },
    description: {
        "id": "cross-join-nudges.request-access-success-flag.description",
        "defaultMessage": "You'll receive an email once they've reviewed it."
    }
});

});


parcelRegister("6GdGo", function(module, exports) {

$parcel$export(module.exports, "CrossJoinNudgeYourWorkCard", () => $ba8d6dc2b909e90b$export$7ac60ccf67d54f65);

var $eUqFw = parcelRequire("eUqFw");

var $4XQdE = parcelRequire("4XQdE");

var $6zOB7 = parcelRequire("6zOB7");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $8B2FA = parcelRequire("8B2FA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1g0qb = parcelRequire("1g0qb");
var $a6aOo = parcelRequire("a6aOo");

var $bGx6E = parcelRequire("bGx6E");
const $ba8d6dc2b909e90b$var$Actions = ({ onSubmit: onSubmit, onSnooze: onSnooze, onOptOut: onOptOut, collaborators: collaborators })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        onClick: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $bGx6E.messages).joinYourTeam,
        values: {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name.split(' ')[0]
        }
    })), onSnooze && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onSnooze
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bGx6E.messages).remindMeLater)), onOptOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onOptOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bGx6E.messages).notInterested)));
const $ba8d6dc2b909e90b$var$Avatars = ({ collaborators: collaborators })=>{
    const data = [
        ...(0, $a6aOo.DEFAULT_USERS)
    ];
    for (const [i, user] of collaborators.entries())data[i] = {
        name: user.name,
        src: user.avatar
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ba8d6dc2b909e90b$var$AvatarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: data,
        maxCount: 4,
        size: "large",
        borderColor: "white",
        testId: "cross-join-nudges.ui.your-work-widget.ui"
    }));
};
const $ba8d6dc2b909e90b$export$7ac60ccf67d54f65 = ({ onRender: onRender, collaborators: collaborators, onDismiss: onDismiss, ...actionsProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    onRender();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ba8d6dc2b909e90b$var$Wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba8d6dc2b909e90b$var$Avatars, {
        collaborators: collaborators
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8B2FA.PromotionalCard), {
        header: formatMessage((0, $bGx6E.messages).header, {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1g0qb))),
        imageAltText: formatMessage((0, $bGx6E.messages).imageAltText),
        description: formatMessage((0, $bGx6E.messages).description),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba8d6dc2b909e90b$var$Actions, {
            ...actionsProps,
            collaborators: collaborators
        }),
        reason: formatMessage((0, $bGx6E.messages).tooltip),
        analyticsSource: "cross-join-nudges-your-work",
        onDismiss: onDismiss
    }));
};
const $ba8d6dc2b909e90b$var$AvatarWrapper = (0, $1ZAYh.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: '144px',
    top: '35px'
});
const $ba8d6dc2b909e90b$var$Wrapper = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    position: 'relative'
});

});
parcelRegister("8B2FA", function(module, exports) {

$parcel$export(module.exports, "PromotionalCard", () => $0bc1e5a81a25c3ea$export$418393e556a23457);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7opLA = parcelRequire("7opLA");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $aUqTb = parcelRequire("aUqTb");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $lSjZ9 = parcelRequire("lSjZ9");
const $0bc1e5a81a25c3ea$export$418393e556a23457 = ({ imageUrl: imageUrl, imageAltText: imageAltText, header: header, description: description, primaryAction: primaryAction, reason: reason, analyticsSource: analyticsSource, isDismissLoading: isDismissLoading, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
        sourceName: analyticsSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "subtle",
        spacing: "none",
        isLoading: isDismissLoading,
        "aria-label": formatMessage((0, $lSjZ9.default).dismiss),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "medium",
            label: "",
            primaryColor: `var(--ds-icon-warning-inverse, ${(0, $PdmhA).N800})`
        }),
        onClick: (e, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `${analyticsSource}Dismiss`);
            onDismiss();
        }
    })), imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$ImageContainer, {
        imageUrl: imageUrl
    }, imageAltText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        role: "img",
        "aria-label": imageAltText
    }) : null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Description, null, description), primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: reason,
        onShow: (analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'promotionalCardInfo')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$FooterContent, {
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        size: "small",
        label: ""
    }), formatMessage((0, $lSjZ9.default).footerContent))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _16qspmv4 _2rko1l7b _1bsb1gwv _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71lckbl _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$ImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { imageUrl: imageUrl, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ntxwly": (0, $9t7rW.default)(`url(${__cmplp.imageUrl})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1lrw1dfr _4t3ibv7e _1bsb1osq _1itklex0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1yt4pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkutpp _otyrutpp _syaz1fxt _c71l1wqb _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $0bc1e5a81a25c3ea$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _x3doh6cr _1yt418iy _syaz1wmz",
            __cmplp.className
        ])
    });
});
const $0bc1e5a81a25c3ea$var$FooterContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1b66 _1wyb1skh",
            __cmplp.className
        ])
    });
});
const $0bc1e5a81a25c3ea$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iv47k _1xi21ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});

parcelRegister("lSjZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a3a81f3c6acc15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $49a3a81f3c6acc15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dismiss: {
        "id": "home-common-ui.promotional-card.dismiss",
        "defaultMessage": "Close"
    },
    footerContent: {
        "id": "home-common-ui.promotional-card.footer-content",
        "defaultMessage": "Why am I seeing this?"
    }
});

});


parcelRegister("1g0qb", function(module, exports) {
module.exports = new URL("Background.cb8e778e.svg", import.meta.url).toString();

});

parcelRegister("a6aOo", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_USERS", () => $d9325517f2987082$export$f1cf19fb21a55eb5);

var $hg3n5 = parcelRequire("hg3n5");

var $9Fn6j = parcelRequire("9Fn6j");

var $lmXIR = parcelRequire("lmXIR");

var $6nwgW = parcelRequire("6nwgW");

var $1g0qb = parcelRequire("1g0qb");
const $d9325517f2987082$export$f1cf19fb21a55eb5 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($6nwgW))),
    (0, (/*@__PURE__*/$parcel$interopDefault($hg3n5))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9Fn6j))),
    (0, (/*@__PURE__*/$parcel$interopDefault($lmXIR)))
].map((src)=>({
        name: '',
        src: src
    }));

});
parcelRegister("hg3n5", function(module, exports) {
module.exports = new URL("Angie.54f8d1c9.svg", import.meta.url).toString();

});

parcelRegister("9Fn6j", function(module, exports) {
module.exports = new URL("Ed.81e2857f.svg", import.meta.url).toString();

});

parcelRegister("lmXIR", function(module, exports) {
module.exports = new URL("More.cf799018.svg", import.meta.url).toString();

});

parcelRegister("6nwgW", function(module, exports) {
module.exports = new URL("Norah.f996d303.svg", import.meta.url).toString();

});


parcelRegister("bGx6E", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e3df8ebf184d6437$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e3df8ebf184d6437$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    header: {
        "id": "cross-join-nudges.your-work.header",
        "defaultMessage": "{collaborators, plural, =0 {Your team is using Confluence} one {{collaborator} is using Confluence} other {{collaborator} and others are using Confluence}}"
    },
    description: {
        "id": "cross-join-nudges.your-work.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    joinYourTeam: {
        "id": "cross-join-nudges.your-work.join-your-team",
        "defaultMessage": "{collaborators, plural, one {Join {collaborator}} other {Join your team}}"
    },
    remindMeLater: {
        "id": "cross-join-nudges.your-work.remind-me-later",
        "defaultMessage": "Remind me later"
    },
    notInterested: {
        "id": "cross-join-nudges.your-work.not-interested",
        "defaultMessage": "Not interested"
    },
    tooltip: {
        "id": "cross-join-nudges.your-work.tooltip",
        "defaultMessage": "You're seeing this suggestion because you may want to use Confluence to work with the same people you work with in Jira. Your Jira teammates already use Confluence."
    },
    imageAltText: {
        "id": "cross-join-nudges.your-work.image-alt-text",
        "defaultMessage": "Your team collaborating on a document in Confluence"
    }
});

});


parcelRegister("i7z2u", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $4e8d8d680964f323$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $guiFP = parcelRequire("guiFP");
const $4e8d8d680964f323$export$e926676385687eaf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        onError: (_, error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'cross-join-nudges-your-work-error-boundary'
                },
                error: error
            });
        }
    }, children);

});


parcelRegister("4vWQL", function(module, exports) {

$parcel$export(module.exports, "fireExposureEvent", () => $ac8be38a28a9f209$export$73124685d9489943);

var $1Iui1 = parcelRequire("1Iui1");

var $hzKLE = parcelRequire("hzKLE");
const $ac8be38a28a9f209$export$73124685d9489943 = (featureFlagKey, flagValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes = {})=>{
    const cohort = flagValue.value;
    if (!cohort.startsWith((0, $1Iui1.NOT_ENROLLED))) (0, $hzKLE.getFeatureFlagClient)().trackExposure(featureFlagKey, {
        value: cohort,
        explanation: {
            kind: flagValue?.explanation.kind,
            ruleId: flagValue?.explanation.ruleId || undefined
        }
    }, attributes);
};

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});


parcelRegister("fzPXJ", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagValue", () => $ea4dfdc9185ffd8d$export$7064bb599f663d7e);

var $illlw = parcelRequire("illlw");

var $1Iui1 = parcelRequire("1Iui1");

var $aWbzA = parcelRequire("aWbzA");
const $ea4dfdc9185ffd8d$export$7064bb599f663d7e = (featureFlagKey)=>{
    const featureFlags = (0, $aWbzA.default)();
    const flagValue = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(featureFlags, [
        featureFlagKey
    ]);
    if (typeof flagValue === 'undefined') return {
        value: (0, $1Iui1.NOT_ENROLLED),
        explanation: {
            ruleId: null,
            kind: 'INELIGIBLE'
        }
    };
    // @ts-expect-error - TS2741 - Property 'explanation' is missing in type '{ value: FeatureFlagValue; }' but required in type 'FeatureFlagValue'.
    return flagValue;
};

});

parcelRegister("2MjDU", function(module, exports) {

$parcel$export(module.exports, "openSlackIntegrationPopup", () => $44caa7e99d5c85d6$export$a4ed879b9981f635);

var $3FBda = parcelRequire("3FBda");
const $44caa7e99d5c85d6$var$WIDTH = 500;
const $44caa7e99d5c85d6$var$HEIGHT = 900;
const $44caa7e99d5c85d6$var$baseParams = {
    toolbar: 0,
    menubar: 0,
    location: 0,
    status: 0,
    scrollbars: 1,
    resizable: 0,
    chrome: 'yes'
};
// @ts-expect-error - TS2322 - Type 'Window & typeof globalThis' is not assignable to type 'Window'.
const $44caa7e99d5c85d6$var$popupWindowParams = (w = window)=>{
    const width = Math.min($44caa7e99d5c85d6$var$WIDTH, w.screen.availWidth);
    const height = Math.min($44caa7e99d5c85d6$var$HEIGHT, w.screen.availHeight);
    const entities = {
        ...$44caa7e99d5c85d6$var$baseParams,
        width: width,
        height: height,
        left: Math.round((w.innerWidth - width) / 2 + w.screenX),
        top: Math.round((w.innerHeight - height) / 3 + w.screenY)
    };
    return Object.keys(entities)// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ width: number; height: number; left: number; top: number; toolbar: 0; menubar: 0; location: 0; status: 0; scrollbars: 1; resizable: 0; chrome: "yes"; }'.
    .map((key)=>`${key}=${entities[key]}`).join(',');
};
const $44caa7e99d5c85d6$export$a4ed879b9981f635 = (source, w = window)=>w.open((0, $3FBda.getSlackConsentUrl)(source), '_blank', $44caa7e99d5c85d6$var$popupWindowParams(w));

});
parcelRegister("3FBda", function(module, exports) {

$parcel$export(module.exports, "getSlackConsentUrl", () => $4f26a62c588a77b4$export$cc6a5a2d00c6e3ad);
const $4f26a62c588a77b4$var$prodConsentUrl = 'https://atlassian-slack-integration.services.atlassian.com/api/slack/login';
const $4f26a62c588a77b4$var$stagingConsentUrl = 'https://atlassian-slack-integration.stg.services.atlassian.com/api/slack/login';
const $4f26a62c588a77b4$export$cc6a5a2d00c6e3ad = (source, w = window)=>{
    const isProd = !(w.location.hostname.endsWith('jira-dev.com') || w.location.hostname === 'localhost');
    const url = isProd ? $4f26a62c588a77b4$var$prodConsentUrl : $4f26a62c588a77b4$var$stagingConsentUrl;
    return `${url}?source=${source}`;
};

});


parcelRegister("6YtCU", function(module, exports) {

$parcel$export(module.exports, "useFetchSlackStatus", () => $b5d5faf07bb9e0fb$export$bc4af53b82736ec2);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $dWLk9 = parcelRequire("dWLk9");
const $b5d5faf07bb9e0fb$export$7ee0516d378ea459 = (cloudId)=>(0, $2OdyW.default)(`/gateway/api/slack/jira/enabled?cloudId=${cloudId}`, {
        method: 'GET'
    }).then((response)=>Boolean(response.enabled)).catch(()=>true);
const $b5d5faf07bb9e0fb$export$71a3c7f7dc819106 = ()=>(0, $2OdyW.default)('/gateway/api/slack/jira/status', {
        method: 'GET'
    }).then((response)=>Boolean(response.connected)).catch(()=>false);
const $b5d5faf07bb9e0fb$export$bc4af53b82736ec2 = (skip = false)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [isSlackIntegrationEnabled, setSlackIntegrationEnabled] = (0, $eUqFw.useState)(true);
    const [isSlackIntegrationConnected, setSlackIntegrationConnected] = (0, $eUqFw.useState)(false);
    const [isLoading, setLoading] = (0, $eUqFw.useState)(true);
    (0, $eUqFw.useEffect)(()=>{
        if (skip || !cloudId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setSlackIntegrationEnabled(true);
        setSlackIntegrationConnected(false);
        Promise.all([
            $b5d5faf07bb9e0fb$export$7ee0516d378ea459(cloudId),
            $b5d5faf07bb9e0fb$export$71a3c7f7dc819106()
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([isEnabled, isConnected])=>{
            setSlackIntegrationEnabled(isEnabled);
            setSlackIntegrationConnected(isConnected);
        }) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(()=>{}).finally(()=>{
            setLoading(false);
        });
    }, [
        skip,
        cloudId
    ]);
    return {
        isLoading: isLoading,
        isSlackIntegrationEnabled: isSlackIntegrationEnabled,
        isSlackIntegrationConnected: isSlackIntegrationConnected
    };
};

});

parcelRegister("k09VB", function(module, exports) {

$parcel$export(module.exports, "PostOfficeContext", () => $e8fb823e18b042c0$export$a228be81fcb77b42);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $e8fb823e18b042c0$export$b77983be89bb0a4e);

var $eUqFw = parcelRequire("eUqFw");
const $e8fb823e18b042c0$export$a228be81fcb77b42 = (0, $eUqFw.createContext)({
    product: undefined,
    locale: undefined
});
const $e8fb823e18b042c0$export$b77983be89bb0a4e = $e8fb823e18b042c0$export$a228be81fcb77b42.Provider;
const $e8fb823e18b042c0$export$5bd9099e0ae94a43 = ()=>(0, $eUqFw.useContext)($e8fb823e18b042c0$export$a228be81fcb77b42);

});

parcelRegister("7Ekqe", function(module, exports) {

$parcel$export(module.exports, "DiscoverySurface", () => $02b5e825c3a4377f$export$194abd5f76c494d3);
$parcel$export(module.exports, "DiscoverySurfaceContextCollector", () => $02b5e825c3a4377f$export$1eb2547b4b2d2ec1);

var $2ubwb = parcelRequire("2ubwb");

var $ao0hp = parcelRequire("ao0hp");

var $bKxX9 = parcelRequire("bKxX9");

var $6rW04 = parcelRequire("6rW04");

var $cPEpP = parcelRequire("cPEpP");

var $jD3pk = parcelRequire("jD3pk");

var $80nQh = parcelRequire("80nQh");

var $gd0Sp = parcelRequire("gd0Sp");
const $02b5e825c3a4377f$var$getDiscoverySurfaceCohortValue = (locale)=>{
    if (locale.startsWith('en')) return (0, $bKxX9.ff)('jira.frontend.atlassian-switcher.discovery-sdk');
    return (0, $bKxX9.ff)('jira.app-recommendations.discovery-sdk.all-locale');
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $02b5e825c3a4377f$var$usersLocale = (0, $6rW04.default)('ajs-user-locale') ?? '';
const { useDiscoverySdk: $02b5e825c3a4377f$var$useDiscoverySdk, DiscoverySurface: $02b5e825c3a4377f$export$194abd5f76c494d3 } = (0, $2ubwb.createDiscoverySdk)({
    context: {
        product: 'jira'
    },
    enable: $02b5e825c3a4377f$var$getDiscoverySurfaceCohortValue($02b5e825c3a4377f$var$usersLocale)
});
const $02b5e825c3a4377f$export$1eb2547b4b2d2ec1 = ({ isOpen: isOpen })=>{
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { data: data } = (0, $cPEpP.useProject)();
    const { workspaceId: workspaceId } = (0, $80nQh.useWorkspaceContext)();
    const { setContext: setContext } = $02b5e825c3a4377f$var$useDiscoverySdk();
    setContext((current)=>({
            ...current,
            tenantId: cloudId || undefined,
            subproduct: data?.type,
            locale: (0, $ao0hp.standardizeLocale)($02b5e825c3a4377f$var$usersLocale),
            isSiteAdmin: isSiteAdmin,
            // stays true after the switcher has been opened for the first time
            switcherMenuHasBeenOpened: current.switcherMenuHasBeenOpened ? true : isOpen,
            orgId: orgId,
            workspaceId: workspaceId
        }));
    return null;
};

});
parcelRegister("2ubwb", function(module, exports) {

$parcel$export(module.exports, "createDiscoverySdk", () => $fee9ae3047d3e504$export$14ffcd9f1221fa3f);

var $eUqFw = parcelRequire("eUqFw");

var $d46DH = parcelRequire("d46DH");
var $a0eNT = parcelRequire("a0eNT");

var $cmUfV = parcelRequire("cmUfV");
var $6keBJ = parcelRequire("6keBJ");
var $gSS5J = parcelRequire("gSS5J");

var $6Qy8u = parcelRequire("6Qy8u");
var $9IbuV = parcelRequire("9IbuV");

var $b6nCV = parcelRequire("b6nCV");

var $ja8PP = parcelRequire("ja8PP");

var $gvRc5 = parcelRequire("gvRc5");

var $l8JlB = parcelRequire("l8JlB");

var $6c6gw = parcelRequire("6c6gw");

var $2v0PV = parcelRequire("2v0PV");

var $egmas = parcelRequire("egmas");

var $8930h = parcelRequire("8930h");
const $fee9ae3047d3e504$var$gqlEndpoint = '/gateway/api/graphql';
const $fee9ae3047d3e504$var$SurfaceRenderer = (0, $6keBJ.createSurfaceRenderer)({
    AppRecommendationsSectionHeader: $6c6gw.AppRecommendationsSectionHeader,
    AppRecommendationsList: $2v0PV.AppRecommendationsList,
    AppRecommendations: $l8JlB.AppRecommendations,
    AppRecommendationsWithTitle: $egmas.AppRecommendationsWithTitle
});
const $fee9ae3047d3e504$var$surfaces = {
    appSwitcher: {
        surfaceType: 'DiscoverySection',
        surfaceKey: 'app-recommendations-surface',
        contextDependencies: [
            'tenantId',
            'subproduct',
            'sessionId',
            'locale',
            'isSiteAdmin',
            'workspaceId',
            'orgId',
            {
                field: 'product',
                required: true
            },
            {
                field: 'switcherMenuHasBeenOpened',
                required: true
            }
        ],
        fallback: null
    }
};
const $fee9ae3047d3e504$var$disabledSdk = {
    DiscoverySurface: ()=>{
        return null;
    },
    setContext: (c)=>c,
    useDiscoverySdk: ()=>({
            setContext: (c)=>c
        })
};
const $fee9ae3047d3e504$export$14ffcd9f1221fa3f = (config)=>{
    if (config?.enable === false) return $fee9ae3047d3e504$var$disabledSdk;
    const surfaceLoader = config?.surfaceLoader ?? (0, $cmUfV.createSurfaceLoader)({
        gqlEndpoint: config?.graphqlEndpoint ?? $fee9ae3047d3e504$var$gqlEndpoint
    });
    const { useSurface: useSurface, updateContext: updateContext } = (0, $gSS5J.createSurfaceSdk)({
        surfaces: $fee9ae3047d3e504$var$surfaces,
        surfaceLoader: surfaceLoader,
        context: {
            ...config?.context
        },
        sideEffects: [
            (0, $gvRc5.observabilitySideEffects),
            ...config?.sideEffects ?? []
        ],
        contextMiddleware: (0, $ja8PP.createContextMiddleware)()
    });
    return {
        DiscoverySurface: ({ surface: surface, fallback: fallback, baseHeadingLevel: baseHeadingLevel, errorFallback: errorFallback })=>{
            const analyticsSideEffect = (0, $b6nCV.useAnalyticsSideEffect)((0, $d46DH.useFireAdControlAnalyticsEvents)(), (0, $a0eNT.useFireCrossFlowAnalyticsEvents)());
            const surfaceProps = useSurface(surface, analyticsSideEffect);
            (0, $9IbuV.useUFOComponentExperience)((0, $8930h.showRecommendations));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fee9ae3047d3e504$var$SurfaceRenderer, {
                ...surfaceProps,
                fallback: fallback ?? surfaceProps.fallback,
                errorFallback: errorFallback,
                baseHeadingLevel: baseHeadingLevel
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Qy8u.ExperienceSuccess), {
                experience: (0, $8930h.showRecommendations)
            }));
        },
        setContext: updateContext,
        useDiscoverySdk: ()=>{
            const setContextCallback = (0, $eUqFw.useCallback)(updateContext, []);
            return {
                setContext: setContextCallback
            };
        }
    };
};

});
parcelRegister("d46DH", function(module, exports) {

$parcel$export(module.exports, "useFireAdControlAnalyticsEvents", () => $a6fa4c31aa5ea07f$export$376b8a99b8453b1);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8fAH0 = parcelRequire("8fAH0");

var $01mPo = parcelRequire("01mPo");
const $a6fa4c31aa5ea07f$export$376b8a99b8453b1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $eUqFw.useRef)();
    const mapToCcpProductKeys = (0, $eUqFw.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $eUqFw.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds, targetProductId);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $eUqFw.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
};

});

parcelRegister("cmUfV", function(module, exports) {

$parcel$export(module.exports, "createSurfaceLoader", () => $0c509c3cccad39d5$export$bef4207efc76bc42);

var $5Mkmb = parcelRequire("5Mkmb");
const $0c509c3cccad39d5$var$surfaceLoaderQuery = `
  query SurfaceByTypeAndKey($type: String!, $key: String!, $context: JSON) {
    surfacePlatform {
      surfaceV2(type: $type, key: $key, context: $context) {
        key
        type
        label
        locale
        channel
        description
        definitionVersion
        revision
        fields
        zones
      }
    }
  }
`;
const $0c509c3cccad39d5$export$bef4207efc76bc42 = ({ gqlEndpoint: gqlEndpoint })=>async ({ surfaceType: surfaceType, surfaceKey: surfaceKey, contextResolver: contextResolver })=>{
        try {
            const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
            const responsePromise = $0c509c3cccad39d5$var$requestSurface(gqlEndpoint, surfaceType, surfaceKey, context);
            const surface = await $0c509c3cccad39d5$var$parseSurfaceFromResponse(responsePromise);
            return {
                surface: {
                    ...surface
                }
            };
        } catch (error) {
            return {
                surface: undefined,
                error: error
            };
        }
    };
const $0c509c3cccad39d5$var$requestSurface = async (gqlEndpoint, surfaceType, surfaceKey, context)=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const request = new Request(gqlEndpoint, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify({
            query: $0c509c3cccad39d5$var$surfaceLoaderQuery,
            variables: {
                type: surfaceType,
                key: surfaceKey,
                context: context
            }
        })
    });
    return fetch(request);
};
const $0c509c3cccad39d5$var$parseSurfaceFromResponse = async (promiseResponse)=>{
    const data = await promiseResponse.then((response)=>{
        if (!response.ok) return Promise.reject(Error(`Unexpected response - ${response.status} ${response.statusText}`));
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json?.errors) return Promise.reject(Error(`Graphql errors received - ${JSON.stringify(json.errors)}`));
        return json?.data;
    });
    const surface = data?.surfacePlatform?.surfaceV2;
    if (!(0, $5Mkmb.dataIsSurface)(surface)) return Promise.reject(Error('Received data could not be determined to be a valid surface'));
    return surface;
};

});
parcelRegister("5Mkmb", function(module, exports) {

$parcel$export(module.exports, "dataIsSurface", () => $51ada1da7d5319fe$export$8f20d4828736a2b4);
const $51ada1da7d5319fe$export$8f20d4828736a2b4 = (data)=>data?.type && data?.key && data?.fields;

});


parcelRegister("6keBJ", function(module, exports) {

$parcel$export(module.exports, "createSurfaceRenderer", () => $00eade762d6cca64$export$32834a319fd28b83);

var $eUqFw = parcelRequire("eUqFw");

var $gCrTT = parcelRequire("gCrTT");
const $00eade762d6cca64$var$createSurfaceElement = (type, props, ...children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(type, props, children);
const $00eade762d6cca64$var$incrementBaseHeadingLevel = (baseHeadingLevel)=>{
    const number = Number(baseHeadingLevel.replace('h', ''));
    return `h${Math.min(number + 1, 6)}`;
};
const $00eade762d6cca64$export$32834a319fd28b83 = (moduleDictionary)=>{
    const moduleMap = new Map(Object.entries(moduleDictionary));
    const ZoneRenderer = ({ zones: zones, createMutateAtModule: createMutateAtModule, updateId: updateId, headingLevel: headingLevel, createActionBusAtModule: createActionBusAtModule, context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, zones && Object.values(zones).flatMap((selectionItems)=>(selectionItems ?? []).map((selectionItem, i)=>{
                const module = selectionItem.data;
                if (module === null || !module?.type || !module?.key) return null;
                // Looks up imported modules, which are (kind of) similar to components and uses that if available
                const componentToRender = moduleMap.get(module.type);
                if (!componentToRender) throw new Error(`Surface Renderer tried to render a component of type ${module?.type} but no such component exists`);
                const mutate = createMutateAtModule(module.type, module.key);
                return $00eade762d6cca64$var$createSurfaceElement(componentToRender, {
                    ...module?.fields,
                    id: module.key,
                    key: [
                        module.type,
                        module.key,
                        i
                    ].join('-'),
                    actionBus: createActionBusAtModule(selectionItem),
                    context: context,
                    mutate: mutate,
                    headingLevel: headingLevel
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ZoneRenderer, {
                    key: `${Object.keys(zones ?? []).join('-')}-zones `,
                    updateId: updateId,
                    zones: module?.zones,
                    createMutateAtModule: createMutateAtModule,
                    headingLevel: $00eade762d6cca64$var$incrementBaseHeadingLevel(headingLevel),
                    createActionBusAtModule: createActionBusAtModule,
                    context: context
                }));
            })));
    const FallbackHandler = ({ error: error, isLoading: isLoading, surface: surface, fallback: fallback, children: children })=>{
        if (error) {
            if (!error.name || error.name === '') throw new Error(`Unnamed error in surface renderer. isLoading: ${isLoading}, surfaceExists: ${surface !== undefined}, stack: ${error.stack}`);
            throw error;
        }
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallback);
        if (!isLoading && !surface) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    };
    const SurfaceRenderer = ({ surface: surface, isLoading: isLoading, fallback: fallback, error: error, errorFallback: errorFallback = null, createMutateAtModule: createMutateAtModule, updateId: updateId, baseHeadingLevel: baseHeadingLevel, createActionBusAtModule: createActionBusAtModule, context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCrTT.default), {
            fallback: errorFallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackHandler, {
            surface: surface,
            error: error,
            isLoading: isLoading,
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ZoneRenderer, {
            key: `${Object.keys(surface?.zones ?? []).join('-')}-zones `,
            updateId: updateId,
            zones: surface?.zones,
            createMutateAtModule: createMutateAtModule,
            headingLevel: baseHeadingLevel,
            createActionBusAtModule: createActionBusAtModule,
            context: context
        })));
    return SurfaceRenderer;
};

});
parcelRegister("gCrTT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f2b3dbf8ece535$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
const $a2f2b3dbf8ece535$var$CROSS_FLOW_CHANNEL = 'crossFlow';
class $a2f2b3dbf8ece535$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'surfaceErrorBoundary',
            attributes: {
                error: error,
                errorInfo: errorInfo
            }
        });
        analyticsEvent.fire($a2f2b3dbf8ece535$var$CROSS_FLOW_CHANNEL);
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.props.fallback) : null;
        return this.props.children;
    }
}
var $a2f2b3dbf8ece535$export$2e2bcd8739ae039 = (0, $2jDha.default)()($a2f2b3dbf8ece535$var$ErrorBoundary);

});


parcelRegister("gSS5J", function(module, exports) {

$parcel$export(module.exports, "createSurfaceSdk", () => $793af89cf494f30f$export$abc203433f95ced9);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $epILn = parcelRequire("epILn");

var $11Jl1 = parcelRequire("11Jl1");

var $hlx8t = parcelRequire("hlx8t");

var $3Rkm6 = parcelRequire("3Rkm6");

var $60VcB = parcelRequire("60VcB");

var $9fgFj = parcelRequire("9fgFj");

var $wEDcQ = parcelRequire("wEDcQ");

var $6keBJ = parcelRequire("6keBJ");

var $cmUfV = parcelRequire("cmUfV");
const $793af89cf494f30f$var$isEagerSurfaceInitialization = (surfaceInit)=>!surfaceInit.load || surfaceInit.load === 'EAGER';
const $793af89cf494f30f$var$eagerLoadSurfaces = (surfaceLoader)=>async (surfaces, update, context)=>{
        Object.entries(surfaces).forEach(async ([name, surfaceInit])=>{
            if (!$793af89cf494f30f$var$isEagerSurfaceInitialization(surfaceInit)) return;
            const { surfaceType: surfaceType, surfaceKey: surfaceKey, fallback: fallback } = surfaceInit;
            const experienceMetaData = {
                metadata: {
                    surfaceType: surfaceType,
                    surfaceKey: surfaceKey
                }
            };
            const surfaceLoaderPromise = (0, $wEDcQ.loadSurfaceExperience).start();
            const { surface: surface, error: error } = await surfaceLoader({
                surfaceType: surfaceType,
                surfaceKey: surfaceKey,
                contextResolver: ()=>{
                    const { switcherMenuHasBeenOpened: switcherMenuHasBeenOpened, ...rest } = context || {
                        switcherMenuHasBeenOpened: true
                    };
                    return rest;
                }
            });
            await surfaceLoaderPromise;
            if (surface) // only record success metric in eager load as failure will be retried
            await (0, $wEDcQ.loadSurfaceExperience).success(experienceMetaData);
            update(name, {
                surface: surface,
                isLoading: !surface,
                fallback: fallback,
                error: error
            });
        });
    };
const $793af89cf494f30f$var$isSurfaceStore = (initializationOptions)=>!!initializationOptions.getCurrentSurfaceState;
const $793af89cf494f30f$var$createMutateAtModuleFactory = (getCurrentState, update)=>(moduleType, moduleKey)=>(mutation)=>{
            const state = getCurrentState();
            update(state.name, ({ surface: surface })=>{
                const state = getCurrentState();
                const modulePaths = state.surface ? (0, $60VcB.getModulePathsInSurface)(state.surface) : new Map();
                if (!surface) return {
                    surface: surface
                };
                const modulePath = modulePaths.get((0, $3Rkm6.buildCombinedKey)(moduleType, moduleKey));
                if (!modulePath) throw Error(`tried to update surface module with id of ${moduleKey} path but could not find that module`);
                const currentModuleConfiguration = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(state.surface, modulePath)?.fields;
                if (typeof mutation === 'function' && !currentModuleConfiguration) throw Error(`tried to access currentState of surface module with id of ${moduleKey} path but could not find that module`);
                return {
                    surface: (0, $9fgFj.setModuleStateAtPath)(modulePath)(surface, typeof mutation === 'function' ? mutation(currentModuleConfiguration) : mutation)
                };
            });
        };
const $793af89cf494f30f$var$isContextReady = (contextDependencies = [])=>(subscriberContext)=>contextDependencies.every((dep)=>{
            if (typeof dep === 'string') return Object.keys(subscriberContext).includes(dep);
            if (dep?.match) return !!subscriberContext?.[dep.field]?.match(dep.match);
            if (dep?.required) return !!(subscriberContext?.[dep.field] ?? false);
            return true;
        });
const $793af89cf494f30f$var$transformSurfacesToSubscribers = (surfaceLoader, update)=>(surfaces)=>Object.entries(surfaces).filter((surface)=>surface[1].load === 'LAZY' || surface[1].load === undefined).map(([surfaceName, { contextDependencies: contextDependencies, ...surface }])=>[
                ({ subscriberContext: subscriberContext })=>{
                    if (!$793af89cf494f30f$var$isContextReady(contextDependencies)(subscriberContext)) return;
                    $793af89cf494f30f$var$eagerLoadSurfaces(surfaceLoader)({
                        [surfaceName]: surface
                    }, update, subscriberContext);
                },
                contextDependencies?.map((dep)=>typeof dep === 'string' ? dep : dep.field),
                {
                    updateOnSubscribe: true
                }
            ]);
const $793af89cf494f30f$export$abc203433f95ced9 = ({ surfaces: surfaces, surfaceLoader: surfaceLoader, sideEffects: sideEffects = [], context: context = {}, contextMiddleware: contextMiddleware })=>{
    const contextStore = (0, $11Jl1.createContextStore)({
        initialState: context,
        middleware: contextMiddleware
    });
    const store = $793af89cf494f30f$var$isSurfaceStore(surfaces) ? surfaces : (()=>{
        const _store = (0, $hlx8t.createSurfaceStore)(surfaces);
        const surfaceToSubs = $793af89cf494f30f$var$transformSurfacesToSubscribers(surfaceLoader, _store.update);
        contextStore.subscribe(...surfaceToSubs(surfaces));
        return _store;
    })();
    const useSurface = (surfaceName, analyticsSideEffect)=>{
        const [state, setState] = (0, $eUqFw.useState)(store.getCurrentSurfaceState(surfaceName));
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const createMutateAtModule = (0, $eUqFw.useCallback)($793af89cf494f30f$var$createMutateAtModuleFactory(()=>store.getCurrentSurfaceState(surfaceName), store.update), []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const createActionBusWithContexts = (0, $eUqFw.useMemo)(()=>(0, $epILn.createActionBusWithContextsFactory)({
                sideEffects: analyticsSideEffect ? [
                    ...sideEffects,
                    analyticsSideEffect
                ] : sideEffects
            }), [
            analyticsSideEffect
        ]);
        const lazyLoadSurface = (0, $eUqFw.useCallback)(async (surfaceType, surfaceKey)=>{
            try {
                store.getCurrentSurfaceStateFromKeys(surfaceType, surfaceKey);
                return;
            } catch  {
                const experienceMetaData = {
                    metadata: {
                        surfaceType: surfaceType,
                        surfaceKey: surfaceKey
                    }
                };
                const surfaceLoaderPromise = (0, $wEDcQ.loadSurfaceExperience).start();
                const { surface: surface, error: error } = await surfaceLoader({
                    surfaceType: surfaceType,
                    surfaceKey: surfaceKey,
                    contextResolver: ()=>{
                        const context = contextStore.getCurrentContext();
                        const { switcherMenuHasBeenOpened: switcherMenuHasBeenOpened, ...rest } = context || {
                            switcherMenuHasBeenOpened: true
                        };
                        return rest;
                    }
                });
                await surfaceLoaderPromise;
                if (surface) await (0, $wEDcQ.loadSurfaceExperience).success(experienceMetaData);
                else await (0, $wEDcQ.loadSurfaceExperience).failure(experienceMetaData);
                store.update(surfaceName, {
                    error: error,
                    surface: surface,
                    isLoading: false
                });
            }
        }, [
            surfaceName
        ]);
        (0, $eUqFw.useEffect)(()=>{
            const unsubscribe = store.subscribe(setState, [
                surfaceName
            ], {
                updateOnSubscribe: true
            });
            const surfaceInit = store.getSurfaceInitializationOptions(surfaceName);
            const currentState = store.getCurrentSurfaceState(surfaceName);
            if (surfaceInit?.load === 'LAZY' && surfaceInit?.surfaceType && surfaceInit?.surfaceKey || surfaceInit && $793af89cf494f30f$var$isEagerSurfaceInitialization(surfaceInit) && currentState?.error instanceof Error // Try to reload if eager load has previously failed
            ) lazyLoadSurface(surfaceInit.surfaceType, surfaceInit.surfaceKey);
            return unsubscribe;
        }, [
            surfaceName,
            lazyLoadSurface
        ]);
        return {
            createMutateAtModule: createMutateAtModule,
            createActionBusAtModule: createActionBusWithContexts({
                client: contextStore.getCurrentContext(),
                surfaceName: state.surface?.type ?? surfaceName
            }),
            context: contextStore.getCurrentContext(),
            ...state
        };
    };
    return {
        useSurface: useSurface,
        updateContext: contextStore.update,
        store: store
    };
};

});
parcelRegister("epILn", function(module, exports) {

$parcel$export(module.exports, "ContextsSymbol", () => $560bec1f327370c1$export$1d839cb062253f18);
$parcel$export(module.exports, "createActionBusWithContextsFactory", () => $560bec1f327370c1$export$ff3fe268a3b84343);

var $j8deM = parcelRequire("j8deM");
const $560bec1f327370c1$export$1d839cb062253f18 = Symbol('@@contexts');
const $560bec1f327370c1$var$pipe = (functions)=>(args)=>functions.reduce((acc, fn)=>fn(acc), args);
const $560bec1f327370c1$export$2913aee7992f6c52 = (middlewares)=>(action)=>$560bec1f327370c1$var$pipe(middlewares)(action);
const $560bec1f327370c1$var$sideEffectToMiddleware = (sideEffect)=>(action)=>{
        sideEffect({
            action: action,
            contexts: (0, $j8deM.extractContextsFromAction)(action) ?? {}
        });
        return action;
    };
const $560bec1f327370c1$export$c001373022545dbd = (config)=>{
    const middlewares = (config?.sideEffects ?? []).map((sideEffect)=>$560bec1f327370c1$var$sideEffectToMiddleware(sideEffect));
    const applyMiddlewares = $560bec1f327370c1$export$2913aee7992f6c52(middlewares);
    const subscribers = new Map([]);
    const updateSubscriber = ([selectors, subscription])=>(action)=>{
            if (selectors.includes(action.type)) subscription(action.payload);
        };
    const updateSubscibers = (action)=>{
        subscribers.forEach((...subscriber)=>updateSubscriber(subscriber)(action));
    };
    const dispatchWithContexts = (contexts)=>(...args)=>{
            const [type, payload] = args;
            const action = {
                type: type,
                payload: payload ?? {}
            };
            if (contexts) // This attaches contexts from the module for analytics
            // It is delibrately excluded from types and
            // made readonly
            Object.defineProperty(action, $560bec1f327370c1$export$1d839cb062253f18, {
                value: contexts,
                writable: false,
                enumerable: false
            });
            updateSubscibers(applyMiddlewares(action));
        };
    return {
        dispatch: dispatchWithContexts(),
        dispatchWithContexts: dispatchWithContexts,
        on: (...[action, callback])=>{
            subscribers.set(callback, [
                action
            ]);
            return ()=>{
                subscribers.delete(callback);
            };
        }
    };
};
const $560bec1f327370c1$export$ff3fe268a3b84343 = (config)=>{
    const { on: on, dispatchWithContexts: dispatchWithContexts } = $560bec1f327370c1$export$c001373022545dbd(config);
    return (contexts)=>({ data: module, reasons: reasons })=>({
                on: on,
                dispatch: dispatchWithContexts({
                    ...contexts,
                    module: module,
                    reasons: reasons
                })
            });
};

});
parcelRegister("j8deM", function(module, exports) {

$parcel$export(module.exports, "extractContextsFromAction", () => $bff4cc3984092962$export$d01221f46d8c0a4c);

var $epILn = parcelRequire("epILn");
const $bff4cc3984092962$var$isActionWithContexts = (action)=>!!action?.[0, $epILn.ContextsSymbol];
const $bff4cc3984092962$export$d01221f46d8c0a4c = (action)=>$bff4cc3984092962$var$isActionWithContexts(action) ? action[0, $epILn.ContextsSymbol] : undefined;

});


parcelRegister("11Jl1", function(module, exports) {

$parcel$export(module.exports, "createContextStore", () => $2e2fe80399026355$export$442fcc989576400e);
const $2e2fe80399026355$var$createDiff = (left, right)=>Object.entries(left).reduce((acc, [key, value])=>right?.[key] !== value ? {
            ...acc,
            [key]: right?.[key]
        } : acc, {});
const $2e2fe80399026355$var$createSubscriberContext = (context, selectors)=>selectors.reduce((a, selector)=>({
            ...a,
            [selector]: context?.[selector]
        }), {});
const $2e2fe80399026355$var$idenityMiddleware = (context)=>context;
const $2e2fe80399026355$export$442fcc989576400e = (config)=>{
    const initialState = config?.initialState;
    const middleware = config?.middleware ?? $2e2fe80399026355$var$idenityMiddleware;
    let state = middleware({
        tenantId: undefined,
        isSiteAdmin: undefined,
        product: undefined,
        subproduct: undefined,
        switcherMenuHasBeenOpened: undefined,
        sessionId: undefined,
        locale: undefined,
        orgId: undefined,
        workspaceId: undefined,
        ...initialState
    });
    const subscribers = new Map();
    const updateSubscribers = (updatedContext, changes)=>{
        const changedKeys = Object.keys(changes);
        subscribers.forEach((selectors, subscription)=>{
            if (!selectors || changedKeys.find((changedKey)=>selectors.includes(changedKey))) updateSubscriber({
                subscription: subscription,
                context: updatedContext,
                subscriberContext: selectors ? $2e2fe80399026355$var$createSubscriberContext(updatedContext, selectors) : updatedContext,
                changes: changes
            });
        });
    };
    const updateSubscriber = ({ subscription: subscription, context: context, subscriberContext: subscriberContext, changes: changes = {} })=>{
        subscription({
            subscriberContext: subscriberContext,
            changes: changes,
            context: context
        });
    };
    const update = (callback)=>{
        const newState = middleware(callback(state));
        updateSubscribers(newState, $2e2fe80399026355$var$createDiff(state, newState));
        state = newState;
    };
    const subscribe = (...newSubscribers)=>{
        newSubscribers.forEach((newSubscriber)=>{
            const [subscription, selectors, options] = newSubscriber;
            if (options?.updateOnSubscribe) updateSubscriber({
                subscription: subscription,
                context: state,
                subscriberContext: selectors ? $2e2fe80399026355$var$createSubscriberContext(state, selectors) : state
            });
            subscribers.set(subscription, selectors);
        });
    };
    const unsubscribe = (subscription)=>{
        !!subscription ? subscribers.delete(subscription) : subscribers.clear();
    };
    const getCurrentContext = ()=>state;
    return {
        update: update,
        subscribe: subscribe,
        getCurrentContext: getCurrentContext,
        unsubscribe: unsubscribe
    };
};

});

parcelRegister("hlx8t", function(module, exports) {

$parcel$export(module.exports, "createSurfaceStore", () => $48ac8bc495f1f14e$export$7803f0281247d54d);

var $gq0ar = parcelRequire("gq0ar");
const $48ac8bc495f1f14e$var$transformSurfaceInitToSurfaceState = (name, initOptions)=>({
        name: name,
        error: undefined,
        fallback: initOptions?.fallback
    });
const $48ac8bc495f1f14e$var$transformSurfaceInitializationToClientSurfaceStates = (surfaces)=>new Map(Object.entries(surfaces).map(([name, initOptions])=>[
            name,
            $48ac8bc495f1f14e$var$transformSurfaceInitToSurfaceState(name, initOptions)
        ]));
const $48ac8bc495f1f14e$var$transformSurfaceInitializationToSurfaceByCombinedKey = (surfaces)=>new Map(Object.entries(Object.entries(surfaces).reduce((a, [, initOptions])=>{
        const surfaceKey = initOptions.surfaceKey ?? initOptions.surface?.key;
        const surfaceType = initOptions.surfaceType ?? initOptions.surface?.type;
        const combinedKey = $48ac8bc495f1f14e$var$buildCombinedKey(surfaceType, surfaceKey);
        const updateId = (0, $gq0ar.createUpdateId)();
        return {
            ...a,
            [combinedKey]: {
                updateId: updateId,
                surface: a?.[combinedKey]?.surface || initOptions?.surface,
                isLoading: !(a?.[combinedKey]?.surface || initOptions.load === 'PRE')
            }
        };
    }, {})));
const $48ac8bc495f1f14e$export$f1006fc0f0c38e36 = (surfaces)=>new Map(Object.entries(surfaces).map(([name, initOptions])=>[
            name,
            $48ac8bc495f1f14e$var$buildCombinedKey(initOptions.surfaceType ?? initOptions.surface?.type, initOptions.surfaceKey ?? initOptions.surface?.key)
        ]));
const $48ac8bc495f1f14e$var$createSurfaceStates = (surfaces)=>{
    const clientSurfaceStates = $48ac8bc495f1f14e$var$transformSurfaceInitializationToClientSurfaceStates(surfaces);
    const surfaceCombinedKeyByName = $48ac8bc495f1f14e$export$f1006fc0f0c38e36(surfaces);
    const surfacesByCombinedKey = $48ac8bc495f1f14e$var$transformSurfaceInitializationToSurfaceByCombinedKey(surfaces);
    return {
        set: (name, state)=>{
            const surfaceCombinedKey = surfaceCombinedKeyByName.get(name);
            const updateId = (0, $gq0ar.createUpdateId)();
            if (!surfaceCombinedKey || !clientSurfaceStates.has(name) || !surfacesByCombinedKey.has(surfaceCombinedKey)) throw Error(`Tried to update a surface with name ${name}, but no surface of that name exists. Check your initialization settings`);
            clientSurfaceStates.set(name, {
                name: name,
                fallback: state.fallback,
                error: state.error
            });
            surfacesByCombinedKey.set(surfaceCombinedKey, {
                updateId: updateId,
                surface: state.surface,
                isLoading: state.isLoading
            });
        },
        get: (name)=>{
            try {
                const surfaceCombinedKey = surfaceCombinedKeyByName.get(name);
                const surfaceState = clientSurfaceStates.get(name);
                const surfaceByCombinedKey = surfacesByCombinedKey.get(surfaceCombinedKey);
                if (!surfaceState || !surfaceByCombinedKey) throw Error;
                return {
                    ...surfaceState,
                    ...surfaceByCombinedKey
                };
            } catch  {
                throw Error(`Tried to get surface with name "${name}" but no surface of that name was initialized`);
            }
        },
        isSelected: (name, selectors)=>!!selectors.find((selector)=>surfaceCombinedKeyByName.get(selector) === surfaceCombinedKeyByName.get(name))
    };
};
const $48ac8bc495f1f14e$export$7803f0281247d54d = (surfaceInitializationOptions)=>{
    let surfaceStates = $48ac8bc495f1f14e$var$createSurfaceStates(surfaceInitializationOptions);
    const subscribers = new Map();
    const updateSubscribers = ({ name: name })=>{
        const surfaceName = name;
        subscribers.forEach((subscriber)=>updateSubscriber(subscriber, surfaceName));
    };
    const updateSubscriber = (subscriber, surfaceName)=>{
        const [subscription, selectors] = subscriber;
        if (!selectors || surfaceStates.isSelected(surfaceName, selectors)) {
            const state = surfaceStates.get(surfaceName);
            if (state) subscription(state);
        }
    };
    const subscribe = (...subscriber)=>{
        const [subscription, selectors, options] = subscriber;
        subscribers.set(subscriber, subscriber);
        if (options?.updateOnSubscribe) selectors?.forEach((selector)=>{
            updateSubscriber([
                subscription,
                [
                    selector
                ]
            ], selector);
        });
        return ()=>subscribers.delete(subscriber);
    };
    const setState = (newSurfaceState, callback)=>{
        const surfaceName = newSurfaceState.name;
        surfaceStates.set(surfaceName, newSurfaceState);
        callback();
    };
    const update = (surfaceName, surfaceState)=>{
        const previousSurfaceState = surfaceStates.get(surfaceName);
        const partialSurfaceState = typeof surfaceState === 'function' ? surfaceState(surfaceStates.get(surfaceName)) : surfaceState;
        const newSurfaceState = {
            ...previousSurfaceState,
            ...partialSurfaceState
        };
        setState(newSurfaceState, ()=>{
            updateSubscribers(newSurfaceState);
        });
    };
    const getCurrentSurfaceState = (surfaceName)=>surfaceStates.get(surfaceName);
    const getCurrentSurfaceStateFromKeys = (surfaceType, surfaceKey)=>surfaceStates.get($48ac8bc495f1f14e$var$buildCombinedKey(surfaceType, surfaceKey));
    const getSurfaceInitializationOptions = (surfaceName)=>{
        const surfaceOptions = surfaceInitializationOptions?.[surfaceName];
        if (!surfaceOptions) throw Error(`Tried to get surface initializations options for "${surfaceName}" but no surface of that name was initialized`);
        return surfaceOptions;
    };
    const getSurfaces = ()=>{
        return surfaceInitializationOptions;
    };
    return {
        getSurfaceInitializationOptions: getSurfaceInitializationOptions,
        getCurrentSurfaceState: getCurrentSurfaceState,
        getCurrentSurfaceStateFromKeys: getCurrentSurfaceStateFromKeys,
        getSurfaces: getSurfaces,
        update: update,
        subscribe: subscribe
    };
};
function $48ac8bc495f1f14e$var$buildCombinedKey(SurfaceType, surfaceKey) {
    return `${SurfaceType},${surfaceKey}`;
}

});
parcelRegister("gq0ar", function(module, exports) {

$parcel$export(module.exports, "createUpdateId", () => $0f6ed0ca8cf27e0a$export$6eab04d30ab6b5ee);
const $0f6ed0ca8cf27e0a$export$6eab04d30ab6b5ee = ()=>{
    const input = new Uint32Array(12);
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!#$%^&-_0123456789';
    if (typeof window !== 'undefined' && window?.crypto) {
        const output = window.crypto.getRandomValues(input);
        return output.reduce((acc, value)=>`${acc}${characters.charAt(Math.floor(value % characters.length))}`, '');
    }
    return input.reduce((acc)=>`${acc}${characters.charAt(Math.floor(Math.random() * characters.length))}`, '');
};

});


parcelRegister("3Rkm6", function(module, exports) {

$parcel$export(module.exports, "buildCombinedKey", () => $bc3cf63fb9e23853$export$685ef91dcd97b5e5);
// Utility to build a combined key for identifying a surface or module using the type and key
const $bc3cf63fb9e23853$export$685ef91dcd97b5e5 = (type, key)=>{
    return `${type},${key}`;
};

});

parcelRegister("60VcB", function(module, exports) {

$parcel$export(module.exports, "getModulePathsInSurface", () => $1535357d8190d0d6$export$33fc1ff5a905fd3c);

var $3Rkm6 = parcelRequire("3Rkm6");
const $1535357d8190d0d6$export$8b393145032738c2 = (outputMap, module, currentPath = [])=>{
    if (module.key && module.type) outputMap.set((0, $3Rkm6.buildCombinedKey)(module.type, module.key), currentPath.join('.'));
    if (module.zones) Object.entries(module.zones).forEach(([zoneKey, value])=>{
        value.forEach((m, i)=>{
            if (m.data) $1535357d8190d0d6$export$8b393145032738c2(outputMap, m.data, [
                ...currentPath,
                `zones.${zoneKey}[${i}].data`
            ]);
        });
    });
};
const $1535357d8190d0d6$export$33fc1ff5a905fd3c = (surface)=>{
    const outputMap = new Map();
    $1535357d8190d0d6$export$8b393145032738c2(outputMap, surface);
    return outputMap;
};

});

parcelRegister("9fgFj", function(module, exports) {

$parcel$export(module.exports, "setModuleStateAtPath", () => $fec401d7457a754b$export$9679d11ddd39f0f1);

var $kd0cS = parcelRequire("kd0cS");

var $a0i0f = parcelRequire("a0i0f");
const $fec401d7457a754b$export$9679d11ddd39f0f1 = (modulePath)=>(surface, newProps)=>{
        const surfaceCopy = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(surface);
        switch(true){
            case newProps === null:
                (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(surfaceCopy, modulePath, null);
                break;
            case newProps.hasOwnProperty('componentName') && newProps.hasOwnProperty('props'):
                (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(surfaceCopy, `${modulePath}.name`, newProps.componentName);
                (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(surfaceCopy, `${modulePath}.fields`, newProps.props);
                break;
            default:
                (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(surfaceCopy, `${modulePath}.fields`, newProps);
                break;
        }
        return surfaceCopy;
    };

});
parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("wEDcQ", function(module, exports) {

$parcel$export(module.exports, "loadSurfaceExperience", () => $1d6700fded387fcb$export$51b10c156e320484);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $1d6700fded387fcb$var$platform = {
    platform: {
        component: 'surface-sdk'
    }
};
const $1d6700fded387fcb$export$51b10c156e320484 = new (0, $kDfSL.UFOExperience)('load-surface', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    ...$1d6700fded387fcb$var$platform
});

});


parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("b6nCV", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsSideEffect", () => $73b731de414b30f5$export$11a25966c1f951bd);
const $73b731de414b30f5$export$11a25966c1f951bd = (adControlAnalyticsMethods, surfaceAnalyticsMethods)=>({ action: action, contexts: contexts })=>{
        const fields = contexts.module?.fields;
        const recommendationSession = {
            type: 'appRec',
            id: contexts.client?.sessionId ?? ''
        };
        switch(action.type){
            case 'USER_VIEW_DISCOVERY_SURFACE':
                surfaceAnalyticsMethods.fireViewedUIEvent(action.payload.action, {
                    source: action.payload.source,
                    recommendedProductIds: fields?.apps?.map((app)=>app.productId) || [],
                    recommendationSession: recommendationSession
                });
                break;
            case 'CLICK_APP_RECOMMENDATION':
                surfaceAnalyticsMethods.fireInteractedUIEvent(action.payload.action, {
                    source: action.payload.source,
                    targetProductId: action.payload.productId,
                    recommendedProductIds: fields?.apps?.map((app)=>app.productId),
                    recommendationSession: recommendationSession
                }, {
                    skipBenefitsPageExperimentCohort: action.payload.skipBenefitsPageExperimentCohort,
                    tblzSwitcherRoleBasedExperimentCohort: action.payload.tblzSwitcherRoleBasedExperimentCohort
                });
                break;
            case 'DISMISS_APP':
            case 'OPEN_APP_DROP_DOWN_MENU':
            case 'SHOW_REASONS':
            case 'CLOSE_APP_DISMISSED_FLAG':
            case 'CLICK_PRIVACY_POLICY_LINK':
            case 'DISMISS_RECOMMENDATION_REASONS_MODAL':
                adControlAnalyticsMethods.fireInteractedUIEvent(action.payload.action, {
                    source: action.payload.source,
                    targetProductId: action.payload.productId,
                    recommendedProductIds: fields?.apps?.map((app)=>app.productId),
                    recommendationSession: recommendationSession
                }, {
                    tblzSwitcherRoleBasedExperimentCohort: action.payload.tblzSwitcherRoleBasedExperimentCohort
                });
                break;
            case 'USER_VIEW_RECOMMENDED_REASONS_SCREEN':
                adControlAnalyticsMethods?.fireViewedScreenEvent(action.payload.name, {
                    recommendedProductIds: fields?.apps?.map((app)=>app.productId) || [],
                    recommendationSession: recommendationSession,
                    targetProductId: action.payload.productId
                });
                break;
            default:
                break;
        }
    };

});

parcelRegister("ja8PP", function(module, exports) {

$parcel$export(module.exports, "createContextMiddleware", () => $758e0358a16a834f$export$df8b5520963ff5fa);

var $cQkCt = parcelRequire("cQkCt");

var $eV8U4 = parcelRequire("eV8U4");

var $efsYo = parcelRequire("efsYo");
const $758e0358a16a834f$var$defaultsMiddleware = (context)=>context;
const $758e0358a16a834f$var$createSessionIdMiddleware = ()=>{
    let previousContext;
    return (context)=>{
        if (previousContext === undefined && context.sessionId) {
            previousContext = context;
            return context;
        }
        if (!context.sessionId || (0, $eV8U4.isContextChanged)(previousContext, context)) {
            const newContext = {
                ...context,
                sessionId: (0, $cQkCt.createSessionId)()
            };
            previousContext = newContext;
            return newContext;
        }
        return context;
    };
};
const $758e0358a16a834f$export$dd5a2c290382fcf3 = ({ subproduct: subproduct, ...context })=>({
        ...context,
        subproduct: (0, $efsYo.mapSubproduct)(subproduct)
    });
const $758e0358a16a834f$export$df8b5520963ff5fa = ()=>{
    /**
	 * Session id refers to a context session. When context changes the session will update
	 */ const sessionIdMiddleware = $758e0358a16a834f$var$createSessionIdMiddleware();
    return (context)=>$758e0358a16a834f$var$defaultsMiddleware($758e0358a16a834f$export$dd5a2c290382fcf3(sessionIdMiddleware(context)));
};

});
parcelRegister("cQkCt", function(module, exports) {

$parcel$export(module.exports, "createSessionId", () => $a1c36128c7a0b5d3$export$b44e2b9eb66cb0e6);

var $hompL = parcelRequire("hompL");
const $a1c36128c7a0b5d3$export$b44e2b9eb66cb0e6 = ()=>(0, $hompL.v4)();

});

parcelRegister("eV8U4", function(module, exports) {

$parcel$export(module.exports, "isContextChanged", () => $bc28fd724ecfe42b$export$73bc6b275323373a);
const $bc28fd724ecfe42b$var$areContextsTheSame = (left, right)=>!Object.entries(left).every(([k, v])=>right.hasOwnProperty(k) && right[k] === v);
const $bc28fd724ecfe42b$export$73bc6b275323373a = (previousContext, newContext)=>previousContext && newContext && $bc28fd724ecfe42b$var$areContextsTheSame(previousContext, newContext) && $bc28fd724ecfe42b$var$areContextsTheSame(newContext, previousContext);

});

parcelRegister("efsYo", function(module, exports) {

$parcel$export(module.exports, "mapSubproduct", () => $0b2ed9eb261d687d$export$276599326610bc8f);
const $0b2ed9eb261d687d$export$276599326610bc8f = (subproduct)=>{
    switch(subproduct){
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'polaris';
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            return subproduct;
    }
};

});


parcelRegister("gvRc5", function(module, exports) {

$parcel$export(module.exports, "observabilitySideEffects", () => $42865a0d01c409b8$export$c227cc63b2f8350f);

var $8930h = parcelRequire("8930h");
const $42865a0d01c409b8$export$c227cc63b2f8350f = ({ action: action })=>{
    try {
        switch(action.type){
            case 'SHOW_REASONS':
                (0, $8930h.showReasons).start();
                break;
            case 'DISMISS_START':
                (0, $8930h.dismiss).start();
                break;
            case 'DISMISS_SUCCESS':
                (0, $8930h.dismiss).success();
                break;
            case 'DISMISS_FAILURE':
                (0, $8930h.dismiss).failure();
                break;
            default:
                break;
        }
    } catch (error) {
    // TODO: error handling
    }
};

});
parcelRegister("8930h", function(module, exports) {

$parcel$export(module.exports, "showRecommendations", () => $4381ee352352c084$export$6312af6bd52a8cdc);
$parcel$export(module.exports, "dismiss", () => $4381ee352352c084$export$abf286bbe7073aba);
$parcel$export(module.exports, "showReasons", () => $4381ee352352c084$export$7132ee5d0ee6bcbd);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $4381ee352352c084$var$platform = {
    platform: {
        component: 'discovery-sdk'
    }
};
const $4381ee352352c084$export$6312af6bd52a8cdc = new (0, $kDfSL.UFOExperience)('show-recommendations', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
    ...$4381ee352352c084$var$platform
});
const $4381ee352352c084$export$abf286bbe7073aba = new (0, $kDfSL.UFOExperience)('dismiss', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    ...$4381ee352352c084$var$platform
});
const $4381ee352352c084$export$7132ee5d0ee6bcbd = new (0, $kDfSL.UFOExperience)('show-reasons', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    ...$4381ee352352c084$var$platform
});

});


parcelRegister("l8JlB", function(module, exports) {

$parcel$export(module.exports, "AppRecommendations", () => $50e7f0b6eb7a169e$export$3f34104900714363);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxfrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $50e7f0b6eb7a169e$export$3f34104900714363 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("6c6gw", function(module, exports) {

$parcel$export(module.exports, "AppRecommendationsSectionHeader", () => $a3a421abf8aef456$export$a5496785270ffa14);
/** @jsxRuntime classic */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxfrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Qivz = parcelRequire("1Qivz");

var $PdmhA = parcelRequire("PdmhA");
const $a3a421abf8aef456$var$HeadingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    fontWeight: 700,
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
    fontSize: '11px',
    marginBottom: "var(--ds-space-050, 4px)",
    textTransform: 'uppercase',
    marginTop: "var(--ds-space-0, 0px)",
    marginLeft: "var(--ds-space-100, 8px)"
});
const $a3a421abf8aef456$export$a5496785270ffa14 = ({ title: title, noAppsTitle: noAppsTitle = 'Discover', headingLevel: headingLevel, actionBus: actionBus, mutate: mutate })=>{
    const HeadingAs = headingLevel;
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = actionBus?.on('USE_EMPTY_APPS_TITLE', ()=>{
            mutate((currentProps)=>({
                    ...currentProps,
                    title: noAppsTitle
                }));
        });
        return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        actionBus
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)(HeadingAs, {
        "data-testid": 'discovery-sdk-component--app-recommendation-section-header',
        css: $a3a421abf8aef456$var$HeadingStyles
    }, title);
};
$a3a421abf8aef456$export$a5496785270ffa14.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    noAppsTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    headingLevel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ]).isRequired
};

});

parcelRegister("2v0PV", function(module, exports) {

$parcel$export(module.exports, "AppRecommendationsList", () => $f6c4317e49be5811$export$5d3f41a8dd5f8ce2);
/** @jsxRuntime classic */ /**
                            * @jsxRuntime classic
                            * @jsx jsx
                            */ /** @jsxfrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Qivz = parcelRequire("1Qivz");

var $dfimj = parcelRequire("dfimj");

var $a0eNT = parcelRequire("a0eNT");

var $dHBPr = parcelRequire("dHBPr");

var $1OExy = parcelRequire("1OExy");
function $f6c4317e49be5811$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $f6c4317e49be5811$var$UndoDismissFlag = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("aSJXn")));
const $f6c4317e49be5811$var$ListResetStyles = {
    name: "1772xtw",
    styles: "padding:0;margin:0"
};
const $f6c4317e49be5811$var$containerStyles = {
    name: "182bzef",
    styles: "list-style-type:none;margin:0"
};
const $f6c4317e49be5811$export$5d3f41a8dd5f8ce2 = ({ actionBus: actionBus, flagNotInterestedSubtitle: flagNotInterestedSubtitle, flagNotInterestedTitle: flagNotInterestedTitle, apps: apps, mutate: mutate, context: context, recommendationReasonsModalAcceptButton: recommendationReasonsModalAcceptButton, recommendationReasonsModalExplanation: recommendationReasonsModalExplanation, recommendationReasonsModalPrivacyPolicyLinkHref: recommendationReasonsModalPrivacyPolicyLinkHref, recommendationReasonsModalPrivacyPolicyLinkText: recommendationReasonsModalPrivacyPolicyLinkText, recommendationReasonsModalTitle: recommendationReasonsModalTitle, adControlsMenuLabel: adControlsMenuLabel, adControlsMenuNotInterested: adControlsMenuNotInterested, adControlsMenuWhyAmISeeingThis: adControlsMenuWhyAmISeeingThis })=>{
    const appProvisioning = (0, $dfimj.useAppProvisioning)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    // TBLZ-494: Switcher - Updated Recommendations and Targeting
    // go/trailblazerexperiments
    const tblzSwitcherRoleBasedExperimentCohort = (0, $1OExy.getExperimentCohort)(context);
    if (context.locale?.startsWith('en') && tblzSwitcherRoleBasedExperimentCohort !== 'not-enrolled' && apps.length > 0) fireViewedUIEvent({
        // Using @ts-ignore here to avoid the strict typing in `surface-analytics`.
        // `surface-analytics` doesn't have track events, so using a UI event to send exposure event.
        // @ts-ignore
        actionSubject: 'feature',
        // @ts-ignore
        action: 'exposed',
        // @ts-ignore
        actionSubjectId: (0, $1OExy.TBLZ_SWITCHER_ROLE_BASED_EXPERIMENT_NAME)
    }, {
        source: 'atlassianSwitcherDiscoverProductsSection',
        recommendedProductIds: apps.map((app)=>app.productId)
    }, {
        flagKey: (0, $1OExy.TBLZ_SWITCHER_ROLE_BASED_EXPERIMENT_NAME),
        cohort: tblzSwitcherRoleBasedExperimentCohort
    });
    if (tblzSwitcherRoleBasedExperimentCohort === 'experiment' && apps.length > (0, $1OExy.NUMBER_OF_RECOMMENDED_APPS)) apps.splice((0, $1OExy.NUMBER_OF_RECOMMENDED_APPS));
    // TBLZ-494
    // stores the list of dismissed apps
    const [dismissedApps, setDismissedApps] = (0, $eUqFw.useState)([]);
    // stores the order/arrangement of all apps
    const [_, setStateRegister] = (0, $eUqFw.useState)([
        apps
    ]);
    const removeFlag = (id)=>{
        setDismissedApps((current)=>current.filter((flag)=>flag.productId !== id));
    };
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = actionBus?.on('DISMISS_APP', ({ productId: productId })=>{
            let app = apps.find((searchApp)=>searchApp.productId === productId);
            if (app) {
                setDismissedApps([
                    app,
                    ...dismissedApps
                ]);
                setStateRegister((listOfPrevStates)=>{
                    return [
                        ...listOfPrevStates,
                        apps
                    ];
                });
            }
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        apps,
        actionBus,
        dismissedApps
    ]);
    const dispatchSurfaceViewedEvent = (0, $eUqFw.useCallback)(()=>{
        actionBus?.dispatch('USER_VIEW_DISCOVERY_SURFACE', {
            action: {
                action: 'viewed',
                actionSubject: 'section',
                actionSubjectId: 'atlassianSwitcherDiscoverProducts'
            },
            source: 'atlassianSwitcher'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        dispatchSurfaceViewedEvent();
    }, [
        dispatchSurfaceViewedEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (apps.length === 0) actionBus?.dispatch('USE_EMPTY_APPS_TITLE');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        apps.length
    ]);
    const appRecommendationMessages = {
        recommendationReasonsModalAcceptButton: recommendationReasonsModalAcceptButton,
        recommendationReasonsModalExplanation: recommendationReasonsModalExplanation,
        recommendationReasonsModalPrivacyPolicyLinkHref: recommendationReasonsModalPrivacyPolicyLinkHref,
        recommendationReasonsModalPrivacyPolicyLinkText: recommendationReasonsModalPrivacyPolicyLinkText,
        recommendationReasonsModalTitle: recommendationReasonsModalTitle
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $f6c4317e49be5811$var$ListResetStyles,
        "data-testid": 'discovery-sdk-component--app-recommendations-list'
    }, apps.map((app, index)=>/*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f6c4317e49be5811$var$containerStyles,
            key: index
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dHBPr.AppRecommendation), {
            ...app,
            ...appRecommendationMessages,
            actionBus: actionBus,
            context: context,
            mutate: mutate,
            journey: app.journey,
            appProvisioning: appProvisioning,
            key: (app.productId, index),
            adControlsMenuLabel: adControlsMenuLabel,
            adControlsMenuNotInterested: adControlsMenuNotInterested,
            adControlsMenuWhyAmISeeingThis: adControlsMenuWhyAmISeeingThis
        }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, $byn9U.jsx)($f6c4317e49be5811$var$UndoDismissFlag, {
        title: flagNotInterestedTitle,
        description: flagNotInterestedSubtitle,
        flags: dismissedApps.map((app)=>({
                ...app,
                ...appRecommendationMessages
            })),
        removeFlag: removeFlag,
        closeDismissedFlag: (productId)=>{
            actionBus?.dispatch('CLOSE_APP_DISMISSED_FLAG', {
                productId: productId,
                action: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'adControlsFlagClose'
                },
                source: 'atlassianSwitcherDiscoverProductsSection'
            });
        }
    })));
};
$f6c4317e49be5811$export$5d3f41a8dd5f8ce2.propTypes = {
    apps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        productId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        journey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            'get-started',
            'decide',
            'discover'
        ]).isRequired,
        reasons: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired).isRequired
    }).isRequired).isRequired,
    recommendationReasonsModalExplanation: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    recommendationReasonsModalPrivacyPolicyLinkText: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    recommendationReasonsModalPrivacyPolicyLinkHref: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    recommendationReasonsModalAcceptButton: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    adControlsMenuLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    adControlsMenuNotInterested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    adControlsMenuWhyAmISeeingThis: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    flagNotInterestedTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    flagNotInterestedSubtitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
};

});
parcelRegister("dfimj", function(module, exports) {

$parcel$export(module.exports, "useAppProvisioning", () => $aba9a12b18c26017$export$f602d60a3b7c6342);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("2Nzqx");
var $hXPzA = parcelRequire("hXPzA");

var $5PgJs = parcelRequire("5PgJs");
const $aba9a12b18c26017$export$f602d60a3b7c6342 = ()=>{
    const crossFlow = (0, $hXPzA.useCrossFlow)();
    const [appKeyMappings, setAppKeyMappings] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const client = new (0, $5PgJs.default)('app-provisioning');
        client.fetchConfigFromFlightDeck({
            name: 'discovery-sdk',
            dimensions: {
                environmentType: 'prod'
            }
        }).then((mappings)=>setAppKeyMappings(mappings)).catch(()=>{});
    }, []);
    return ({ productId: productId, ...rest })=>{
        // TODO: check if the app is 1P, 2P or 3P and create the provision context accordingly.
        // This can be done through Unified Listing API.
        // https://hello.atlassian.net/wiki/spaces/ECON/pages/2303960596/Project+Plan+Unified+Listing+API
        // At the moment, we only support provisioning 1P apps.
        if (!crossFlow.isEnabled || !appKeyMappings || !appKeyMappings.products[productId]) return Promise.resolve({
            success: false
        });
        const { crossFlowReferenceId: crossFlowReferenceId } = appKeyMappings?.products[productId];
        return crossFlow.api.open({
            targetProduct: crossFlowReferenceId,
            ...rest
        });
    };
};
function $aba9a12b18c26017$export$c62db4257a7cd8fd(WrappedComponent) {
    const ComponentWithAppProvisioning = (props)=>{
        const appProvisioning = $aba9a12b18c26017$export$f602d60a3b7c6342();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            appProvisioning: appProvisioning
        });
    };
    ComponentWithAppProvisioning.displayName = `withAppProvisioning(${WrappedComponent.displayName || WrappedComponent.name})`;
    return ComponentWithAppProvisioning;
}

});
parcelRegister("2Nzqx", function(module, exports) {

$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("hXPzA")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("hXPzA")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("hXPzA")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("hXPzA")).Reasons);
$parcel$export(module.exports, "Targets", () => (parcelRequire("8a0ZO")).Targets);

var $hXPzA = parcelRequire("hXPzA");

var $8a0ZO = parcelRequire("8a0ZO");

});


parcelRegister("dHBPr", function(module, exports) {

$parcel$export(module.exports, "AppRecommendation", () => $a88567afc7fd02ba$export$e1f5964c465868f);
/** @jsxRuntime classic */ 
var $eUqFw = parcelRequire("eUqFw");

var $l3nfS = parcelRequire("l3nfS");

var $jG1wZ = parcelRequire("jG1wZ");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $exycG = parcelRequire("exycG");

var $hWloH = parcelRequire("hWloH");

var $1OExy = parcelRequire("1OExy");

var $9Nrw1 = parcelRequire("9Nrw1");

var $hzCFt = parcelRequire("hzCFt");

const $a88567afc7fd02ba$var$AppRecommendationMenu = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("8hsKh")));
const $a88567afc7fd02ba$var$recommendationStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    width: '100%',
    justifyItems: 'stretch',
    justifyContent: 'flex-end',
    gap: 'space.025',
    height: '48px',
    alignItems: 'center'
});
const $a88567afc7fd02ba$var$commonButtonStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius',
    border: 'none',
    display: 'flex',
    backgroundColor: 'color.background.neutral.subtle',
    minWidth: '0',
    height: "var(--ds-space-600, 48px)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a88567afc7fd02ba$var$recommendationButtonStyles = (0, $1ZAYh.xcss)({
    textAlign: 'left',
    flexGrow: 1,
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    lineHeight: '18px',
    alignItems: 'stretch',
    color: 'color.text'
});
const $a88567afc7fd02ba$var$menuTriggerButtonStyles = (0, $1ZAYh.xcss)({
    width: "var(--ds-space-600, 48px)",
    padding: 'space.0',
    alignItems: 'center',
    justifyContent: 'center'
});
const $a88567afc7fd02ba$var$recommendationBodyIconStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100',
    display: 'flex',
    alignItems: 'center'
});
const $a88567afc7fd02ba$var$recommendationBodyContentStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    fontWeight: 400,
    display: 'flex',
    flexDirection: 'column'
});
const $a88567afc7fd02ba$var$titleStyles = (0, $1ZAYh.xcss)({
    fontSize: "var(--ds-font-body, 14px)",
    fontWeight: 400,
    marginTop: 'space.025',
    minWidth: '0',
    lineHeight: '16px'
});
const $a88567afc7fd02ba$var$tagLineStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'color.text.subtlest',
    fontSize: '11px',
    lineHeight: '16px'
});
const $a88567afc7fd02ba$var$tblzSwitcherTagLineStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    fontSize: '12px'
});
const $a88567afc7fd02ba$export$e1f5964c465868f = ({ actionBus: actionBus, name: name, description: description, journey: journey = (0, $exycG.Journeys).DECIDE, productId: productId, logo: logo, appProvisioning: appProvisioning, mutate: mutate, reasons: reasons, context: context, adControlsMenuLabel: adControlsMenuLabel, adControlsMenuNotInterested: adControlsMenuNotInterested, adControlsMenuWhyAmISeeingThis: adControlsMenuWhyAmISeeingThis, recommendationReasonsModalTitle: recommendationReasonsModalTitle, recommendationReasonsModalExplanation: recommendationReasonsModalExplanation, recommendationReasonsModalPrivacyPolicyLinkText: recommendationReasonsModalPrivacyPolicyLinkText, recommendationReasonsModalPrivacyPolicyLinkHref: recommendationReasonsModalPrivacyPolicyLinkHref, recommendationReasonsModalAcceptButton: recommendationReasonsModalAcceptButton })=>{
    const tblzSwitcherRoleBasedExperimentCohort = (0, $1OExy.getExperimentCohort)(context);
    const handleAppProvisioning = (0, $eUqFw.useCallback)(async (journeyOverride)=>{
        try {
            const completionStatus = await appProvisioning({
                sourceComponent: 'atlassian-switcher',
                sourceContext: 'AppRecommendation',
                productId: productId,
                journey: journeyOverride ?? journey,
                extraAnalyticsAttributes: {
                    tblzSwitcherRoleBasedExperimentCohort: tblzSwitcherRoleBasedExperimentCohort
                },
                extensions: context.sessionId ? (0, $l3nfS.createRecommendationContextExtensions)({
                    entityId: productId,
                    recommendationSessionId: context.sessionId
                }) : undefined
            });
            if (completionStatus?.success === true) mutate((currentConfiguration)=>{
                return {
                    ...currentConfiguration,
                    apps: currentConfiguration.apps?.filter((app)=>app.productId !== productId)
                };
            });
        } catch (error) {}
    }, [
        appProvisioning,
        productId,
        journey,
        context.sessionId,
        tblzSwitcherRoleBasedExperimentCohort,
        mutate
    ]);
    const MenuTrigger = ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
            "aria-label": (0, $hWloH.formatStringMessage)(adControlsMenuLabel, {
                productName: name
            }),
            ...triggerProps,
            xcss: [
                $a88567afc7fd02ba$var$commonButtonStyles,
                $a88567afc7fd02ba$var$menuTriggerButtonStyles
            ],
            ref: triggerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
            primaryColor: "var(--ds-icon, #44546F)",
            label: "",
            size: "small"
        }));
    const messages = {
        recommendationReasonsModalTitle: recommendationReasonsModalTitle,
        recommendationReasonsModalExplanation: recommendationReasonsModalExplanation,
        recommendationReasonsModalPrivacyPolicyLinkText: recommendationReasonsModalPrivacyPolicyLinkText,
        recommendationReasonsModalPrivacyPolicyLinkHref: recommendationReasonsModalPrivacyPolicyLinkHref,
        recommendationReasonsModalAcceptButton: recommendationReasonsModalAcceptButton
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a88567afc7fd02ba$var$recommendationStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: ()=>{
            const experimentValues = (0, $hzCFt.getExperimentValues)(context, productId);
            handleAppProvisioning(experimentValues?.journeyOverride);
            actionBus?.dispatch('CLICK_APP_RECOMMENDATION', {
                productId: productId,
                action: {
                    action: 'clicked',
                    actionSubject: 'listItem',
                    actionSubjectId: 'product'
                },
                source: 'atlassianSwitcherDiscoverProductsSection',
                skipBenefitsPageExperimentCohort: experimentValues?.cohort,
                tblzSwitcherRoleBasedExperimentCohort: tblzSwitcherRoleBasedExperimentCohort
            });
        },
        xcss: [
            $a88567afc7fd02ba$var$commonButtonStyles,
            $a88567afc7fd02ba$var$recommendationButtonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $a88567afc7fd02ba$var$recommendationBodyIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Nrw1.AppLogo), {
        src: logo,
        tblzSwitcherRoleBasedExperimentCohort: tblzSwitcherRoleBasedExperimentCohort
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a88567afc7fd02ba$var$recommendationBodyContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $a88567afc7fd02ba$var$titleStyles
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $a88567afc7fd02ba$var$tagLineStyles,
            tblzSwitcherRoleBasedExperimentCohort === 'experiment' && $a88567afc7fd02ba$var$tblzSwitcherTagLineStyles
        ]
    }, (0, $1OExy.getRecommendationDescription)(description, productId, tblzSwitcherRoleBasedExperimentCohort)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $a88567afc7fd02ba$var$menuTriggerButtonStyles
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a88567afc7fd02ba$var$AppRecommendationMenu, {
        ...messages,
        actionBus: actionBus,
        context: context,
        mutate: mutate,
        name: name,
        reasons: reasons,
        menu: [
            {
                title: adControlsMenuNotInterested,
                action: {
                    actionType: 'DISMISS'
                }
            },
            {
                title: adControlsMenuWhyAmISeeingThis,
                action: {
                    actionType: 'REASON'
                }
            }
        ],
        productId: productId,
        menuTrigger: MenuTrigger
    })));
};

});
parcelRegister("exycG", function(module, exports) {

$parcel$export(module.exports, "Journeys", () => $6d5a06ecc7f27bac$export$3411873bfd520bb6);
const $6d5a06ecc7f27bac$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $6d5a06ecc7f27bac$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    TEAM_CENTRAL: 'townsquare',
    ANALYTICS: 'atlassian-analytics-free'
};

});

parcelRegister("hWloH", function(module, exports) {

$parcel$export(module.exports, "formatStringMessage", () => $5c91da78b3714347$export$3a03ab0b93acd93b);
$parcel$export(module.exports, "formatReactMessage", () => $5c91da78b3714347$export$c90a719af0e2582c);

var $eUqFw = parcelRequire("eUqFw");
const $5c91da78b3714347$export$3a03ab0b93acd93b = (message, variables)=>$5c91da78b3714347$export$25868d1e8e76735f(message, variables).filter($5c91da78b3714347$var$assertString).join('');
const $5c91da78b3714347$export$c90a719af0e2582c = (message, variables)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $5c91da78b3714347$export$25868d1e8e76735f(message, variables).map((e, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: i
        }, e)));
const $5c91da78b3714347$export$25868d1e8e76735f = (message, variables)=>message.split(/({[A-z]*})/g).map($5c91da78b3714347$var$getVariableValues(variables)).reduce($5c91da78b3714347$var$concatStringsReducer, []);
const $5c91da78b3714347$var$getVariableValues = (variables)=>(input)=>{
        const variableName = input.slice(1, -1);
        const variableValue = variables?.[variableName];
        return variableValue === undefined ? input : variableValue;
    };
const $5c91da78b3714347$var$concatStringsReducer = (accumulator, current)=>{
    const [previous, ...rest] = [
        ...accumulator
    ].reverse();
    if (typeof current === 'string' && typeof previous === 'string') return [
        `${previous}${current}`,
        ...rest
    ].reverse();
    return [
        ...accumulator,
        current
    ];
};
const $5c91da78b3714347$var$assertString = (s)=>typeof s === 'string';

});

parcelRegister("1OExy", function(module, exports) {

$parcel$export(module.exports, "NUMBER_OF_RECOMMENDED_APPS", () => $603b8ef6d821d094$export$1c7b69e8643338f3);
$parcel$export(module.exports, "TBLZ_SWITCHER_ROLE_BASED_EXPERIMENT_NAME", () => $603b8ef6d821d094$export$76b3d75ac4131b96);
$parcel$export(module.exports, "getExperimentCohort", () => $603b8ef6d821d094$export$d297da143e393306);
$parcel$export(module.exports, "getRecommendationDescription", () => $603b8ef6d821d094$export$550342c8fbb9c1b4);

var $8tM2T = parcelRequire("8tM2T");

var $8fAH0 = parcelRequire("8fAH0");
const $603b8ef6d821d094$export$3ad6340c73de7b5 = 'Track your issues and projects';
const $603b8ef6d821d094$export$d074821cee0ead49 = 'Automatically turn tickets into issues';
const $603b8ef6d821d094$export$d84e4dec8b0c0b33 = 'Build the right features, the right way';
const $603b8ef6d821d094$export$ed88391c52d60840 = 'Visualize, browse, and connect teams';
const $603b8ef6d821d094$export$50531f89dd4f17a4 = 'Stay aware and in control of incidents';
const $603b8ef6d821d094$export$b7cc65539a4f75b4 = 'Create one place for all your docs';
const $603b8ef6d821d094$export$1c7b69e8643338f3 = 2;
const $603b8ef6d821d094$export$76b3d75ac4131b96 = 'switcher_personalized_and_engaging_experience';
const $603b8ef6d821d094$export$d297da143e393306 = (context)=>{
    const { product: product } = context;
    const isConfluence = product === 'confluence';
    const isJira = product === 'jira';
    if (!isConfluence && !isJira) return 'not-enrolled';
    const cohort = (0, $8tM2T.default).getExperimentValue($603b8ef6d821d094$export$76b3d75ac4131b96, 'cohort', 'not-enrolled');
    return cohort;
};
const $603b8ef6d821d094$export$550342c8fbb9c1b4 = (description, productId, tblzSwitcherRoleBasedExperimentCohort)=>{
    if (tblzSwitcherRoleBasedExperimentCohort !== 'experiment') return description;
    switch(productId){
        case (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-servicedesk.ondemand']:
            return $603b8ef6d821d094$export$d074821cee0ead49;
        case (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products['confluence.ondemand']:
            return $603b8ef6d821d094$export$b7cc65539a4f75b4;
        case (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-software.ondemand']:
            return $603b8ef6d821d094$export$3ad6340c73de7b5;
        case (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-product-discovery']:
            return $603b8ef6d821d094$export$d84e4dec8b0c0b33;
        case (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products.townsquare:
            return $603b8ef6d821d094$export$ed88391c52d60840;
        case (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products.opsgenie:
            return $603b8ef6d821d094$export$50531f89dd4f17a4;
        default:
            return description;
    }
};

});

parcelRegister("9Nrw1", function(module, exports) {

$parcel$export(module.exports, "AppLogo", () => $843146fe27d35b5c$export$113a612889e1565d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxfrag */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1Qivz = parcelRequire("1Qivz");

var $PdmhA = parcelRequire("PdmhA");
function $843146fe27d35b5c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $843146fe27d35b5c$var$imageStyles = {
    name: "32zy3t",
    styles: "&&{max-height:24px;max-width:26px;flex-shrink:0;line-height:1;margin:auto;}"
};
const $843146fe27d35b5c$var$appLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: '32px',
    width: '32px',
    boxSizing: 'border-box',
    backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N0)})`,
    borderRadius: '8px',
    display: 'flex',
    overflow: 'hidden',
    boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px ${(0, $PdmhA.N50A)}, 0 0 1px 1px ${(0, $PdmhA.N40A)}`})`
});
const $843146fe27d35b5c$var$tblzSwitcherExperimentIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    border: `1px solid ${"var(--ds-shadow-overflow-spread, #091E4224)"}`,
    boxShadow: 'none',
    backgroundColor: 'transparent'
});
const $843146fe27d35b5c$export$113a612889e1565d = ({ src: src, tblzSwitcherRoleBasedExperimentCohort: tblzSwitcherRoleBasedExperimentCohort })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $843146fe27d35b5c$var$appLogoStyles,
            tblzSwitcherRoleBasedExperimentCohort === 'experiment' ? $843146fe27d35b5c$var$tblzSwitcherExperimentIconStyles : null
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        css: $843146fe27d35b5c$var$imageStyles,
        src: src
    }));
$843146fe27d35b5c$export$113a612889e1565d.propTypes = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
};

});

parcelRegister("hzCFt", function(module, exports) {

$parcel$export(module.exports, "getExperimentValues", () => $1a189c8d48782daf$export$f90390499ffa03d0);

var $8tM2T = parcelRequire("8tM2T");

var $exycG = parcelRequire("exycG");

var $8fAH0 = parcelRequire("8fAH0");
const $1a189c8d48782daf$export$f90390499ffa03d0 = (context, targetProduct)=>{
    const { isSiteAdmin: isSiteAdmin, product: product } = context;
    if (!isSiteAdmin || ![
        'jira',
        'confluence'
    ].includes(product || '') || targetProduct !== (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-servicedesk.ondemand']) return;
    const experimentName = 'skip_benefits_page_experiment';
    try {
        const cohort = (0, $8tM2T.default).getExperimentValue(experimentName, 'cohort', 'not-enrolled');
        if (cohort === 'variation') return {
            cohort: cohort,
            journeyOverride: (0, $exycG.Journeys).GET_STARTED
        };
        else if (cohort === 'control') return {
            cohort: cohort,
            journeyOverride: (0, $exycG.Journeys).DECIDE
        };
        return {
            cohort: 'not-enrolled'
        };
    } catch (error) {
        Promise.reject(error);
    }
};

});

parcelRegister("8hsKh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('72tna');
        const value = parcelRequire('a3SUd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("72tna").then(()=>parcelRequire('a3SUd'));
}

});


parcelRegister("aSJXn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7CRyb');
        const value = parcelRequire('iObOM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7CRyb").then(()=>parcelRequire('iObOM'));
}

});


parcelRegister("egmas", function(module, exports) {

$parcel$export(module.exports, "AppRecommendationsWithTitle", () => $5ab26204ab6bcdd4$export$49ba1946e5bb5643);

var $eUqFw = parcelRequire("eUqFw");

var $agylp = parcelRequire("agylp");

var $6c6gw = parcelRequire("6c6gw");

var $2v0PV = parcelRequire("2v0PV");
const $5ab26204ab6bcdd4$export$49ba1946e5bb5643 = ({ mutate: mutate, title: title, noAppsTitle: noAppsTitle, headingLevel: headingLevel, context: context, actionBus: actionBus, ...rest })=>{
    const AppRecommendationSectionHeaderMutate = (0, $agylp.deriveMutateOfChild)({
        mutate: mutate,
        mutationArgs: {
            noAppsTitle: noAppsTitle,
            title: title,
            headingLevel: headingLevel
        }
    });
    const AppRecommendationsMutate = (0, $agylp.deriveMutateOfChild)({
        mutate: mutate,
        mutationArgs: rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6c6gw.AppRecommendationsSectionHeader), {
        title: title,
        noAppsTitle: noAppsTitle,
        mutate: AppRecommendationSectionHeaderMutate,
        context: context,
        headingLevel: headingLevel,
        actionBus: actionBus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2v0PV.AppRecommendationsList), {
        ...rest,
        actionBus: actionBus,
        context: context,
        mutate: AppRecommendationsMutate
    }));
};

});
parcelRegister("agylp", function(module, exports) {

$parcel$export(module.exports, "deriveMutateOfChild", () => $9c79d5581a8c356c$export$59c4fd8eb3e54fae);
const $9c79d5581a8c356c$export$59c4fd8eb3e54fae = ({ mutate: mutate, mutationArgs: mutationArgs })=>(mutation)=>{
        if (mutation === null) return mutation;
        mutate((current)=>{
            return {
                ...current,
                ...typeof mutation === 'function' ? mutation(mutationArgs) : mutationArgs
            };
        });
    };

});



parcelRegister("80nQh", function(module, exports) {

$parcel$export(module.exports, "useWorkspaceContext", () => $5089ebfd51edd178$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5089ebfd51edd178$export$74ebc9a49f60d38a);

var $eUqFw = parcelRequire("eUqFw");

var $hqVLk = parcelRequire("hqVLk");

var $8PehF = parcelRequire("8PehF");

var $gd0Sp = parcelRequire("gd0Sp");

var $cV47S = parcelRequire("cV47S");

var $aeCba = parcelRequire("aeCba");
const $5089ebfd51edd178$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5089ebfd51edd178$export$122fccf0bbbc9acc = 30000;
const $5089ebfd51edd178$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $hqVLk.useResource)((0, $cV47S.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5089ebfd51edd178$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $eUqFw.useRef)(callback);
    // Remember the latest callback.
    (0, $eUqFw.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $eUqFw.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5089ebfd51edd178$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5089ebfd51edd178$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)((0, $8PehF.isCMDBEnabledInEnvironment)() && (0, $aeCba.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $eUqFw.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $eUqFw.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $eUqFw.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $eUqFw.useEffect)(()=>{
        if (!workspaceId && (0, $aeCba.isLicensedPremiumUser)(tenantContext) && (0, $8PehF.isCMDBEnabledInEnvironment)()) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5089ebfd51edd178$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5089ebfd51edd178$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $eUqFw.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $aeCba.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});



parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

const $ecbb977aece36a74$export$381faf5821ba1c1f = 'app-switcher-spotlight';



//# sourceMappingURL=async-atlassian-navigation-app-switcher.7c98753a.js.map
